/* eslint-disable */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// tslint:disable max-line-length
// tslint:disable no-namespace
// tslint:disable max-classes-per-file
// tslint:disable trailing-comma
// tslint:disable no-string-literal
// tslint:disable no-shadowed-variable array-type
import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
import * as ApolloReactHoc from '@apollo/client/react/hoc';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: Date;
  /** The built-in `Decimal` scalar type. */
  Decimal: number;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** The multiplier path scalar represents a valid GraphQL multiplier path string. */
  MultiplierPath: any;
  Uuid: any;
};

export type AcceptTermsPayload = {
  __typename?: 'AcceptTermsPayload';
  /** @deprecated Refer to errors response object instead */
  Code?: Maybe<Scalars['String']>;
  /** @deprecated Refer to errors response object instead */
  Message?: Maybe<Scalars['String']>;
  /** @deprecated Refer to errors response object instead */
  Success: Scalars['Boolean'];
  UserSession: UserSession;
};

export type Account = {
  __typename?: 'Account';
  /**
   * Account limits for given date range. If none provided will be as of now. Includes from
   * and to. If
   */
  AccountLimits?: Maybe<Array<Maybe<EffectiveAccountLimit>>>;
  AllowAdhocPaymentDisbursements?: Maybe<Scalars['Boolean']>;
  AllowOnlineDisbursements?: Maybe<Scalars['Boolean']>;
  AnnualInstalment?: Maybe<Scalars['Decimal']>;
  ApplicationAmount?: Maybe<Scalars['Decimal']>;
  /** application number related to the account. */
  ApplicationNumber?: Maybe<Scalars['String']>;
  ApprovedAmount?: Maybe<Scalars['Decimal']>;
  /** current arrears balance. */
  ArrearsBalance?: Maybe<Scalars['Decimal']>;
  BankAccounts?: Maybe<Array<Maybe<BankAccount>>>;
  /** BankIdentifierText code for the account. */
  BankIdentifierText?: Maybe<Scalars['String']>;
  /** Biller Code for the given account set at product level. */
  BillerCode?: Maybe<Scalars['String']>;
  /** Bpay Number for the account. */
  BpayNumber?: Maybe<Scalars['String']>;
  CardAccount?: Maybe<Scalars['Boolean']>;
  CardAvailable?: Maybe<Scalars['Boolean']>;
  CardBalance?: Maybe<CardBalance>;
  /** identifier for the account. */
  CardIdentifier?: Maybe<Scalars['String']>;
  CardLimit?: Maybe<Scalars['Decimal']>;
  CardProduct?: Maybe<Scalars['Boolean']>;
  /** current amount reserved for a linked card. */
  CardReservation?: Maybe<Scalars['Decimal']>;
  Cards?: Maybe<Array<Maybe<Card>>>;
  /** current principal balance. */
  CurrentBalance?: Maybe<Scalars['Decimal']>;
  /** currently remaining daily limit. */
  CurrentDailyPayAnyoneLimit?: Maybe<Scalars['Decimal']>;
  /** currently remaining daily limit. */
  CurrentDailyRedrawLimit?: Maybe<Scalars['Decimal']>;
  /** current instalament type for the account. */
  CurrentInstalmentSource?: Maybe<Scalars['String']>;
  /** Active users authority on this account */
  CurrentUserAccountAuthority?: Maybe<AccountAuthority>;
  /** daily limit. */
  DailyPayAnyoneLimit?: Maybe<Scalars['Decimal']>;
  /** daily limit. */
  DailyRedrawLimit?: Maybe<Scalars['Decimal']>;
  /**
   * current number of days in arrears.
   * @deprecated No no longer populated
   */
  DaysInArrears?: Maybe<Scalars['Long']>;
  /** description of the account. */
  Description?: Maybe<Scalars['String']>;
  /** display order for the account. */
  DisplayOrder?: Maybe<Scalars['Int']>;
  /** if outstanding authorisations are displayed on internet banking. */
  DisplayOutstandingAuthorisations?: Maybe<Scalars['Boolean']>;
  /** documentation level for the account. */
  DocumentationLevel?: Maybe<Scalars['String']>;
  Documents?: Maybe<Array<Maybe<AccountDocumentLink>>>;
  EnforceOffsetBalanceLimit?: Maybe<Scalars['Boolean']>;
  FixedInterestPeriodExpiryDate?: Maybe<Scalars['DateTime']>;
  FortnightlyInstalment?: Maybe<Scalars['Decimal']>;
  FortnightlyTrue?: Maybe<Scalars['Decimal']>;
  FortnightlyTwo?: Maybe<Scalars['Decimal']>;
  /**
   * Obslete Moving to FurtherAdvances connection
   * @deprecated Moving to FurtherAdvances connection
   */
  FurtherAdvanceApplicationAmount?: Maybe<Scalars['Decimal']>;
  /**
   * Obslete Moving to FurtherAdvances connection
   * @deprecated Moving to FurtherAdvances connection
   */
  FurtherAdvanceApprovedAmount?: Maybe<Scalars['Decimal']>;
  /**
   * Obslete Moving to FurtherAdvances connection
   * @deprecated Moving to FurtherAdvances connection
   */
  FurtherAdvanceSettlementAmount?: Maybe<Scalars['Decimal']>;
  HasOffsetLinked?: Maybe<Scalars['Boolean']>;
  /** regular payment flag. */
  HasRegularPayment?: Maybe<Scalars['Boolean']>;
  /** The database identifier of the record. */
  Id: Scalars['Uuid'];
  IncomingFundsTransfers?: Maybe<Array<Maybe<FundsTransfer>>>;
  InstalmentCalculationType?: Maybe<Scalars['String']>;
  InstalmentFrequencyPeriod?: Maybe<Scalars['String']>;
  /** current amount of instalments reserved. */
  InstalmentReservation?: Maybe<Scalars['Decimal']>;
  /** GUID identifier of the parent instrument. */
  InstrumentId?: Maybe<Scalars['Uuid']>;
  InterestOnlyExpiryDate?: Maybe<Scalars['DateTime']>;
  InterestType?: Maybe<Scalars['String']>;
  IsRedrawExcluded?: Maybe<Scalars['Boolean']>;
  LastInterestChargeDate?: Maybe<Scalars['DateTime']>;
  /** account legacy number. */
  LegacyNumber?: Maybe<Scalars['String']>;
  /** legacy product code for the account. */
  LegacyProductCode?: Maybe<Scalars['String']>;
  LinkedAccounts?: Maybe<Array<Maybe<LinkedAccount>>>;
  /** Gets and set the Maturity Date for an account */
  MaturityDate?: Maybe<Scalars['DateTime']>;
  MonthlyInstalment?: Maybe<Scalars['Decimal']>;
  NextInstalmentDue?: Maybe<Scalars['DateTime']>;
  NextRepaymentDate?: Maybe<Scalars['DateTime']>;
  Notifications?: Maybe<Array<Maybe<InterestConversionNotification>>>;
  /** account number. */
  Number?: Maybe<Scalars['String']>;
  /** current number of reserved instalments. */
  NumberOfReservedInstalments?: Maybe<Scalars['Decimal']>;
  OffsetAccount?: Maybe<Scalars['Boolean']>;
  OffsetBalanceLimit?: Maybe<Scalars['Decimal']>;
  /** current other arrears balance. */
  OtherArrears?: Maybe<Scalars['Decimal']>;
  PendingAccountFundsTransfers?: Maybe<Array<Maybe<FundsTransfer>>>;
  ProcessedAccountFundsTransfers?: Maybe<Array<Maybe<FundsTransfer>>>;
  ProductAvailableForOffset?: Maybe<Scalars['Boolean']>;
  /** description of the product type. */
  ProductType?: Maybe<Scalars['String']>;
  /** GUID identifier of a product type. */
  ProductTypeId?: Maybe<Scalars['Uuid']>;
  ProfileAccountCategorisations?: Maybe<Array<Maybe<AccountCategorisation>>>;
  /** Profile Specific Ordering for this account */
  ProfileOrder?: Maybe<ProfileAccountOrdering>;
  /** current account interest rate. */
  Rate?: Maybe<Scalars['Decimal']>;
  /** current redraw amount. */
  Redraw?: Maybe<Scalars['Decimal']>;
  RedrawFlag?: Maybe<Scalars['Boolean']>;
  RemainingDisbursementAmount?: Maybe<Scalars['Decimal']>;
  /** remaining term in months. */
  RemainingTermMonths?: Maybe<Scalars['Long']>;
  RepaymentAmount?: Maybe<Scalars['Decimal']>;
  RepaymentSchedule?: Maybe<Scalars['Boolean']>;
  RiskLevel?: Maybe<Scalars['String']>;
  ScheduleAnnualInstalment?: Maybe<Scalars['Decimal']>;
  ScheduleFortnightlyInstalment?: Maybe<Scalars['Decimal']>;
  ScheduleFortnightlyTrue?: Maybe<Scalars['Decimal']>;
  ScheduleFortnightlyTwo?: Maybe<Scalars['Decimal']>;
  ScheduleMonthlyInstalment?: Maybe<Scalars['Decimal']>;
  ScheduleWeeklyFour?: Maybe<Scalars['Decimal']>;
  ScheduleWeeklyInstalment?: Maybe<Scalars['Decimal']>;
  ScheduleWeeklyTrue?: Maybe<Scalars['Decimal']>;
  /** current schedule balance. */
  ScheduledBalance?: Maybe<Scalars['Decimal']>;
  /** account sequence number. */
  SequenceNumber?: Maybe<Scalars['String']>;
  /** Settlement Date for an account */
  SettlementDate?: Maybe<Scalars['DateTime']>;
  StatementFee?: Maybe<Scalars['Decimal']>;
  Statements?: Maybe<Array<Maybe<StatementDocument>>>;
  /** current account status. */
  Status?: Maybe<Scalars['String']>;
  /** if the account product is tax tracking. */
  TaxProduct?: Maybe<Scalars['Boolean']>;
  /** term in months. */
  TermInMonths?: Maybe<Scalars['Long']>;
  /** Active users authority on this account */
  TotalApprovedAmount?: Maybe<Scalars['Decimal']>;
  /** @deprecated Use TransactionsConnection */
  Transactions?: Maybe<Array<Maybe<AccountTransaction>>>;
  TransactionsConnection?: Maybe<ConnectionWithNodesOfGraphAccountTransaction>;
  Transfers?: Maybe<Array<Maybe<FundsTransfer>>>;
  /** current uncleared funds balance. */
  UnclearedFunds?: Maybe<Scalars['Decimal']>;
  WeeklyFour?: Maybe<Scalars['Decimal']>;
  WeeklyInstalment?: Maybe<Scalars['Decimal']>;
  WeeklyTrue?: Maybe<Scalars['Decimal']>;
};


export type AccountDocumentsArgs = {
  where?: InputMaybe<DocumentLinkFilterInput>;
};


export type AccountProcessedAccountFundsTransfersArgs = {
  filter?: InputMaybe<LookBackDaysInput>;
};


export type AccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type AccountTransactionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/** Current User Authority on an Account */
export type AccountAuthority = {
  __typename?: 'AccountAuthority';
  Account?: Maybe<Account>;
  /** Whether the user can use the account to BPay. */
  BPay: Scalars['Boolean'];
  /** Whether the profile can setup direct debit transfers for the account. */
  DirectDebit: Scalars['Boolean'];
  Id: Scalars['Uuid'];
  /** Whether the profile can setup inter-account transfers for the account. */
  InterAccount: Scalars['Boolean'];
  /** Whether the user can use the account for inter-account transfers. */
  Operate: Scalars['Boolean'];
  /** Whether the user can use the account to pay any third-party. */
  PayAnyone: Scalars['Boolean'];
  /** Whether the user can use the account for redraws to nominated accounts. */
  Redraw: Scalars['Boolean'];
  /** Whether the user can see the account. */
  View: Scalars['Boolean'];
};

export type AccountCategorisation = {
  __typename?: 'AccountCategorisation';
  Account?: Maybe<Account>;
  AccountOrder?: Maybe<Scalars['Int']>;
  Category?: Maybe<ProfileCustomCategory>;
  Id: Scalars['Uuid'];
};

/** Request to assign Account to a list of categories */
export type AccountCategorisationRequestInput = {
  /** Account to Apply Categorisation */
  AccountId: Scalars['Uuid'];
  /** Categorisations to Apply */
  Categories?: InputMaybe<Array<InputMaybe<ProfileAccountCategoryInput>>>;
  /** Optional, if true, Remove the account from all other categories */
  RemoveFromOtherCategories?: InputMaybe<Scalars['Boolean']>;
};

export type AccountCategorisationToApplyInput = {
  /** Category to apply. Null applies the default category with empty string '' as the name */
  AccountCategory?: InputMaybe<AccountCategoryInput>;
  /** Account to Apply Ordering */
  AccountId: Scalars['Uuid'];
  /** User defined order for the account within the category */
  AccountOrder?: InputMaybe<Scalars['Int']>;
  /** Optionally remove all other categorisations from the account */
  RemoveOtherCategories?: InputMaybe<Scalars['Boolean']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AccountCategorisationToRemoveInput = {
  /** Id of the category to remove */
  AccountCategoryId?: InputMaybe<Scalars['Uuid']>;
  /** Account to Apply Ordering */
  AccountId: Scalars['Uuid'];
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Profile Specific Category, Either Id or Name must be supplied */
export type AccountCategoryInput = {
  /** Id of an existing category */
  CategoryId?: InputMaybe<Scalars['Uuid']>;
  /** Order of the category if it is a new category */
  CategoryOrder?: InputMaybe<Scalars['Int']>;
  /** Name of an existing category or the new category if it doesn't exist */
  Name?: InputMaybe<Scalars['String']>;
};

export type AccountDocumentLink = {
  __typename?: 'AccountDocumentLink';
  /** the document. */
  Document?: Maybe<File>;
  Id: Scalars['Uuid'];
  /** Has this document link been removed */
  IsDeleted: Scalars['Boolean'];
};

export type AccountLimit = {
  __typename?: 'AccountLimit';
  DailyBPayLimit?: Maybe<Money>;
  DailyPayAnyoneLimit?: Maybe<Money>;
  DailyRedrawLimit?: Maybe<Money>;
  DefaultBPayLimit?: Maybe<Money>;
  DefaultPayAnyoneLimit?: Maybe<Money>;
  DefaultRedrawLimit?: Maybe<Money>;
  LimitEffectiveTo?: Maybe<Scalars['DateTime']>;
  RemainingDailyBPayLimit?: Maybe<Money>;
  RemainingDailyPayAnyoneLimit?: Maybe<Money>;
  RemainingDailyRedrawLimit?: Maybe<Money>;
};

/** Represents a transaction against an account. */
export type AccountTransaction = {
  __typename?: 'AccountTransaction';
  Account?: Maybe<Account>;
  /** transaction that a manual interest adjustment is for. */
  AdjustsInterestForTransactionId?: Maybe<Scalars['Uuid']>;
  /** whether this transaction appears on statements. */
  AppearsOnStatement?: Maybe<Scalars['Boolean']>;
  /** transaction that a backout is for. */
  BackOutTransactionId?: Maybe<Scalars['Uuid']>;
  /** principal balance. */
  Balance?: Maybe<Scalars['Decimal']>;
  /** colour a transaction should be rendered in. */
  Colour?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['DateTime'];
  /** when the transaction is expected to clear. */
  DateToClear?: Maybe<Scalars['DateTime']>;
  /** decrease amount. */
  Decrease?: Maybe<Scalars['Decimal']>;
  /** transaction that a dishonour is for. */
  DishonourTransactionId?: Maybe<Scalars['Uuid']>;
  /** date the transaction is effective. */
  Effective: Scalars['DateTime'];
  /** date the transaction is effective. Alias for Effective */
  EffectiveDate: Scalars['DateTime'];
  Id: Scalars['Uuid'];
  /** increase amount. */
  Increase?: Maybe<Scalars['Decimal']>;
  /** file item Id of the invoice */
  InvoiceFileItemId?: Maybe<Scalars['Uuid']>;
  IsPending?: Maybe<Scalars['Boolean']>;
  /** transaction note. */
  Note?: Maybe<Scalars['String']>;
  /** date the transaction was processed. */
  Processed: Scalars['DateTime'];
  /** transaction that a reversal is for. */
  ReversalTransactionId?: Maybe<Scalars['Uuid']>;
  /** transaction sequence number. */
  SequenceNumber?: Maybe<Scalars['String']>;
  /** text that appears on a statement. */
  StatementText?: Maybe<Scalars['String']>;
  TransactionCategory?: Maybe<TransactionCategory>;
  /** transaction number. */
  TransactionNumber?: Maybe<Scalars['String']>;
  /** transaction type. */
  TransactionType?: Maybe<Scalars['String']>;
  /** transaction type number. */
  TransactionTypeNumber?: Maybe<Scalars['Long']>;
  Transfer?: Maybe<FundsTransfer>;
  /** CLR type of the DTO. */
  Type?: Maybe<Scalars['String']>;
  /** if the transaction is uncleared. */
  Uncleared?: Maybe<Scalars['Boolean']>;
  /** transaction that a waive is for. */
  WaiveTransactionId?: Maybe<Scalars['Uuid']>;
  /** name of the waiver transaction related to the current transaction type. */
  WaiverTransactionName?: Maybe<Scalars['String']>;
  /** whether the transaction was backed out. */
  WasBackedOut?: Maybe<Scalars['Boolean']>;
  /** whether the transaction was dishonoured. */
  WasDishonoured?: Maybe<Scalars['Boolean']>;
  /** whether the transaction was reversed. */
  WasReversed?: Maybe<Scalars['Boolean']>;
  /** whether the transaction was waived. */
  WasWaived?: Maybe<Scalars['Boolean']>;
};

export type AccountTransactionCategorisationRequestInput = {
  /** Transaction to categorise */
  accountId: Scalars['Uuid'];
  /** Transaction to categorise */
  accountTransactionId: Scalars['Uuid'];
  /** Category to apply. Null to remove category */
  categoryId?: InputMaybe<Scalars['Uuid']>;
};

/** Input for querying which accounts can be transferred to from the supplied account */
export type AccountsTransferableByAccountInput = {
  /** Id of the account */
  Id?: InputMaybe<Scalars['String']>;
  /** Number of the account */
  Number?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AcknowledgedUserNotificationInput = {
  BrandId?: InputMaybe<Scalars['Uuid']>;
  Dismissed?: InputMaybe<Scalars['Boolean']>;
  UserNotificationId: Scalars['Uuid'];
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ActivateCardInput = {
  CardId: Scalars['Uuid'];
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ActivateCardResponse = {
  __typename?: 'ActivateCardResponse';
  Code?: Maybe<Scalars['String']>;
  Data?: Maybe<Card>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** A Physical address, eg. Street Address */
export type Address = {
  __typename?: 'Address';
  /**
   * whether the address is a street address
   * or a postal box.
   */
  AddressDetailType: AddressDetailType;
  /** the address line 1 details if the address is not broken up */
  AddressLine1?: Maybe<Scalars['String']>;
  /** the address line 2 details if the address is not broken up */
  AddressLine2?: Maybe<Scalars['String']>;
  /** the address line 3 details if the address is not broken up */
  AddressLine3?: Maybe<Scalars['String']>;
  /** the address line 4 details if the address is not broken up */
  AddressLine4?: Maybe<Scalars['String']>;
  /** the building name. */
  Building?: Maybe<Scalars['String']>;
  /** the country. */
  Country?: Maybe<Country>;
  /** the floor name. */
  FloorName?: Maybe<Scalars['String']>;
  /** the floor number. */
  FloorNumber?: Maybe<Scalars['String']>;
  /** the geographic location details of an address. */
  GeographicPosition?: Maybe<GeographicLocation>;
  /** whether an address has been validated. */
  HasBeenVerified: Scalars['Boolean'];
  Id: Scalars['Uuid'];
  /** whether an address is a valid address. */
  IsValid: Scalars['Boolean'];
  /** the lot number. */
  LotNumber?: Maybe<Scalars['String']>;
  /** the details of the postal box or roadside drop. */
  PostalBoxDetails?: Maybe<Scalars['String']>;
  /** the postal area code. */
  PostalCode?: Maybe<Scalars['String']>;
  /** the property name. */
  PropertyName?: Maybe<Scalars['String']>;
  /** the geographic region (state/province etc). */
  Region?: Maybe<GeographicRegion>;
  /** the name of the street. */
  StreetName?: Maybe<Scalars['String']>;
  /**
   * the starting street number. Also used
   * as the individual street number.
   */
  StreetNumberFrom?: Maybe<Scalars['String']>;
  /**
   * the ending street number. Ignored when
   * an address is one number only.
   */
  StreetNumberTo?: Maybe<Scalars['String']>;
  /** Street Type eg. Street, Way, Boulevard */
  StreetType?: Maybe<Scalars['String']>;
  /** the suburb or town. */
  SuburbTown?: Maybe<Scalars['String']>;
  /** the unit number. */
  UnitNumber?: Maybe<Scalars['String']>;
};

/** The set of address detail types. */
export enum AddressDetailType {
  /** The address contains postal box details. */
  Postalbox = 'POSTALBOX',
  /** The address could not be broken up into the relevant details. */
  Printformat = 'PRINTFORMAT',
  /** The address is a street address. */
  Street = 'STREET'
}

/** Filter the notifications to show */
export type ApplicationNotificationsFilterInput = {
  /** Optionally filter by brand */
  BrandId?: InputMaybe<Scalars['Uuid']>;
  /** Only show matching */
  NotificationTypeCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ArchiveSecureMessageInput = {
  /** The Capital Id of the SecureMessage to archive */
  SecureMessageId: Scalars['Uuid'];
};

export type ArchiveSecureMessageResponse = {
  __typename?: 'ArchiveSecureMessageResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** List of Accounts and categories to be added */
export type AssignAccountCategoriesInput = {
  /** List of Accounts and categories to be added */
  AccountCategorisations: Array<AccountCategorisationRequestInput>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AssignAccountCategoriesResponse = {
  __typename?: 'AssignAccountCategoriesResponse';
  /** Categorisations Applied */
  AppliedCategorisation?: Maybe<Array<Maybe<AccountCategorisation>>>;
  Code?: Maybe<Scalars['String']>;
  /** Categorisations that failed */
  FailedCategorisation?: Maybe<Array<Maybe<FailedAccountCategorisationRequest>>>;
  Message?: Maybe<Scalars['String']>;
  /** Categorisations Removed via AccountCategorisationToAssignInput.RemoveFromOtherCategories */
  RemovedCategorisation?: Maybe<Array<Maybe<AccountCategorisation>>>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AuthorityOperateAccountsInput = {
  /** Specifies that the operate accounts returned must allow BPAY */
  MustAllowBPay?: InputMaybe<Scalars['Boolean']>;
  /** Specifies that the operate accounts returned must allow pay anyone */
  MustAllowPayAnyone?: InputMaybe<Scalars['Boolean']>;
  /** Specifies that the operate accounts returned must allow redraw */
  MustAllowRedraw?: InputMaybe<Scalars['Boolean']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Represents the details of a bank account. */
export type BankAccount = {
  __typename?: 'BankAccount';
  /** account name. */
  AccountName?: Maybe<Scalars['String']>;
  /** account number. */
  AccountNumber?: Maybe<Scalars['String']>;
  /** bank identifier GUID identifier. */
  BankIdentifierId?: Maybe<Scalars['Uuid']>;
  /** bank identifier text. */
  BankIdentifierText?: Maybe<Scalars['String']>;
  /** name of the bank related to the bank identifier. */
  BankName?: Maybe<Scalars['String']>;
  /** whether this bank account can be used for direct credits. */
  HasDirectCreditAuthority?: Maybe<Scalars['Boolean']>;
  /** whether this bank account can be used for direct debits. */
  HasDirectDebitAuthority?: Maybe<Scalars['Boolean']>;
  HasPendingTransfer?: Maybe<Scalars['Boolean']>;
  /** The database identifier of the record. */
  Id: Scalars['Uuid'];
  /** whether this account can be used for pay anyone. */
  IsPayAnyone?: Maybe<Scalars['Boolean']>;
  /** whether this is a borrower nominated account. */
  Nominated?: Maybe<Scalars['Boolean']>;
  /** account suffix. */
  Suffix?: Maybe<Scalars['String']>;
};

export type BankBranch = {
  __typename?: 'BankBranch';
  BankIdentifier?: Maybe<Scalars['String']>;
  /** customer description of branch type */
  BankIdentifierType?: Maybe<Scalars['String']>;
  /** Bank specified name */
  BankName?: Maybe<Scalars['String']>;
  /** branch description / address */
  Description?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
};

export type BankBranchDetailsInput = {
  BankIdentifier: Scalars['String'];
  BankIdentifierType?: InputMaybe<Scalars['String']>;
};

export type BpayBiller = {
  __typename?: 'BpayBiller';
  /** customer description of biller fall back to BillerName */
  BillerDescription?: Maybe<Scalars['String']>;
  /** Bpay specified name */
  BillerName?: Maybe<Scalars['String']>;
  Billercode: Scalars['Long'];
  /** customer last used CRN for this biller */
  CustomerReferenceNumber?: Maybe<Scalars['String']>;
  HasPendingTransfer?: Maybe<Scalars['Boolean']>;
  Id?: Maybe<Scalars['String']>;
};

export type BpayBillerDetailsInput = {
  BillerCode: Scalars['Long'];
  EffectiveDate: Scalars['DateTime'];
};

/** Request a new Bpay transfer to be setup */
export type BpayTransferRequestInput = {
  /** GUID identifier of the account the transfer will come from */
  AccountId: Scalars['Uuid'];
  /** amount of the transfer. */
  Amount: Scalars['Decimal'];
  /** User Description of Biller to save in history */
  BillerDescription?: InputMaybe<Scalars['String']>;
  /** biller code for a bpay payment */
  Billercode: Scalars['Long'];
  /** customer reference number for a bpay payment. */
  CustomerReferenceNumber: Scalars['String'];
  /** The date the recurrence will end on or after. */
  EndingOn?: InputMaybe<Scalars['DateTime']>;
  /** frequency of any recurrences. */
  Frequency?: InputMaybe<Scalars['String']>;
  /** number of repeats. */
  NumberOfTimesAmount?: InputMaybe<Scalars['Int']>;
  RecurrenceEnd?: InputMaybe<RecurrenceEndEnum>;
  SaveBillerDetails?: InputMaybe<Scalars['Boolean']>;
  StartingOn: Scalars['DateTime'];
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /** description for the withdrawal transaction. */
  WithdrawalDescription?: InputMaybe<Scalars['String']>;
  /** Id of the PayAnyone request to correlate with response */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type BpayTransferRequestResponse = {
  __typename?: 'BpayTransferRequestResponse';
  Code?: Maybe<Scalars['String']>;
  FundsTransfer?: Maybe<FundsTransfer>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  ValidationErrors?: Maybe<Array<Maybe<ErrorMessage>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type BpayValidatorInput = {
  /** The BPAY payment amount */
  Amount?: InputMaybe<Scalars['Decimal']>;
  /** The BPAY BillerCode */
  BillerCode: Scalars['Long'];
  /** The BPAY CRN */
  CustomerReferenceNumber: Scalars['String'];
  /** Date the payment is going to be made */
  PaymentDate?: InputMaybe<Scalars['DateTime']>;
};

export type BpayValidatorResponse = {
  __typename?: 'BpayValidatorResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  /** BPay validation errors */
  ValidationErrors?: Maybe<Array<Maybe<ErrorMessage>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Card = {
  __typename?: 'Card';
  ExpiryDate: Scalars['DateTime'];
  HolderRelationship?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
  NameOnCard?: Maybe<Scalars['String']>;
  Number?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

/** The Current and Available balances of the card account */
export type CardBalance = {
  __typename?: 'CardBalance';
  /**
   * Total amount in the account that may be withdrawn.
   * This is the current balance less any oustanding holds or debits that are yet to be posted to the account.
   * A $100 hold on the card will reduce the AvailableBalance by $100 but will not change the CurrentBalance.
   */
  availableBalance?: Maybe<Money>;
  /**
   * Total amount of funds in the account.
   * Purchase of $500 prior to clearing will show AvailableBalance $500 less than CurrentBalance.
   * When the transaction clears CurrentBalance will reduce by $500.
   */
  currentBalance?: Maybe<Money>;
};

/** Request the categorisation of a list of AccountTransactions */
export type CategoriseAccountTransactionsInput = {
  /** List of categorisations to attempt */
  categorisations?: InputMaybe<Array<InputMaybe<AccountTransactionCategorisationRequestInput>>>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Request the categorisation of a list of AccountTransactions */
export type CategoriseAccountTransactionsResponse = {
  __typename?: 'CategoriseAccountTransactionsResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
  /** Failed categorisations */
  failedCategorisations?: Maybe<Array<Maybe<FailedAccountTransactionCategorisationRequest>>>;
  /** Successful categorisations */
  successfulCategorisations?: Maybe<Array<Maybe<AccountTransaction>>>;
};

export type CategoriseProfileAccountsInput = {
  /** Accounts to be categorised */
  CategoriesToApply?: InputMaybe<Array<InputMaybe<AccountCategorisationToApplyInput>>>;
  /** Remove categories from accounts. Removals are processed first */
  CategoriesToRemove?: InputMaybe<Array<InputMaybe<AccountCategorisationToRemoveInput>>>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CategoriseProfileAccountsResponse = {
  __typename?: 'CategoriseProfileAccountsResponse';
  /** Categories applied to accounts */
  CategoriesApplied?: Maybe<Array<Maybe<AccountCategorisation>>>;
  /** Categories removed from accounts */
  CategoriesRemoved?: Maybe<Array<Maybe<AccountCategorisation>>>;
  Code?: Maybe<Scalars['String']>;
  /** Categories removed from accounts */
  FailedCategorisations?: Maybe<Array<Maybe<FailedAccountCategorisation>>>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Request to update the profile specific Categorisation of an Account */
export type CategoryToRemoveInput = {
  /** Account to Apply Categorisation */
  AccountId: Scalars['Uuid'];
  /** Category to Remove */
  Category?: InputMaybe<ProfileAccountCategoryInput>;
  /** Optional Id of an existing Categorisation entry to update, null or empty to update all Categorisations for this account */
  Id?: InputMaybe<Scalars['Uuid']>;
};

export type ChangeAccountDescriptionInput = {
  AccountId: Scalars['Uuid'];
  Name?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ChangeAccountDescriptionResponse = {
  __typename?: 'ChangeAccountDescriptionResponse';
  Code?: Maybe<Scalars['String']>;
  Data?: Maybe<Account>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ChangeCardPinInput = {
  CardId: Scalars['Uuid'];
  /** PIN must be 4-6 digits */
  NewPin?: InputMaybe<Scalars['String']>;
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ChangeCardPinResponse = {
  __typename?: 'ChangeCardPinResponse';
  Code?: Maybe<Scalars['String']>;
  Data?: Maybe<Card>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ChangeElectronicCommsStatusInput = {
  EmailNotificationStatus: Scalars['Boolean'];
  SMSNotificationStatus: Scalars['Boolean'];
  StatementNotificationStatus: Scalars['Boolean'];
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Updates the electronic communications flags against party association. */
export type ChangeElectronicCommsStatusResponse = {
  __typename?: 'ChangeElectronicCommsStatusResponse';
  Code?: Maybe<Scalars['String']>;
  EmailNotificationStatus: Scalars['Boolean'];
  Message?: Maybe<Scalars['String']>;
  SMSNotificationStatus: Scalars['Boolean'];
  StatementNotificationStatus: Scalars['Boolean'];
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ChangeMarketingCommsStatusInput = {
  MarketingStatus: Scalars['Boolean'];
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Updates the marketing communications flag against party. */
export type ChangeMarketingCommsStatusResponse = {
  __typename?: 'ChangeMarketingCommsStatusResponse';
  Code?: Maybe<Scalars['String']>;
  MarketingStatus: Scalars['Boolean'];
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ChangePasswordInput = {
  /** The password the user logged in with */
  CurrentPassword?: InputMaybe<Scalars['String']>;
  /** The new password. It must meet complexity requirements */
  NewPassword?: InputMaybe<Scalars['String']>;
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  UserSession?: Maybe<UserSession>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ChangeUsernameInput = {
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The new username */
  newUsername?: InputMaybe<Scalars['String']>;
};

export type ChangeUsernameResponse = {
  __typename?: 'ChangeUsernameResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CheckMultiFactorAuthorisationInput = {
  /** The two factor token to check */
  TwoFactorToken: Scalars['String'];
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CheckMultiFactorAuthorisationResponse = {
  __typename?: 'CheckMultiFactorAuthorisationResponse';
  /** Indicates whether the MFA token is valid */
  Result: MultiFactorResult;
};

export type ConnectionWithNodesOfGraphAccountTransaction = {
  __typename?: 'ConnectionWithNodesOfGraphAccountTransaction';
  edges?: Maybe<Array<Maybe<EdgeOfGraphAccountTransaction>>>;
  nodes?: Maybe<Array<Maybe<AccountTransaction>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ConnectionWithNodesOfGraphApplicationNotificationInteraction = {
  __typename?: 'ConnectionWithNodesOfGraphApplicationNotificationInteraction';
  edges?: Maybe<Array<Maybe<EdgeOfGraphApplicationNotificationInteraction>>>;
  nodes?: Maybe<Array<Maybe<UserNotificationInteraction>>>;
  pageInfo?: Maybe<PageInfo>;
};

/** Country */
export type Country = {
  __typename?: 'Country';
  /** Phone dialing prefix. eg. 61 */
  IsdPrefix?: Maybe<Scalars['String']>;
  /** Country ISO code eg AU */
  IsoCode?: Maybe<Scalars['String']>;
  /** ISO Currency code eg. AUD */
  IsoCurrencyCode?: Maybe<Scalars['String']>;
  /** Name of Country. eg. Australia */
  Name?: Maybe<Scalars['String']>;
  /** Mask used for valid postcodes */
  PostalCodeMask?: Maybe<Scalars['String']>;
  /** Postal codes required */
  PostalCodeRequired: Scalars['Boolean'];
  /** Type of Region eg. State, District, Region, Province */
  RegionLabel?: Maybe<Scalars['String']>;
  /** Region required */
  RegionRequired: Scalars['Boolean'];
  /** Are postal codes used */
  UsePostalCode: Scalars['Boolean'];
  /** Are Regions used */
  UseRegions: Scalars['Boolean'];
};

/** Input for adding a BPAY Biller to a party */
export type CreateBpayBillerInput = {
  /** Biller Code used to identify the BPAY biller */
  BillerCode: Scalars['Int'];
  /** Optional customer friendly name of the BPAY biller */
  BillerDescription?: InputMaybe<Scalars['String']>;
  /** Customer reference number used to identify the customer making the payment */
  CustomerReferenceNumber: Scalars['String'];
  HasPendingTransfer?: InputMaybe<Scalars['Boolean']>;
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateBpayBillerResponse = {
  __typename?: 'CreateBpayBillerResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  NewBpayBiller?: Maybe<BpayBiller>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreatePayAnyoneBankAccountInput = {
  /** Name of the bank account */
  AccountName: Scalars['String'];
  /** Number of the bank account */
  AccountNumber: Scalars['String'];
  /** 6 digit code used to identify the bank and branch */
  Bsb: Scalars['String'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreatePayAnyoneBankAccountResponse = {
  __typename?: 'CreatePayAnyoneBankAccountResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  NewPartyBankAccount?: Maybe<PartyBankAccount>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CurrentTheme = {
  __typename?: 'CurrentTheme';
  theme: Scalars['String'];
};

export type DateRangeInput = {
  From?: InputMaybe<Scalars['DateTime']>;
  To?: InputMaybe<Scalars['DateTime']>;
};

export type DeleteBpayPartyBillerInput = {
  /** ID of the saved BPAY biller/CRN */
  PartyBillerHistoryId?: InputMaybe<Scalars['String']>;
  /** Id of the PayAnyone request to correlate with response */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteBpayPartyBillerResponse = {
  __typename?: 'DeleteBpayPartyBillerResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  PartyBillerHistoryId: Scalars['Uuid'];
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeletePartyBankAccountInput = {
  /** ID of the user's bank account to be deleted */
  PartyBankAccountId: Scalars['Uuid'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeletePartyBankAccountResponse = {
  __typename?: 'DeletePartyBankAccountResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  PartyBankAccountId: Scalars['Uuid'];
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteProfileCustomAccountCategoryInput = {
  /** User defined order for the account */
  Deletions: Array<ProfileCategoryDeletionInput>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteProfileCustomAccountCategoryResponse = {
  __typename?: 'DeleteProfileCustomAccountCategoryResponse';
  Code?: Maybe<Scalars['String']>;
  Deleted?: Maybe<Array<Maybe<ProfileCustomCategory>>>;
  Failed?: Maybe<Array<Maybe<FailedProfileCategoryDeletion>>>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DisableProfileAuthenticatorInput = {
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DisableProfileAuthenticatorResponse = {
  __typename?: 'DisableProfileAuthenticatorResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DisbursementRequestInput = {
  AccountId: Scalars['Uuid'];
  /** Supplier Bank Account Number */
  AccountNumber?: InputMaybe<Scalars['String']>;
  BankIdentifierText?: InputMaybe<Scalars['String']>;
  File?: InputMaybe<Scalars['String']>;
  FileName?: InputMaybe<Scalars['String']>;
  InstrumentId: Scalars['Uuid'];
  PayeeName?: InputMaybe<Scalars['String']>;
  PaymentDate: Scalars['DateTime'];
  PaymentDescription?: InputMaybe<Scalars['String']>;
  RequestedAmount: Scalars['Decimal'];
  SupplierBankAccountName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DisbursementRequestResponse = {
  __typename?: 'DisbursementRequestResponse';
  Code?: Maybe<Scalars['String']>;
  Data?: Maybe<DisbursementStage>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DisbursementStage = {
  __typename?: 'DisbursementStage';
  AccountNumber?: Maybe<Scalars['String']>;
  BankIdentifierText?: Maybe<Scalars['String']>;
  Documents?: Maybe<Array<Maybe<File>>>;
  Id: Scalars['Uuid'];
  PayeeName?: Maybe<Scalars['String']>;
  PaymentDate: Scalars['DateTime'];
  PaymentDescription?: Maybe<Scalars['String']>;
  RequestedAmount: Scalars['Decimal'];
};

export type DismissNotificationResult = MutationResponse & {
  __typename?: 'DismissNotificationResult';
  Code: Scalars['String'];
  Data?: Maybe<InterestConversionNotification>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
};

export type DocumentCategory = {
  __typename?: 'DocumentCategory';
  Id: Scalars['Uuid'];
  /** name of the category. */
  Name?: Maybe<Scalars['String']>;
};

export type DocumentLinkFilterInput = {
  Document?: InputMaybe<FileFilterInput>;
};

export type EdgeOfGraphAccountTransaction = {
  __typename?: 'EdgeOfGraphAccountTransaction';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AccountTransaction>;
};

export type EdgeOfGraphApplicationNotificationInteraction = {
  __typename?: 'EdgeOfGraphApplicationNotificationInteraction';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<UserNotificationInteraction>;
};

/** Account limits for the specified date */
export type EffectiveAccountLimit = {
  __typename?: 'EffectiveAccountLimit';
  EffectiveDate: Scalars['DateTime'];
  Id?: Maybe<Scalars['String']>;
  Limits?: Maybe<AccountLimit>;
};

export type ElectronicCommsStatus = {
  __typename?: 'ElectronicCommsStatus';
  EmailNotificationStatus: Scalars['Boolean'];
  SMSNotificationStatus: Scalars['Boolean'];
  StatementNotificationStatus: Scalars['Boolean'];
};

export type EnableProfileAuthenticatorInput = {
  /** Authenticator Token supplied by Authenticator app */
  AuthenticatorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type EnableProfileAuthenticatorResponse = {
  __typename?: 'EnableProfileAuthenticatorResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
};

export type FailedAccountCategorisation = {
  __typename?: 'FailedAccountCategorisation';
  clientMutationId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type FailedAccountCategorisationRequest = {
  __typename?: 'FailedAccountCategorisationRequest';
  Categorisation?: Maybe<FailedCategorisation>;
  Reason?: Maybe<Scalars['String']>;
};

export type FailedAccountOrdering = {
  __typename?: 'FailedAccountOrdering';
  Ordering?: Maybe<FailedOrdering>;
  Reason?: Maybe<Scalars['String']>;
};

export type FailedAccountTransactionCategorisationRequest = {
  __typename?: 'FailedAccountTransactionCategorisationRequest';
  /** Transaction to categorise */
  accountId: Scalars['Uuid'];
  /** Transaction to categorise */
  accountTransactionId: Scalars['Uuid'];
  /** Category to apply. Null to remove category */
  categoryId?: Maybe<Scalars['Uuid']>;
  failureCode?: Maybe<Scalars['String']>;
  failureMessage?: Maybe<Scalars['String']>;
};

export type FailedCategorisation = {
  __typename?: 'FailedCategorisation';
  /** Account to Apply Categorisation */
  AccountId: Scalars['Uuid'];
  /** User defined category for the account */
  Category?: Maybe<FailedCategory>;
};

export type FailedCategory = {
  __typename?: 'FailedCategory';
  Id?: Maybe<Scalars['Uuid']>;
  Name?: Maybe<Scalars['String']>;
  Ordering?: Maybe<Scalars['Int']>;
};

export type FailedCategoryRemovalRequest = {
  __typename?: 'FailedCategoryRemovalRequest';
  /** Account to Apply Categorisation */
  AccountId: Scalars['Uuid'];
  /** Category to Remove */
  Category?: Maybe<FailedCategory>;
  /** Optional Id of an existing Categorisation entry to update, null or empty to update all Categorisations for this account */
  Id?: Maybe<Scalars['Uuid']>;
};

export type FailedOrdering = {
  __typename?: 'FailedOrdering';
  /** Account to Apply Ordering */
  AccountId: Scalars['Uuid'];
  /** Optional Id of an existing ordering entry to update, null or empty to update all orderings for this account */
  Id?: Maybe<Scalars['Uuid']>;
  /** User defined order for the account */
  Ordering?: Maybe<Scalars['Int']>;
  /** Optional, Current User will be used if not provided */
  ProfileId?: Maybe<Scalars['Uuid']>;
};

export type FailedProfileCategoryDeletion = {
  __typename?: 'FailedProfileCategoryDeletion';
  Id?: Maybe<Scalars['Uuid']>;
};

export type FailedRemoveAccountFromCategory = {
  __typename?: 'FailedRemoveAccountFromCategory';
  Reason?: Maybe<Scalars['String']>;
  Request?: Maybe<FailedCategoryRemovalRequest>;
};

export enum FieldDataType {
  Date = 'DATE',
  Flag = 'FLAG',
  Money = 'MONEY',
  Number = 'NUMBER',
  Text = 'TEXT'
}

/** Represents a document linked to an instrument. */
export type File = {
  __typename?: 'File';
  CreatedOn: Scalars['DateTime'];
  /** Document Category */
  DocumentCategory?: Maybe<DocumentCategory>;
  /** document type. */
  DocumentType: FileType;
  FileName?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
  /** GUID identifier of the parent instrument. */
  InstrumentId?: Maybe<Scalars['Uuid']>;
  /** Has the file been deleted */
  IsDeleted: Scalars['Boolean'];
  /** document name. */
  Name?: Maybe<Scalars['String']>;
  /** note against the document. */
  Note?: Maybe<Scalars['String']>;
  /** document number. */
  Number?: Maybe<Scalars['String']>;
  /** The Privacy level of a document */
  PrivacyLevel: PrivacyLevel;
  /** whether the document was user generated. */
  UserGenerated?: Maybe<Scalars['Boolean']>;
};

/** Add Graph filter object for GraphFile */
export type FileFilterInput = {
  DocumentCategory?: InputMaybe<GraphDocumentCategoryFilterInput>;
  DocumentType?: InputMaybe<ValueFilterOfFileTypeInput>;
  PrivacyLevel?: InputMaybe<ValueFilterOfPrivacyLevelInput>;
  UserGenerated?: InputMaybe<Scalars['Boolean']>;
};

export enum FileType {
  Document = 'DOCUMENT',
  Documentfooter = 'DOCUMENTFOOTER',
  Documentheader = 'DOCUMENTHEADER',
  Image = 'IMAGE',
  Logo = 'LOGO',
  Marketingimage = 'MARKETINGIMAGE',
  Profileimage = 'PROFILEIMAGE',
  Resource = 'RESOURCE',
  Signature = 'SIGNATURE',
  Statement = 'STATEMENT',
  Template = 'TEMPLATE'
}

export type FinanceSummary = {
  __typename?: 'FinanceSummary';
  Id: Scalars['Uuid'];
  Instruments?: Maybe<Array<Maybe<Instrument>>>;
  TotalPrincipal?: Maybe<Money>;
  TotalRedraw?: Maybe<Money>;
};

export type ForceCloseCurrentUserSessionsInput = {
  CloseCurrentSession?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ForceCloseCurrentUserSessionsResponse = {
  __typename?: 'ForceCloseCurrentUserSessionsResponse';
  /** @deprecated Refer to errors response object instead */
  Code?: Maybe<Scalars['String']>;
  Data?: Maybe<UserSession>;
  /** @deprecated Refer to errors response object instead */
  Message?: Maybe<Scalars['String']>;
  /** @deprecated Refer to errors response object instead */
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Represents a transfer of funds from one account to another, either internally or
 * externally.
 */
export type FundsTransfer = {
  __typename?: 'FundsTransfer';
  /** GUID identifier of the account the transfer is linked to. */
  AccountId?: Maybe<Scalars['Uuid']>;
  /** date and time the transfer was added to the system. */
  AddedOn?: Maybe<Scalars['DateTime']>;
  /** additional amount to apply on top of the installment amount. */
  AdditionalAmount?: Maybe<Scalars['Decimal']>;
  /** amount of the transfer. */
  Amount?: Maybe<Scalars['Decimal']>;
  /** source of the funds transfer. */
  ApplicationInstance?: Maybe<Scalars['String']>;
  /** description of the bank account. */
  BankAccountDescription?: Maybe<Scalars['String']>;
  /** GUID identifier of the bank account the transfer will use. */
  BankAccountId?: Maybe<Scalars['Uuid']>;
  /** biller name for a bpay payment. */
  BillerName?: Maybe<Scalars['String']>;
  /** biller code for a bpay payment */
  Billercode?: Maybe<Scalars['String']>;
  BpayBiller?: Maybe<BpayBiller>;
  /** if the funds transfer can be removed. */
  CanRemove?: Maybe<Scalars['Boolean']>;
  /** description on a cheque. */
  ChequeNote?: Maybe<Scalars['String']>;
  /** who created the item. */
  CreatedByFullName?: Maybe<Scalars['String']>;
  /** work pool the creator is in. */
  CreatedByWorkpool?: Maybe<Scalars['String']>;
  /** date the entity was created. */
  CreatedOn?: Maybe<Scalars['DateTime']>;
  /** customer reference number for a bpay payment. */
  CustomerReferenceNumber?: Maybe<Scalars['String']>;
  /** description for the deposit transaction. */
  DepositDescription?: Maybe<Scalars['String']>;
  /** date the recurrence will end on or after. */
  EndingOn?: Maybe<Scalars['DateTime']>;
  /** whether the transfer is for a fixed amount. */
  FixedAmountOption?: Maybe<Scalars['Boolean']>;
  /** frequency of any recurrences. */
  Frequency?: Maybe<Scalars['String']>;
  /** description of the from account. */
  FromAccountDescription?: Maybe<Scalars['String']>;
  /** GUID identifier of the internal account to draw funds from. */
  FromAccountId?: Maybe<Scalars['Uuid']>;
  FromBankAccount?: Maybe<BankAccount>;
  /** wether the transfer continues until further notice. */
  FurtherNotice?: Maybe<Scalars['Boolean']>;
  /** The database identifier of the record. */
  Id: Scalars['Uuid'];
  IsCopied?: Maybe<Scalars['Boolean']>;
  /** if the record is to be deleted. */
  IsDeleted?: Maybe<Scalars['Boolean']>;
  IsExisting?: Maybe<Scalars['Boolean']>;
  /** if the record has been modified. */
  IsModified?: Maybe<Scalars['Boolean']>;
  /** if the record has been newly added. */
  IsNew?: Maybe<Scalars['Boolean']>;
  /** date the transfer last ran. */
  LastExecuted?: Maybe<Scalars['DateTime']>;
  /** whether the transfer is for the minimum installment. */
  MinimumAmount?: Maybe<Scalars['Boolean']>;
  /** whether the transfer is for the minimum installment plus an amount. */
  MinimumAmountPlus?: Maybe<Scalars['Boolean']>;
  /** who last modified the entity. */
  ModifiedByFullName?: Maybe<Scalars['String']>;
  /** date the entity was last modified. */
  ModifiedOn?: Maybe<Scalars['DateTime']>;
  /** bank identifier for a new bank account. */
  NewBankAccountIdentifier?: Maybe<Scalars['String']>;
  /** bank account name for a new bank account. */
  NewBankAccountName?: Maybe<Scalars['String']>;
  /** bank account number for a new bank account. */
  NewBankAccountNumber?: Maybe<Scalars['String']>;
  /** a bank account suffix for a new bank account. */
  NewBankAccountSuffix?: Maybe<Scalars['String']>;
  /**
   * date the transfer will next execute, taking into account the business
   *             day rules if the apply.
   */
  NextExecutedDate?: Maybe<Scalars['DateTime']>;
  /** date the transfer is next schedule for. */
  NextScheduledDate?: Maybe<Scalars['DateTime']>;
  /** whether the transfer ends after a number of repeats. */
  NumberOfTimes?: Maybe<Scalars['Boolean']>;
  /** number of repeats. */
  NumberOfTimesAmount?: Maybe<Scalars['Decimal']>;
  /** name of a cheque payee. */
  Payee?: Maybe<Scalars['String']>;
  /** type of payment calculation. */
  PaymentCalculationType?: Maybe<Scalars['String']>;
  PaymentType?: Maybe<Scalars['String']>;
  /** percentage of installment amount. */
  PercentageOfInstalment?: Maybe<Scalars['Decimal']>;
  /** whether the installments should be recalculated after a funds transfer. */
  RecalculateInstalments?: Maybe<Scalars['Boolean']>;
  /** receipt number. */
  ReceiptNumber?: Maybe<Scalars['String']>;
  /** if the funds transfer is the regular payment */
  RegularPayment?: Maybe<Scalars['Boolean']>;
  /** number of remaining payments for the direct debit. */
  RemainingNumberOfTimes?: Maybe<Scalars['Decimal']>;
  /** repayment number. */
  RepaymentNumber?: Maybe<Scalars['Decimal']>;
  /** Sequence Number of the transaction if it has been processed */
  SequenceNumber?: Maybe<Scalars['Long']>;
  /** whether the transfer continues until a date. */
  SpecifiedDate?: Maybe<Scalars['Boolean']>;
  /** date the transfer starts on. */
  StartingOn?: Maybe<Scalars['DateTime']>;
  /** GUID identifier of the task that is scheduled to run the funds trasfer. */
  TaskId?: Maybe<Scalars['Uuid']>;
  /** description of the to account. */
  ToAccountDescription?: Maybe<Scalars['String']>;
  /** GUID identifier of the internal account to deposit funds into. */
  ToAccountId?: Maybe<Scalars['Uuid']>;
  ToBankAccount?: Maybe<BankAccount>;
  /** GUID identifier of the type of transfer. */
  TransferType?: Maybe<Scalars['Uuid']>;
  /** a description of the type of transfer. */
  TransferTypeDescription?: Maybe<Scalars['String']>;
  /** CLR type of the DTO. */
  Type?: Maybe<Scalars['String']>;
  /** whether the business day rules apply to a transfer. */
  UseBusinessDayCheck?: Maybe<Scalars['Boolean']>;
  /**
   * whether the transfer will use the greater of the selected amount or the
   * installment amount in case of a change in installments.
   */
  UseGreaterOfInstalment?: Maybe<Scalars['Boolean']>;
  /** whether a new bank account is being used for a pay anyone transfer type. */
  UseNewBankAccount?: Maybe<Scalars['Boolean']>;
  /** whether the transfer will use a percentage of the installments. */
  UsePercentageOfInstalment?: Maybe<Scalars['Boolean']>;
  /** description for the withdrawal transaction. */
  WithdrawalDescription?: Maybe<Scalars['String']>;
};

export type GenerateAuthSecretInput = {
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type GenerateAuthSecretResponse = {
  __typename?: 'GenerateAuthSecretResponse';
  AuthSecret?: Maybe<Scalars['String']>;
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Geo Location */
export type GeographicLocation = {
  __typename?: 'GeographicLocation';
  Latitude: Scalars['Decimal'];
  Longitude: Scalars['Decimal'];
};

/** Region within a country eg. state. */
export type GeographicRegion = {
  __typename?: 'GeographicRegion';
  /** Country specific abbreviation eg VIC, NSW */
  Abbreviation?: Maybe<Scalars['String']>;
  /** Parent country of this region */
  Country?: Maybe<Country>;
  /** Name of the region. eg. Victoria, Alaska. */
  Name?: Maybe<Scalars['String']>;
};

/** An address for a Party */
export type GraphAssociatedAddress = {
  __typename?: 'GraphAssociatedAddress';
  Address?: Maybe<Address>;
  Comment?: Maybe<Scalars['String']>;
  /** when the effective date for the address is */
  EffectiveDate?: Maybe<Scalars['DateTime']>;
  Id: Scalars['Uuid'];
  IsDefaultMailingAddress: Scalars['Boolean'];
  IsDefaultResidentialAddress: Scalars['Boolean'];
  /** whether the address is deleted. */
  IsDeleted: Scalars['Boolean'];
  /** if the address is invalid. */
  IsInvalid: Scalars['Boolean'];
  IsPrevious: Scalars['Boolean'];
  /** the reason for taking an action on the address */
  Reason?: Maybe<Scalars['String']>;
};

export type GraphContact = {
  __typename?: 'GraphContact';
  /** active from date for a contact. */
  ActiveFrom?: Maybe<Scalars['DateTime']>;
  /** the active to date for a contact record. */
  ActiveTo?: Maybe<Scalars['DateTime']>;
  /** a comment for the contact. */
  Comment?: Maybe<Scalars['String']>;
  /** the country code. */
  CountryCode?: Maybe<Scalars['String']>;
  /** the details. */
  Details?: Maybe<Scalars['String']>;
  /** the extension. */
  Extension?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
  /** whether the address is deleted. */
  IsDeleted: Scalars['Boolean'];
  /** the preferred email contact flag. */
  IsPreferredEmail: Scalars['Boolean'];
  /** the preferred phone contact flag. */
  IsPreferredPhone: Scalars['Boolean'];
  /** the preferred sms number flag. */
  IsPreferredSms: Scalars['Boolean'];
  Party?: Maybe<Party>;
  /** the time a contact maybe used. */
  PreferredContactTime: PreferredContactTime;
  /** the region code. */
  RegionCode?: Maybe<Scalars['String']>;
  /** the type of contact. */
  Type?: Maybe<GraphContactType>;
  /** whether the contact details have been verified. */
  Verified: Scalars['Boolean'];
};

export type GraphContactType = {
  __typename?: 'GraphContactType';
  /** Description of the contact */
  Description?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
  /** Is a Phone contact */
  IsPhone: Scalars['Boolean'];
  ReceiveMessages: Scalars['Boolean'];
};

/** Custom Field */
export type GraphCustomField = {
  __typename?: 'GraphCustomField';
  /** the value for date time data types. */
  DateValue?: Maybe<Scalars['DateTime']>;
  /** the metadata for the field. */
  Definition?: Maybe<GraphFieldDefinition>;
  /** the value for flag data types. */
  FlagValue: Scalars['Boolean'];
  Id: Scalars['Uuid'];
  /** the value for money data types. */
  MoneyValue?: Maybe<Money>;
  /** the value for number data types. */
  NumberValue: Scalars['Decimal'];
  /** the value for text data types. */
  TextValue?: Maybe<Scalars['String']>;
};

export type GraphDocumentCategoryFilterInput = {
  Id?: InputMaybe<ValueFilterOfGuidInput>;
  Name?: InputMaybe<StringFilterInput>;
};

/** Definition of a custom field */
export type GraphFieldDefinition = {
  __typename?: 'GraphFieldDefinition';
  /** the datatype. */
  DataType: FieldDataType;
  /** the size limit for a text type field. */
  FieldLength: Scalars['Int'];
  /** help text displayed to a user. */
  HelpText?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
  /** if the field is only active for Instruments. */
  InstrumentOnly: Scalars['Boolean'];
  /** if the Field Definition is active in the system. */
  IsActive: Scalars['Boolean'];
  /** if the field should only be added to a instrument/party once. */
  IsUnique: Scalars['Boolean'];
  /** the name of the field. */
  Name?: Maybe<Scalars['String']>;
  /** if the field is only active for Parties. */
  PartyOnly: Scalars['Boolean'];
  /** the privacy level. */
  PrivacyLevel: PrivacyLevel;
  /** whether the field must be set. */
  Required: Scalars['Boolean'];
};

export type GroupedDateRangeInput = {
  DateRange?: InputMaybe<DateRangeInput>;
  Period?: InputMaybe<Period>;
};

export type IndueCard = {
  __typename?: 'IndueCard';
  /** Indicates whether card current status allows activation */
  CanActivate: Scalars['Boolean'];
  /** Indicates whether card current status allows it to be closed */
  CanClose: Scalars['Boolean'];
  /** Indicates whether card current status allows it to be put on hold */
  CanHold: Scalars['Boolean'];
  /** Indicates whether card current status allows it to be reported lost or stolen */
  CanReportLostStolen: Scalars['Boolean'];
  /** Indicates whether card current status allows it to be unheld */
  CanUnHold: Scalars['Boolean'];
  /** Masked card number */
  CardNumber?: Maybe<Scalars['String']>;
  /** Date that card will expire */
  ExpiryDate?: Maybe<Scalars['DateTime']>;
  /** Id of the card */
  Id: Scalars['Uuid'];
  /** Current status of the card */
  Status: IndueCardStatus;
};

export type IndueCardActivateCardInput = {
  /** CardId to change status of */
  CardId: Scalars['Uuid'];
  /** The new Pin to be set */
  Pin: Scalars['String'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type IndueCardActivateCardResponse = {
  __typename?: 'IndueCardActivateCardResponse';
  /** Result from the response of the card activation */
  ActivateCardResult: Scalars['Boolean'];
  /** The card which was created */
  Card?: Maybe<IndueCard>;
  /** Result from the response of the pin change */
  ChangePinResult: Scalars['Boolean'];
  /** Result from the response of the card change */
  Result: Scalars['Boolean'];
  Success: Scalars['Boolean'];
};

export type IndueCardChangePinInput = {
  /** The CardId which is having its Pin set */
  CardId: Scalars['Uuid'];
  /** The new Pin to be set */
  Pin: Scalars['String'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type IndueCardChangeResponse = {
  __typename?: 'IndueCardChangeResponse';
  /** The card which was changed */
  Card: IndueCard;
  /** Result from the response of the card change */
  Result: Scalars['Boolean'];
};

export type IndueCardChangeStatusInput = {
  /** CardId to change status of */
  CardId: Scalars['Uuid'];
  /**
   * Status to be changed to. Can be
   * * Active
   * * ActiveOff (hold)
   * * Lost
   * * Stolen
   * * Closed
   */
  Status: IndueCardStatus;
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type IndueCardCreateCardInput = {
  /** The AccountId which is requesting a card to be created */
  AccountId: Scalars['Uuid'];
  /** Mothers Maiden Name security question to associate with the card for card management support calls from Indue's end */
  SecurityQuestionAnswer?: InputMaybe<Scalars['String']>;
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type IndueCardCreateCardResponse = {
  __typename?: 'IndueCardCreateCardResponse';
  /** The card which was created */
  Card?: Maybe<IndueCard>;
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type IndueCardDetailsInput = {
  /** The CardId to fetch the details of */
  CardId: Scalars['Uuid'];
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type IndueCardProvisionAppleWalletInput = {
  CardId: Scalars['Uuid'];
  /** Gets or sets the nonce. */
  Nonce?: InputMaybe<Scalars['String']>;
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type IndueCardProvisionAppleWalletResponse = {
  __typename?: 'IndueCardProvisionAppleWalletResponse';
  ActivationData?: Maybe<Scalars['String']>;
  AuthenticationData?: Maybe<Scalars['String']>;
  PrimaryAccountNumberPrefix?: Maybe<Scalars['String']>;
};

export type IndueCardProvisionGooglePayInput = {
  CardId: Scalars['Uuid'];
  ClientDeviceID?: InputMaybe<Scalars['String']>;
  ClientWalletAccountID?: InputMaybe<Scalars['String']>;
  ClientWalletProvider?: InputMaybe<Scalars['String']>;
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type IndueCardProvisionGooglePayResponse = {
  __typename?: 'IndueCardProvisionGooglePayResponse';
  EncryptedPaymentInstrument?: Maybe<Scalars['String']>;
};

export enum IndueCardStatus {
  Active = 'ACTIVE',
  Activeoff = 'ACTIVEOFF',
  Cardcreated = 'CARDCREATED',
  Closed = 'CLOSED',
  Damaged = 'DAMAGED',
  Lost = 'LOST',
  Ordered = 'ORDERED',
  Other = 'OTHER',
  Restricted = 'RESTRICTED',
  Stolen = 'STOLEN'
}

export type IndueCardsByAccountInput = {
  /** The AccountId to fetch the cards for */
  AccountId: Scalars['Uuid'];
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type Instrument = {
  __typename?: 'Instrument';
  /** account with the highest arrears. */
  AccountWithHighestArrearsDays?: Maybe<Scalars['String']>;
  Accounts?: Maybe<Array<Maybe<Account>>>;
  /** application number. */
  ApplicationNumber?: Maybe<Scalars['String']>;
  /** approved amount. */
  ApprovedAmount?: Maybe<Scalars['Decimal']>;
  /** name of the brand. */
  Brand?: Maybe<Scalars['String']>;
  /** if the loan is set to charge default interest. */
  ChargeDefaultInterest?: Maybe<Scalars['Boolean']>;
  /** current LVR. */
  CurrentLVR?: Maybe<Scalars['Decimal']>;
  /** current schedule-based LVR. */
  CurrentScheduleLVR?: Maybe<Scalars['Decimal']>;
  /** current total schedule-based LVR including linked loans. */
  CurrentScheduleTotalLVR?: Maybe<Scalars['Decimal']>;
  /** current total LVR which includes linked loans. */
  CurrentTotalLVR?: Maybe<Scalars['Decimal']>;
  CustomFields?: Maybe<Array<Maybe<GraphCustomField>>>;
  /** a description of the loan. */
  Description?: Maybe<Scalars['String']>;
  Documents?: Maybe<Array<Maybe<InstrumentDocumentLink>>>;
  /** name of the funder. */
  Funder?: Maybe<Scalars['String']>;
  /** if the loan has an active full and final discharge. */
  HasActiveFullFinalDischarge?: Maybe<Scalars['Boolean']>;
  /** highest number of days in arrears. */
  HighestAccountArrearsDays?: Maybe<Scalars['Long']>;
  /** The database identifier of the record. */
  Id: Scalars['Uuid'];
  InstrumentType?: Maybe<Scalars['String']>;
  InterestAccrued?: Maybe<Scalars['Decimal']>;
  InterestDue?: Maybe<Scalars['Decimal']>;
  InterestPaid?: Maybe<Scalars['Decimal']>;
  IsArrangementInPlace?: Maybe<Scalars['Boolean']>;
  /** if the loan is fully discharged. */
  IsFullyDischarged?: Maybe<Scalars['Boolean']>;
  /** if the loan has an active hardship agreement. */
  IsUnderHardshipAgreement?: Maybe<Scalars['Boolean']>;
  /** purpose of the loan. */
  LoanPurpose?: Maybe<Scalars['String']>;
  /** date of maturity. */
  MaturityDate?: Maybe<Scalars['DateTime']>;
  /** loan number. */
  Number?: Maybe<Scalars['String']>;
  /** anticipated settlement date for an application. */
  OriginalAnticipatedSettlementDate?: Maybe<Scalars['DateTime']>;
  /** original application amount. */
  OriginalApplicationAmount?: Maybe<Scalars['Decimal']>;
  /** original application date. */
  OriginalApplicationDate?: Maybe<Scalars['DateTime']>;
  /** LVR at the original settlement date. */
  OriginalSettlementLVR?: Maybe<Scalars['Decimal']>;
  /** name of the primary borrower. */
  PrimaryBorrower?: Maybe<Scalars['String']>;
  /** Account or Instrument redraw consideration */
  RedrawConsideration?: Maybe<Scalars['String']>;
  /** whether the loan is regulated. */
  Regulated?: Maybe<Scalars['Boolean']>;
  /** remaining term in months. */
  RemainingTermMonths: Scalars['Long'];
  /** initial settlement date. */
  SettlementDate?: Maybe<Scalars['DateTime']>;
  /** statements generated for a loan. */
  Statements?: Maybe<Array<Maybe<StatementDocument>>>;
  /** current loan status. */
  Status?: Maybe<Scalars['String']>;
  /** original loan term. */
  Term?: Maybe<Scalars['Int']>;
  /** total arrears amount. */
  TotalArrears?: Maybe<Scalars['Decimal']>;
  /** total amount redraw reserved for active cards. */
  TotalCardReservation?: Maybe<Scalars['Decimal']>;
  /** total number of days the loan as a whole has been in arrears. */
  TotalDaysInArrears?: Maybe<Scalars['Int']>;
  /** total amount of reserved instalments. */
  TotalInstalmentReservation?: Maybe<Scalars['Decimal']>;
  /** total principal amount. */
  TotalPrincipal?: Maybe<Scalars['Decimal']>;
  /** loan-level redraw amount. */
  TotalRedraw?: Maybe<Scalars['Decimal']>;
  /** total schedule amount. */
  TotalSchedule?: Maybe<Scalars['Decimal']>;
  /** total value of active securities. */
  TotalSecurityValue?: Maybe<Scalars['Decimal']>;
  /** total term for the loan. */
  TotalTermMonths?: Maybe<Scalars['Long']>;
  /** total unclears funds amount. */
  TotalUnclearedFunds?: Maybe<Scalars['Decimal']>;
};


export type InstrumentDocumentsArgs = {
  where?: InputMaybe<DocumentLinkFilterInput>;
};

/** Input for querying an Account's Instrument, supply either an Id or Number */
export type InstrumentByAccountInput = {
  /** Id of the account */
  Id?: InputMaybe<Scalars['String']>;
  /** Number of the account */
  Number?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type InstrumentDocumentLink = {
  __typename?: 'InstrumentDocumentLink';
  /** the document. */
  Document?: Maybe<File>;
  Id: Scalars['Uuid'];
  /** Has this document link been removed */
  IsDeleted: Scalars['Boolean'];
};

export type InterestConversionNotification = {
  __typename?: 'InterestConversionNotification';
  Account?: Maybe<Account>;
  ConversionDate?: Maybe<Scalars['DateTime']>;
  ConversionType?: Maybe<Scalars['String']>;
  Dismissed?: Maybe<Scalars['Boolean']>;
  Id: Scalars['Uuid'];
  Message?: Maybe<Scalars['String']>;
  NewInstalmentAmount?: Maybe<Money>;
  NewInstalmentFrequency?: Maybe<Scalars['String']>;
};

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  ChildAccount?: Maybe<Account>;
  /** This the effective date the accounts were linked. */
  EffectiveFrom: Scalars['DateTime'];
  /** the date and time a status was left. */
  EffectiveTo?: Maybe<Scalars['DateTime']>;
  Id: Scalars['Uuid'];
  ParentAccount?: Maybe<Account>;
  /** This is the priority order in which items will be dispersed between the linked accounts. */
  Priority: Scalars['Int'];
  /** This is the percentage ratio of the link between these accounts. 0 - 100 */
  Ratio: Scalars['Decimal'];
};

export type LocalConfig = {
  __typename?: 'LocalConfig';
  allowOnlinePasswordReset: Scalars['Boolean'];
  currentTheme?: Maybe<CurrentTheme>;
};

export type LoginAttempt = {
  __typename?: 'LoginAttempt';
  ClientVersion?: Maybe<Scalars['String']>;
  EventDate: Scalars['DateTime'];
  Expires: Scalars['DateTime'];
  Id: Scalars['Uuid'];
  IpAddress?: Maybe<Scalars['String']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  LastActivity: Scalars['DateTime'];
  SessionStart: Scalars['DateTime'];
  Successful?: Maybe<Scalars['Boolean']>;
  UserAgentHeader?: Maybe<Scalars['String']>;
};

export type LoginInput = {
  ApplicationInstance?: InputMaybe<Scalars['String']>;
  ClientVersionNumber?: InputMaybe<Scalars['String']>;
  /** Set to true if you'd like a trusted device token to be returned after login */
  GenerateTrustedDeviceToken?: InputMaybe<Scalars['Boolean']>;
  Password?: InputMaybe<Scalars['String']>;
  Referrer?: InputMaybe<Scalars['String']>;
  RemoteClientIPAddress?: InputMaybe<Scalars['String']>;
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  UserAgentHeader?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  /**
   * This is set only when login fails due to missing two factor token.
   * It indicates whether this profile can use the trusted device feature
   */
  CanUseTrustedDevice?: Maybe<Scalars['Boolean']>;
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  TrustedDeviceToken?: Maybe<Scalars['String']>;
  UserSession?: Maybe<UserSession>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type LoginV2Input = {
  /** The application name/version number */
  ClientVersionNumber?: InputMaybe<Scalars['String']>;
  /** Set to true if you'd like a trusted device token to be returned after login */
  GenerateTrustedDeviceToken?: InputMaybe<Scalars['Boolean']>;
  /** If logged in with a temporary password then a new password must be specified */
  NewPassword?: InputMaybe<Scalars['String']>;
  OnBehalfOfUsername?: InputMaybe<Scalars['String']>;
  /** The client's password */
  Password: Scalars['String'];
  /** You can optionally override the referrer here */
  Referrer?: InputMaybe<Scalars['String']>;
  /** You may optionally supply the user's IP Address */
  RemoteClientIPAddress?: InputMaybe<Scalars['String']>;
  /** If logging into an account that requires 2FA then the token must be provided here */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /** You can optionally override the user agent here */
  UserAgentHeader?: InputMaybe<Scalars['String']>;
  /** The client's username */
  Username: Scalars['String'];
};

export type LoginV2Response = {
  __typename?: 'LoginV2Response';
  /** bearer token that can be passed in as the auth header */
  AccessToken?: Maybe<Scalars['String']>;
  /** Indicates if the Authentication succeeded or the reason for failure */
  AuthError?: Maybe<LoginV3AuthError>;
  /** Additional information on why the login failed */
  AuthMessage?: Maybe<Scalars['String']>;
  /** If the login has succeeded */
  AuthSucceeded: Scalars['Boolean'];
  /**
   * This is set only when login fails due to missing two factor token.
   * It indicates whether this profile can use the trusted device feature
   */
  CanUseTrustedDevice?: Maybe<Scalars['Boolean']>;
  IsUsingGoogleAuth: Scalars['Boolean'];
  /** The trusted device token if trusted device has been requested */
  TrustedDeviceToken?: Maybe<Scalars['String']>;
  /** Information about the just logged in user */
  UserSession?: Maybe<UserSession>;
};

export enum LoginV3AuthError {
  /** The username or password is invalid */
  Invalidcredentials = 'INVALIDCREDENTIALS',
  /** An MFA token is required but has not been provided */
  Mfarequired = 'MFAREQUIRED',
  /** The provided MFA token is invalid */
  Mfatokeninvalid = 'MFATOKENINVALID',
  /** The provided new password is invalid. Check the AuthErrorDescription field for more information */
  Newpasswordinvalid = 'NEWPASSWORDINVALID',
  /** The password has expired */
  Passwordexpired = 'PASSWORDEXPIRED',
  /** User logged in with a temp password and must change their password before proceeding. Provide a value to NewPassword field */
  Requirepasswordchange = 'REQUIREPASSWORDCHANGE'
}

export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** @deprecated Refer to errors response object instead */
  Code?: Maybe<Scalars['String']>;
  /** @deprecated Refer to errors response object instead */
  Message?: Maybe<Scalars['String']>;
  /** @deprecated Refer to errors response object instead */
  Success: Scalars['Boolean'];
};

export type LookBackDaysInput = {
  Days?: InputMaybe<Scalars['Decimal']>;
};

export type MfaType = {
  __typename?: 'MfaType';
  IsEmailTransport: Scalars['Boolean'];
  IsSmsTransport: Scalars['Boolean'];
  Name?: Maybe<Scalars['String']>;
};

export type Money = {
  __typename?: 'Money';
  Amount: Scalars['Decimal'];
  CurrencyCode?: Maybe<Scalars['String']>;
};

export enum MultiFactorResult {
  /** Supplied mfa request is incorrect, expired, or otherwise invalid */
  Invalid = 'INVALID',
  /** Mfa is not enabled for this profile */
  Notenabled = 'NOTENABLED',
  /** Mfa succeeded */
  Success = 'SUCCESS'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Records that the user has accepted the terms and conditions */
  acceptTerms?: Maybe<AcceptTermsPayload>;
  acknowledgeUserNotification?: Maybe<UserNotificationInteraction>;
  activateCard?: Maybe<ActivateCardResponse>;
  /** Archive the specified SecureMessage */
  archiveSecureMessage?: Maybe<ArchiveSecureMessageResponse>;
  /** Attempt to apply a list of profile specific account Categorisation updates */
  assignAccountCategories?: Maybe<AssignAccountCategoriesResponse>;
  /** Creates a new BPAY transfer from a user's account */
  bpayTransferRequest?: Maybe<BpayTransferRequestResponse>;
  categoriseAccountTransactions?: Maybe<CategoriseAccountTransactionsResponse>;
  /** Attempt to apply a list of profile specific account Categorisation updates */
  categoriseProfileAccounts?: Maybe<CategoriseProfileAccountsResponse>;
  /** Updates the name of the user's account */
  changeAccountDescription?: Maybe<ChangeAccountDescriptionResponse>;
  changeCardPin?: Maybe<ChangeCardPinResponse>;
  /**
   * Change the password of the currently logged in user
   * This endpoint supports Two Factor Authorisation
   */
  changeCurrentUserPassword?: Maybe<ChangePasswordResponse>;
  changeElectronicCommsStatus?: Maybe<ChangeElectronicCommsStatusResponse>;
  changeMarketingCommsStatus?: Maybe<ChangeMarketingCommsStatusResponse>;
  /** Change the Status of an Indue Card */
  changePin?: Maybe<IndueCardChangeResponse>;
  /** Change the Pin for an Indue Card */
  changeStatus?: Maybe<IndueCardChangeResponse>;
  changeUsername?: Maybe<ChangeUsernameResponse>;
  /** Can be used to check if a MFA token is valid. MFA token can be requested by using the RequestMultiFactorAuthorisation mutation */
  checkMultiFactorAuthorisation?: Maybe<CheckMultiFactorAuthorisationResponse>;
  /** Closes all of the user's open sessions. Optionally can be used to close the current session as well */
  closeCurrentUserSessions?: Maybe<ForceCloseCurrentUserSessionsResponse>;
  /** Create a saved BPAY Biller for the user */
  createBpayBiller?: Maybe<CreateBpayBillerResponse>;
  /** Create an Indue Card */
  createCard?: Maybe<IndueCardCreateCardResponse>;
  /** Create a saved Pay Anyone Bank Account for the user */
  createPayAnyoneBankAccount?: Maybe<CreatePayAnyoneBankAccountResponse>;
  /** Deletes a user's saved BPAY biller */
  deleteBpayPartyBiller?: Maybe<DeleteBpayPartyBillerResponse>;
  /** Delete a bank account from the current user */
  deletePartyBankAccount?: Maybe<DeletePartyBankAccountResponse>;
  deleteProfileCustomAccountCategory?: Maybe<DeleteProfileCustomAccountCategoryResponse>;
  /** Disables authenticator for profile */
  disableProfileAuthenticator?: Maybe<DisableProfileAuthenticatorResponse>;
  /** Create a disbursement request and optionally allow the user to upload supporting documentation */
  disbursementRequest?: Maybe<DisbursementRequestResponse>;
  dismissNotification?: Maybe<DismissNotificationResult>;
  /** Enables authenticator for profile */
  enableProfileAuthenticator?: Maybe<EnableProfileAuthenticatorResponse>;
  /** Generate a secret for an authenticator */
  generateAuthSecret?: Maybe<GenerateAuthSecretResponse>;
  /** Activates an indue card and sets new pin */
  indueActivateCard?: Maybe<IndueCardActivateCardResponse>;
  /**
   * Logs in a user and if succesfull returns a http only authorization cookie.
   * This endpoint will automatically trigger the sending of a Two Factor Token if required.
   * The field Code of the response indicates whether login was successfull
   * * 499 - A Two Factor Token is required
   * * 498 - The supplied Two Factor Token is invalid
   * * Unauthorized - The username/password was incorrect or the account has been locked
   * * BadRequest - The temporary password has expired and a new temporary password must be requested
   * * 200 - The user has logged in successfully
   *
   * CanUseTrustedDevice indicates if the profile has the Trusted device feature enabled and is
   * only populated when the endpoint returns a 499 two factor token required response
   */
  login?: Maybe<LoginResponse>;
  /**
   * Used to retrieve a JWT access token and optionally a trusted device token.
   * The tokens will be returned as http only cookies as well as in the body of the response
   */
  loginV2?: Maybe<LoginV2Response>;
  /** Ends the user's current session. This should be called as the final part of any logout flow */
  logout?: Maybe<LogoutPayload>;
  /** Send Outgoing NPP Payment */
  nPPOutgoingPayment?: Maybe<NppOutgoingPaymentMutationResponse>;
  partyPersonalDetails?: Maybe<PartyPersonalDetailsResponse>;
  /** Update the account information associated with the specified PayID */
  payIDAccountUpdate?: Maybe<PayIdMutationResponse>;
  /** Deregister the specified PayID */
  payIDDeregistration?: Maybe<PayIdMutationResponse>;
  /** Disable the specified PayID */
  payIDDisable?: Maybe<PayIdMutationResponse>;
  /** Enable the specified PayID */
  payIDEnable?: Maybe<PayIdMutationResponse>;
  /** Update the name associated with the specified PayID */
  payIDNameUpdate?: Maybe<PayIdMutationResponse>;
  /** Register the specified PayID */
  payIDRegistration?: Maybe<PayIdMutationResponse>;
  provisionAppleWallet?: Maybe<IndueCardProvisionAppleWalletResponse>;
  provisionGooglePay?: Maybe<IndueCardProvisionGooglePayResponse>;
  /** Read the specified SecureMessage */
  readSecureMessage?: Maybe<ReadSecureMessageResponse>;
  /** Attempt to apply a list of profile specific account Categorisation updates */
  removeAccountFromCategory?: Maybe<RemoveAccountFromCategoryResponse>;
  /** Attempt to apply a list of profile specific account ordering updates */
  reorderProfileAccounts?: Maybe<ReorderProfileAccountsResponse>;
  requestInterInstrumentTransfer?: Maybe<RequestInterInstrumentTransferResponse>;
  /**
   * Request a new Two Factor Token. This endpoint can only be called by logged in users.
   * This should be called after an endpoint indicates that a two factor token is required
   */
  requestMultiFactorAuthorisation?: Maybe<RequestMultiFactorAuthorisationResponse>;
  /** Create a secure message */
  requestNewSecureMessage?: Maybe<RequestNewSecureMessageResponse>;
  /** Create a secure message */
  requestNewSecureReply?: Maybe<RequestNewSecureReplyResponse>;
  /**
   * If a user forgets their password they can request a password reset if it's been enabled
   * An email or SMS with their new login details will be sent to the user if the provided details are correct
   */
  requestPasswordReset?: Maybe<ResetPasswordResponse>;
  requestPayAnyoneTransfer?: Maybe<RequestPayAnyoneTransferResponse>;
  /**
   * Request a new Two Factor Token. This endpoint can only be called by logged in users.
   * This should be called after an endpoint indicates that a two factor token is required
   */
  requestTrustedDevice?: Maybe<RequestTrustedDeviceResponse>;
  setPartyPaymentLimit?: Maybe<PartyPaymentLimitResponse>;
  /** Stop a user's funds transfer that has not yet executed */
  stopPendingFundsTransfer?: Maybe<StopPendingFundsTransferResponse>;
  suspendCard?: Maybe<SuspendCardResponse>;
  /** Update the Name and optional ordering of the provided categories */
  updateProfileAccountCategories?: Maybe<UpdateProfileAccountCategoriesResponse>;
};


export type MutationAcknowledgeUserNotificationArgs = {
  input: AcknowledgedUserNotificationInput;
};


export type MutationActivateCardArgs = {
  input: ActivateCardInput;
};


export type MutationArchiveSecureMessageArgs = {
  input: ArchiveSecureMessageInput;
};


export type MutationAssignAccountCategoriesArgs = {
  input?: InputMaybe<AssignAccountCategoriesInput>;
};


export type MutationBpayTransferRequestArgs = {
  input: BpayTransferRequestInput;
};


export type MutationCategoriseAccountTransactionsArgs = {
  input?: InputMaybe<CategoriseAccountTransactionsInput>;
};


export type MutationCategoriseProfileAccountsArgs = {
  input?: InputMaybe<CategoriseProfileAccountsInput>;
};


export type MutationChangeAccountDescriptionArgs = {
  input: ChangeAccountDescriptionInput;
};


export type MutationChangeCardPinArgs = {
  input: ChangeCardPinInput;
};


export type MutationChangeCurrentUserPasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeElectronicCommsStatusArgs = {
  input: ChangeElectronicCommsStatusInput;
};


export type MutationChangeMarketingCommsStatusArgs = {
  input: ChangeMarketingCommsStatusInput;
};


export type MutationChangePinArgs = {
  input: IndueCardChangePinInput;
};


export type MutationChangeStatusArgs = {
  input: IndueCardChangeStatusInput;
};


export type MutationChangeUsernameArgs = {
  input: ChangeUsernameInput;
};


export type MutationCheckMultiFactorAuthorisationArgs = {
  input: CheckMultiFactorAuthorisationInput;
};


export type MutationCloseCurrentUserSessionsArgs = {
  input: ForceCloseCurrentUserSessionsInput;
};


export type MutationCreateBpayBillerArgs = {
  input: CreateBpayBillerInput;
};


export type MutationCreateCardArgs = {
  input: IndueCardCreateCardInput;
};


export type MutationCreatePayAnyoneBankAccountArgs = {
  input: CreatePayAnyoneBankAccountInput;
};


export type MutationDeleteBpayPartyBillerArgs = {
  input: DeleteBpayPartyBillerInput;
};


export type MutationDeletePartyBankAccountArgs = {
  input: DeletePartyBankAccountInput;
};


export type MutationDeleteProfileCustomAccountCategoryArgs = {
  input: DeleteProfileCustomAccountCategoryInput;
};


export type MutationDisableProfileAuthenticatorArgs = {
  input: DisableProfileAuthenticatorInput;
};


export type MutationDisbursementRequestArgs = {
  input: DisbursementRequestInput;
};


export type MutationDismissNotificationArgs = {
  NotificationId: Scalars['ID'];
};


export type MutationEnableProfileAuthenticatorArgs = {
  input: EnableProfileAuthenticatorInput;
};


export type MutationGenerateAuthSecretArgs = {
  input: GenerateAuthSecretInput;
};


export type MutationIndueActivateCardArgs = {
  input: IndueCardActivateCardInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginV2Args = {
  input: LoginV2Input;
};


export type MutationNPpOutgoingPaymentArgs = {
  input: NppOutgoingPaymentInput;
};


export type MutationPartyPersonalDetailsArgs = {
  input: PartyPersonalDetailsInput;
};


export type MutationPayIdAccountUpdateArgs = {
  input: PayIdAccountUpdateInput;
};


export type MutationPayIdDeregistrationArgs = {
  input: PayIdDeregistrationInput;
};


export type MutationPayIdDisableArgs = {
  input: PayIdDisableInput;
};


export type MutationPayIdEnableArgs = {
  input: PayIdEnableInput;
};


export type MutationPayIdNameUpdateArgs = {
  input: PayIdNameUpdateInput;
};


export type MutationPayIdRegistrationArgs = {
  input: PayIdRegistrationInput;
};


export type MutationProvisionAppleWalletArgs = {
  input: IndueCardProvisionAppleWalletInput;
};


export type MutationProvisionGooglePayArgs = {
  input: IndueCardProvisionGooglePayInput;
};


export type MutationReadSecureMessageArgs = {
  input: ReadSecureMessageInput;
};


export type MutationRemoveAccountFromCategoryArgs = {
  input?: InputMaybe<RemoveAccountFromCategoryInput>;
};


export type MutationReorderProfileAccountsArgs = {
  input?: InputMaybe<ReorderProfileAccountsInput>;
};


export type MutationRequestInterInstrumentTransferArgs = {
  input: RequestInterInstrumentTransferInput;
};


export type MutationRequestMultiFactorAuthorisationArgs = {
  input?: InputMaybe<RequestMultiFactorAuthorisationInput>;
};


export type MutationRequestNewSecureMessageArgs = {
  input: RequestNewSecureMessageInput;
};


export type MutationRequestNewSecureReplyArgs = {
  input: RequestNewSecureReplyInput;
};


export type MutationRequestPasswordResetArgs = {
  input: ResetPasswordInput;
};


export type MutationRequestPayAnyoneTransferArgs = {
  input: RequestPayAnyoneTransferInput;
};


export type MutationRequestTrustedDeviceArgs = {
  input: RequestTrustedDeviceInput;
};


export type MutationSetPartyPaymentLimitArgs = {
  input: PartyPaymentLimitInput;
};


export type MutationStopPendingFundsTransferArgs = {
  input: StopPendingFundsTransferInput;
};


export type MutationSuspendCardArgs = {
  input: SuspendCardInput;
};


export type MutationUpdateProfileAccountCategoriesArgs = {
  input?: InputMaybe<UpdateProfileAccountCategoriesInput>;
};

export type MutationResponse = {
  Code: Scalars['String'];
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
};

export type NppOutgoingPaymentInput = {
  /** The Capital AccountId for the payer, not required if PayIDFromId is supplied */
  AccountFromId?: InputMaybe<Scalars['Uuid']>;
  /** The payment amount */
  Amount: Scalars['Decimal'];
  /** The Capital PartyId for the payer, not required if PayIDFromId is supplied */
  PartyFromId?: InputMaybe<Scalars['Uuid']>;
  /** The NPPPayID Id for the from account, if this is not supplied both the AccountFromId and PartyFromId should be supplied */
  PayIDFromId?: InputMaybe<Scalars['Uuid']>;
  /** The PayID type, eg. EMAL or TELI */
  PayIDToType?: InputMaybe<NppPayIdType>;
  /** The PayID value, eg. email address or phone number */
  PayIDToValue?: InputMaybe<Scalars['String']>;
  /** If not using a PayID for the 'To' account then their BSB number should be supplied */
  PayToAccountBSB?: InputMaybe<Scalars['String']>;
  /** If not using a PayID for the 'To' account then their Account number should be supplied */
  PayToAccountNumber?: InputMaybe<Scalars['String']>;
  /** Indicates whether we are using a PayID or Account Number + BSB */
  UsePayIDTo: Scalars['Boolean'];
};

export type NppOutgoingPaymentMutationResponse = {
  __typename?: 'NPPOutgoingPaymentMutationResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum NppPayIdType {
  Aubn = 'AUBN',
  Emal = 'EMAL',
  Orgn = 'ORGN',
  Teli = 'TELI'
}

export enum NppStatusCode {
  Acti = 'ACTI',
  Disa = 'DISA',
  Dreg = 'DREG',
  Port = 'PORT'
}

export type NewBankAccountInput = {
  /** bank identifier for a new bank account. */
  NewBankAccountIdentifier?: InputMaybe<Scalars['String']>;
  /** bank account name for a new bank account. */
  NewBankAccountName?: InputMaybe<Scalars['String']>;
  /** bank account number for a new bank account. */
  NewBankAccountNumber?: InputMaybe<Scalars['String']>;
  /** a bank account suffix for a new bank account. */
  NewBankAccountSuffix?: InputMaybe<Scalars['String']>;
};

export type Note = {
  __typename?: 'Note';
  CreatedBy: Scalars['Uuid'];
  CreatedOn: Scalars['DateTime'];
  Id: Scalars['Uuid'];
  Party: Scalars['Uuid'];
  Text: Scalars['String'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type Party = {
  __typename?: 'Party';
  AcceptsAdvertising: Scalars['Boolean'];
  Addresses?: Maybe<Array<Maybe<GraphAssociatedAddress>>>;
  BpayBillerHistory?: Maybe<Array<Maybe<BpayBiller>>>;
  Contacts?: Maybe<Array<Maybe<GraphContact>>>;
  CustomFields?: Maybe<Array<Maybe<GraphCustomField>>>;
  Documents?: Maybe<Array<Maybe<PartyDocumentLink>>>;
  EntityType?: Maybe<Scalars['String']>;
  FirstName?: Maybe<Scalars['String']>;
  FullName?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
  KnownAs?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  MailingAddress?: Maybe<GraphAssociatedAddress>;
  OrganisationLegalName?: Maybe<Scalars['String']>;
  OrganisationName?: Maybe<Scalars['String']>;
  PartyBankAccounts?: Maybe<Array<Maybe<PartyBankAccount>>>;
  /** Number identifier of the Party */
  PartyNumber?: Maybe<Scalars['String']>;
  /** Preferred correspondance type. */
  PreferredCorrespondanceType?: Maybe<PreferredCorrespondanceType>;
  PreferredEmail?: Maybe<GraphContact>;
  PreferredPhone?: Maybe<GraphContact>;
  PreferredSms?: Maybe<GraphContact>;
  ResedentialAddress?: Maybe<GraphAssociatedAddress>;
  SearchName?: Maybe<Scalars['String']>;
};


export type PartyDocumentsArgs = {
  where?: InputMaybe<DocumentLinkFilterInput>;
};

export type PartyAccountAssociation = {
  __typename?: 'PartyAccountAssociation';
  /** Indicates whether the party is another type of association for the account other than borrower */
  IsNonBorrower: Scalars['Boolean'];
  /** Indicates whether the party is a primary borrower for the account */
  IsPrimaryBorrower: Scalars['Boolean'];
  /** Indicates whether the party is a secondary borrower for the account */
  IsSecondaryBorrower: Scalars['Boolean'];
  /** Indicates whether the primary borrower for the account has a non-closed card */
  PrimaryBorrowerHasCard: Scalars['Boolean'];
};

/** Input for querying the party associations for an account, supply either an Id or Number */
export type PartyAssociationByAccountInput = {
  /** Id of the account */
  Id?: InputMaybe<Scalars['String']>;
  /** Number of the account */
  Number?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type PartyBankAccount = {
  __typename?: 'PartyBankAccount';
  BankAccount?: Maybe<BankAccount>;
  Bpay: Scalars['Boolean'];
  Deleted: Scalars['Boolean'];
  Description?: Maybe<Scalars['String']>;
  DirectCredit: Scalars['Boolean'];
  DirectDebit: Scalars['Boolean'];
  Id: Scalars['Uuid'];
  IsPayWayCustomer: Scalars['Boolean'];
  IsUsedByTransfer: Scalars['Boolean'];
  PartyId: Scalars['Uuid'];
  PayAnyone: Scalars['Boolean'];
  Viewable?: Maybe<Scalars['Boolean']>;
};

export type PartyDocumentLink = {
  __typename?: 'PartyDocumentLink';
  /** the document. */
  Document?: Maybe<File>;
  Id: Scalars['Uuid'];
  /** Has this document link been removed */
  IsDeleted: Scalars['Boolean'];
};

export type PartyPaymentLimitInput = {
  /** The bpay limit */
  BpayLimit: Scalars['Decimal'];
  /** The date that the payment limit is valid to */
  EffectiveTo?: InputMaybe<Scalars['DateTime']>;
  /** The pay anyone limit */
  PayAnyoneLimit: Scalars['Decimal'];
  /** The redraw limit */
  RedrawLimit: Scalars['Decimal'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type PartyPaymentLimitResponse = {
  __typename?: 'PartyPaymentLimitResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type PartyPersonalDetailsInput = {
  PreferredCorrespondenceMethod?: InputMaybe<Scalars['String']>;
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type PartyPersonalDetailsResponse = {
  __typename?: 'PartyPersonalDetailsResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  PreferredCorrespondenceMethod?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type PasswordValidator = {
  __typename?: 'PasswordValidator';
  MinimumBaseSymbolCharacterCount: Scalars['Int'];
  MinimumExtendedSymbolCharacterCount: Scalars['Int'];
  MinimumLowerCaseCharacterCount: Scalars['Int'];
  MinimumNumberCharacterCount: Scalars['Int'];
  MinimumPasswordHistory: Scalars['Int'];
  MinimumPasswordLength: Scalars['Int'];
  MinimumUpperCaseCharacterCount: Scalars['Int'];
  ProhibitRepeatingAlphabetCharacters: Scalars['Boolean'];
  ProhibitRepeatingNumberCharacters: Scalars['Boolean'];
  ProhibitRepeatingSymbolCharacters: Scalars['Boolean'];
  ProhibitSequentialAlphabetCharacters: Scalars['Boolean'];
  ProhibitSequentialNumberCharacters: Scalars['Boolean'];
  RequireBaseSymbols: Scalars['Boolean'];
  RequireExtendedSymbols: Scalars['Boolean'];
  RequireLowerCaseCharacters: Scalars['Boolean'];
  RequireNumberCharacters: Scalars['Boolean'];
  RequireUpperCaseCharacters: Scalars['Boolean'];
};

export type PayId = {
  __typename?: 'PayID';
  Account: Account;
  AccountOwnerName?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
  PartyId: Scalars['Uuid'];
  PayIDName?: Maybe<Scalars['String']>;
  PayIDType: NppPayIdType;
  PayIDValue: Scalars['String'];
  Status: NppStatusCode;
  TermsAccepted: Scalars['Boolean'];
};

export type PayIdAccountUpdateInput = {
  /** The Capital Account number to be associated with the PayID */
  AccountNumber: Scalars['String'];
  /** The full legal name of the Account owner */
  AccountOwnerName: Scalars['String'];
  /** The Capital Id of the PayID to update */
  NPPPayId: Scalars['Uuid'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type PayIdAvailabilityInput = {
  /** The type of PayID used, eg. EMAL (email) or TELI (phone), etc. */
  PayIDType: NppPayIdType;
  /** The value of the PayID used, eg. an email address or phone number, etc. */
  PayIDValue: Scalars['String'];
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type PayIdAvailabilityResponse = {
  __typename?: 'PayIDAvailabilityResponse';
  Code?: Maybe<Scalars['String']>;
  /** Indicates if the requested Pay ID is available */
  IsAvailable: Scalars['Boolean'];
  Message?: Maybe<Scalars['String']>;
  /** Indicates when the Pay ID was previously registered if it has been registered before */
  RegisteredDate?: Maybe<Scalars['DateTime']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type PayIdDeregistrationInput = {
  /** The Capital Id of the PayID to deregister */
  NPPPayId: Scalars['Uuid'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type PayIdDisableInput = {
  /** The Capital Id of the PayID to disable */
  NPPPayId: Scalars['Uuid'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type PayIdEnableInput = {
  /** The Capital Id of the PayID to enable */
  NPPPayId: Scalars['Uuid'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type PayIdMutationResponse = {
  __typename?: 'PayIDMutationResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type PayIdNameUpdateInput = {
  /** The Capital Id of the PayID for name update */
  NPPPayId: Scalars['Uuid'];
  /** The Name that the PayID will be updated to */
  Name: Scalars['String'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type PayIdRegistrationInput = {
  /** The Capital Account Number to be associated with the PayID */
  AccountNumber?: InputMaybe<Scalars['String']>;
  /** The full legal name of the Account owner */
  AccountOwnerName?: InputMaybe<Scalars['String']>;
  /** The Name associated with the PayID */
  Name: Scalars['String'];
  /** The Capital Party Id to be associated with the PayID */
  PartyId: Scalars['Uuid'];
  /** The type of PayID to be used, eg. EMAL (email) or TELI (phone), etc. */
  PayIDType: NppPayIdType;
  /** The value of the PayID to be used, eg. an email address or phone number, etc. */
  PayIDValue: Scalars['String'];
  /** Indicates if the terms have been accepted */
  TermsAccepted: Scalars['Boolean'];
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type PayIdResolutionInput = {
  /** The type of PayID to resolve, eg. EMAL (email) or TELI (phone), etc. */
  PayIDType: NppPayIdType;
  /** The value of the PayID to resolve, eg. an email address or phone number, etc. */
  PayIDValue: Scalars['String'];
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type PayIdResolutionResponse = {
  __typename?: 'PayIDResolutionResponse';
  /** The Identification of the account associated with the PayID */
  AccountIdentification?: Maybe<Scalars['String']>;
  /** The Issuer of the account identification for the PayID */
  AccountIssuer?: Maybe<Scalars['String']>;
  /** The full legal name of the Account owner associated with the PayID */
  AccountOwnerName?: Maybe<Scalars['String']>;
  /** The Identification Scheme of the account associated with the PayID */
  AccountScheme?: Maybe<Scalars['String']>;
  /** The Servicer of the account associated with the PayID */
  AccountServicer?: Maybe<Scalars['String']>;
  Code?: Maybe<Scalars['String']>;
  /** The date that the PayID was last updated */
  LastUpdatedDate?: Maybe<Scalars['DateTime']>;
  Message?: Maybe<Scalars['String']>;
  /** The name associated with the resolved PayID */
  Name?: Maybe<Scalars['String']>;
  /** The type of the resolved PayID, eg. EMAL (email) or TELI (phone), etc. */
  PayIDType: NppPayIdType;
  /** The value of the resolved PayID, eg. an email address or phone number, etc. */
  PayIDValue?: Maybe<Scalars['String']>;
  /** The date that the PayID was first registered */
  RegisteredDate?: Maybe<Scalars['DateTime']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** How to Group values in a period eg available redraw over the next month by day. */
export enum Period {
  Day = 'DAY',
  Eachchange = 'EACHCHANGE',
  Month = 'MONTH',
  Single = 'SINGLE',
  Week = 'WEEK'
}

export enum PreferredContactTime {
  Afterhours = 'AFTERHOURS',
  Anytime = 'ANYTIME',
  Businesshours = 'BUSINESSHOURS',
  Morning = 'MORNING',
  Never = 'NEVER'
}

export enum PreferredCorrespondanceType {
  Email = 'EMAIL',
  Mail = 'MAIL',
  Phone = 'PHONE',
  Sms = 'SMS'
}

export enum PrivacyLevel {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

/** Profile Specific Category, Either Id or Name must be supplied */
export type ProfileAccountCategoryInput = {
  Id?: InputMaybe<Scalars['Uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Ordering?: InputMaybe<Scalars['Int']>;
};

export type ProfileAccountOrdering = {
  __typename?: 'ProfileAccountOrdering';
  Account?: Maybe<Account>;
  Id: Scalars['Uuid'];
  Ordering?: Maybe<Scalars['Int']>;
};

export type ProfileCategoryDeletionInput = {
  Id?: InputMaybe<Scalars['Uuid']>;
};

export type ProfileCustomCategory = {
  __typename?: 'ProfileCustomCategory';
  Accounts?: Maybe<Array<Maybe<Account>>>;
  Id: Scalars['Uuid'];
  Name?: Maybe<Scalars['String']>;
  Ordering?: Maybe<Scalars['Int']>;
};

/** Schema */
export type Query = {
  __typename?: 'Query';
  /** Get a user's account by it's ID or number */
  accountByIdOrNumber?: Maybe<Account>;
  /** Retrieve the redraw/payanyone limits for an account belonging to a user */
  accountLimits?: Maybe<Array<Maybe<EffectiveAccountLimit>>>;
  accountsTransferableByAccount?: Maybe<Array<Maybe<Account>>>;
  authorityOperateAccounts?: Maybe<Array<Maybe<Account>>>;
  /** Retrieve bank branch details by BSB */
  bankBranchLookup?: Maybe<BankBranch>;
  /** Retrieve BPAY Biller details by the biller code */
  bpayBiller?: Maybe<BpayBiller>;
  /** Validates a BPay Biller Code and CRN */
  bpayValidate?: Maybe<BpayValidatorResponse>;
  /** Retrieve Electronic Commumication Status details for PartyId */
  electronicComms?: Maybe<ElectronicCommsStatus>;
  /** The current users finance summary */
  financeSummary?: Maybe<FinanceSummary>;
  /** Gets the details of the IndueCard from the supplied CardId */
  indueCardDetails?: Maybe<IndueCard>;
  /** Gets the IndueCards for the supplied account and logged in party */
  indueCardsByAccount?: Maybe<Array<Maybe<IndueCard>>>;
  /** Retrieves the parent instrument by the account number or id */
  instrumentByAccount?: Maybe<Instrument>;
  /** Get details of a user's Instrument by ID or number */
  instrumentByIdOrNumber?: Maybe<Instrument>;
  localConfig: LocalConfig;
  /** Retrieves the party association for the current user to the account by the account number or id */
  partyAssociationByAccount?: Maybe<PartyAccountAssociation>;
  /** Retrieve the redraw/payanyone limits for an account belonging to a user */
  partyLimits?: Maybe<AccountLimit>;
  /** Gets the Password Validation rules for an application */
  passwordValidatorByApplication?: Maybe<PasswordValidator>;
  /** Checks if the specified PayID is available for registration */
  payIDAvailability?: Maybe<PayIdAvailabilityResponse>;
  /** Resolves information on the specific PayID if available */
  payIDResolution?: Maybe<PayIdResolutionResponse>;
  /** Will retrieve all Pay IDs associated with the logged on user's party */
  payIDsByParty?: Maybe<Array<Maybe<PayId>>>;
  /** Get a secure message item by ID */
  secureMessageById?: Maybe<SecureMessage>;
  /** Gets all secure message types */
  secureMessageTypes?: Maybe<Array<Maybe<SecureMessageType>>>;
  /** Get secure messages associated with the logged on user's profile */
  secureMessagesByParty?: Maybe<SecureMessageContext>;
  statementsByPartyId?: Maybe<Array<Maybe<StatementDocument>>>;
  /** Get To Do Item Types filtered by the provided parameters */
  toDoItemTypes?: Maybe<Array<Maybe<ToDoItemType>>>;
  /** Get a todo item by ID */
  todoItemById?: Maybe<ToDoItem>;
  /** Get all transaction categories. */
  transactionCategories?: Maybe<Array<Maybe<TransactionCategory>>>;
  /** Get Transactions on an Account */
  transactionsByAccount?: Maybe<ConnectionWithNodesOfGraphAccountTransaction>;
  transferAccountsByParty?: Maybe<Array<Maybe<TransferAccount>>>;
  userNotificationInteractions?: Maybe<ConnectionWithNodesOfGraphApplicationNotificationInteraction>;
  /** Retrieve upcoming fixed interest and interest only expiries */
  userNotifications?: Maybe<Array<Maybe<InterestConversionNotification>>>;
  /** Retrieve information about the current users session */
  userSession?: Maybe<UserSession>;
};


/** Schema */
export type QueryAccountByIdOrNumberArgs = {
  idOrNumber?: InputMaybe<Scalars['String']>;
};


/** Schema */
export type QueryAccountLimitsArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GroupedDateRangeInput>;
};


/** Schema */
export type QueryAccountsTransferableByAccountArgs = {
  input: AccountsTransferableByAccountInput;
};


/** Schema */
export type QueryAuthorityOperateAccountsArgs = {
  input?: InputMaybe<AuthorityOperateAccountsInput>;
};


/** Schema */
export type QueryBankBranchLookupArgs = {
  input: BankBranchDetailsInput;
};


/** Schema */
export type QueryBpayBillerArgs = {
  input: BpayBillerDetailsInput;
};


/** Schema */
export type QueryBpayValidateArgs = {
  input: BpayValidatorInput;
};


/** Schema */
export type QueryIndueCardDetailsArgs = {
  input: IndueCardDetailsInput;
};


/** Schema */
export type QueryIndueCardsByAccountArgs = {
  input: IndueCardsByAccountInput;
};


/** Schema */
export type QueryInstrumentByAccountArgs = {
  account: InstrumentByAccountInput;
};


/** Schema */
export type QueryInstrumentByIdOrNumberArgs = {
  idOrNumber?: InputMaybe<Scalars['String']>;
};


/** Schema */
export type QueryPartyAssociationByAccountArgs = {
  input: PartyAssociationByAccountInput;
};


/** Schema */
export type QueryPayIdAvailabilityArgs = {
  input: PayIdAvailabilityInput;
};


/** Schema */
export type QueryPayIdResolutionArgs = {
  input: PayIdResolutionInput;
};


/** Schema */
export type QuerySecureMessageByIdArgs = {
  id: Scalars['Uuid'];
};


/** Schema */
export type QueryToDoItemTypesArgs = {
  input: ToDoItemTypesInput;
};


/** Schema */
export type QueryTodoItemByIdArgs = {
  id: Scalars['Uuid'];
};


/** Schema */
export type QueryTransactionsByAccountArgs = {
  accountId: Scalars['Uuid'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** Schema */
export type QueryUserNotificationInteractionsArgs = {
  input?: InputMaybe<ApplicationNotificationsFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ReadSecureMessageInput = {
  /** The Capital Id of the SecureMessage to mark as read */
  SecureMessageId: Scalars['Uuid'];
};

export type ReadSecureMessageResponse = {
  __typename?: 'ReadSecureMessageResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Method to determine when to stop the recurrence */
export enum RecurrenceEndEnum {
  Bydate = 'BYDATE',
  Never = 'NEVER',
  Numberofocurrences = 'NUMBEROFOCURRENCES',
  Once = 'ONCE'
}

export type RemoveAccountFromCategoryInput = {
  AccountCategoriesToRemove: Array<CategoryToRemoveInput>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RemoveAccountFromCategoryResponse = {
  __typename?: 'RemoveAccountFromCategoryResponse';
  Code?: Maybe<Scalars['String']>;
  Failed?: Maybe<Array<Maybe<FailedRemoveAccountFromCategory>>>;
  Message?: Maybe<Scalars['String']>;
  RemovedCategories?: Maybe<Array<Maybe<AccountCategorisation>>>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ReorderProfileAccountsInput = {
  AccountOrdering: Array<SetAccountOrderingInput>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ReorderProfileAccountsResponse = {
  __typename?: 'ReorderProfileAccountsResponse';
  AppliedOrdering?: Maybe<Array<Maybe<ProfileAccountOrdering>>>;
  Code?: Maybe<Scalars['String']>;
  FailedOrdering?: Maybe<Array<Maybe<FailedAccountOrdering>>>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input for creating an inter instrument transfer */
export type RequestInterInstrumentTransferInput = {
  /** amount to transfer. */
  Amount: Scalars['Decimal'];
  /** description for the deposit transaction. */
  DepositDescription?: InputMaybe<Scalars['String']>;
  /** The date the recurrence will end on or after. */
  EndingOn?: InputMaybe<Scalars['DateTime']>;
  /**
   * frequency of any recurrences.
   * ONCE if no recurrences
   */
  Frequency: TaskFrequencyPeriod;
  /** GUID identifier of the internal instrument account to draw funds from. */
  FromAccountId: Scalars['Uuid'];
  /** number of repeats. */
  NumberOfTimesAmount?: InputMaybe<Scalars['Int']>;
  /** When the recurring transfer ends, ie Once, ByDate, Never, NumberOfOcurrences */
  RecurrenceEnd?: InputMaybe<RecurrenceEndEnum>;
  /** Date the transfer will begin */
  StartingOn: Scalars['DateTime'];
  /** GUID of the internal instrument account to deposit funds into. */
  ToAccountId: Scalars['Uuid'];
  /** description for the withdrawal transaction. */
  WithdrawalDescription?: InputMaybe<Scalars['String']>;
  /** Id of the Inter Instrument input to correlate with response */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RequestInterInstrumentTransferResponse = {
  __typename?: 'RequestInterInstrumentTransferResponse';
  Code?: Maybe<Scalars['String']>;
  FundsTransfer: FundsTransfer;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input to request to begin a new Multi Factor Authorisation */
export type RequestMultiFactorAuthorisationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RequestMultiFactorAuthorisationResponse = {
  __typename?: 'RequestMultiFactorAuthorisationResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input for creating a new secure message */
export type RequestNewSecureMessageInput = {
  /** The account attached to the TDI message. */
  AccountNumber?: InputMaybe<Scalars['String']>;
  /** The initially sent message. */
  Message: Scalars['String'];
  /** ToDoItemTypeId of the secure message. */
  ToDoItemTypeId: Scalars['Uuid'];
  /** Id of the secure message input to correlate with response */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RequestNewSecureMessageResponse = {
  __typename?: 'RequestNewSecureMessageResponse';
  Code?: Maybe<Scalars['String']>;
  GraphSecureMessage?: Maybe<SecureMessage>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input for creating a new secure message */
export type RequestNewSecureReplyInput = {
  /** Reply body of the secure message. */
  Body: Scalars['String'];
  /** The Id of the secure message being replied to */
  SecureMessageId: Scalars['String'];
  /** Id of the secure message input to correlate with response */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RequestNewSecureReplyResponse = {
  __typename?: 'RequestNewSecureReplyResponse';
  Code?: Maybe<Scalars['String']>;
  GraphSecureMessage?: Maybe<SecureMessage>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Request a new Pay Anyone transfer to be setup */
export type RequestPayAnyoneTransferInput = {
  /** GUID identifier of an instrument account for the transfer. */
  AccountId: Scalars['Uuid'];
  /** additional amount to apply on top of the installment amount. */
  AdditionalAmount?: InputMaybe<Scalars['Decimal']>;
  /** amount to transfer. */
  Amount: Scalars['Decimal'];
  /** The GUID identifier of the bank account the transfer will use. */
  BankAccountId?: InputMaybe<Scalars['Uuid']>;
  /** description for the deposit transaction. */
  DepositDescription?: InputMaybe<Scalars['String']>;
  /** The date the recurrence will end on or after. */
  EndingOn?: InputMaybe<Scalars['DateTime']>;
  /** whether the transfer is for a fixed amount. */
  FixedAmountOption?: InputMaybe<Scalars['Boolean']>;
  /**
   * frequency of any recurrences.
   * ONCE if no recurrences
   */
  Frequency: TaskFrequencyPeriod;
  /**
   * GUID identifier of the internal instrument account to draw funds from.
   * Required for Interaccount transfer
   * Required for Redraw - should be the same as AccountId
   */
  FromAccountId?: InputMaybe<Scalars['Uuid']>;
  /** whether the transfer is for the minimum installment. */
  MinimumAmount?: InputMaybe<Scalars['Boolean']>;
  /** whether the transfer is for the minimum installment plus an amount. */
  MinimumAmountPlus?: InputMaybe<Scalars['Boolean']>;
  NewBankAccount?: InputMaybe<NewBankAccountInput>;
  /** number of repeats. */
  NumberOfTimesAmount?: InputMaybe<Scalars['Int']>;
  /** percentage of installment amount. */
  PercentageOfInstalment?: InputMaybe<Scalars['Decimal']>;
  RecurrenceEnd?: InputMaybe<RecurrenceEndEnum>;
  /** Date the transfer will begin */
  StartingOn: Scalars['DateTime'];
  /**
   * GUID of the internal instrument account to deposit funds into.
   * Required for Direct Debit repayments
   */
  ToAccountId?: InputMaybe<Scalars['Uuid']>;
  /**
   * Id of the funds transfer type.
   * eg. Direct credit transfer type id.
   */
  TransferType: Scalars['Uuid'];
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  /**
   * whether the transfer will use the greater of the selected amount or the
   * installment amount in case of a change in installments.
   */
  UseGreaterOfInstalment?: InputMaybe<Scalars['Boolean']>;
  /** Indicate that the transfer will use real time payments (ie. NPP) */
  UseNPP?: InputMaybe<Scalars['Boolean']>;
  /** whether a new bank account is being used for a pay anyone transfer type. */
  UseNewBankAccount?: InputMaybe<Scalars['Boolean']>;
  /** whether the transfer will use a percentage of the installments. */
  UsePercentageOfInstalment?: InputMaybe<Scalars['Boolean']>;
  /** description for the withdrawal transaction. */
  WithdrawalDescription?: InputMaybe<Scalars['String']>;
  /** Id of the PayAnyone request to correlate with response */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RequestPayAnyoneTransferResponse = {
  __typename?: 'RequestPayAnyoneTransferResponse';
  Code?: Maybe<Scalars['String']>;
  FundsTransfer?: Maybe<FundsTransfer>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RequestTrustedDeviceInput = {
  /** Two Factor Token is required if MFA has been enabled otherwise can be left empty */
  TwoFactorToken?: InputMaybe<Scalars['String']>;
};

export type RequestTrustedDeviceResponse = {
  __typename?: 'RequestTrustedDeviceResponse';
  Token?: Maybe<Scalars['String']>;
};

export type ResetPasswordInput = {
  ContactDetails?: InputMaybe<Scalars['String']>;
  /** Method to receive new password 'email' or 'sms' */
  ResetMethod?: InputMaybe<Scalars['String']>;
  TwoFactorToken?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  Code?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SecureMessage = {
  __typename?: 'SecureMessage';
  DateArchived?: Maybe<Scalars['DateTime']>;
  DateRead?: Maybe<Scalars['DateTime']>;
  DateReplied?: Maybe<Scalars['DateTime']>;
  Id: Scalars['Uuid'];
  IsArchived: Scalars['Boolean'];
  IsRead: Scalars['Boolean'];
  IsReplied: Scalars['Boolean'];
  ProfileId: Scalars['Uuid'];
  ShortDescription?: Maybe<Scalars['String']>;
  Subject?: Maybe<Scalars['String']>;
  ToDoItem: ToDoItem;
  Type?: Maybe<Scalars['String']>;
};

export type SecureMessageContext = {
  __typename?: 'SecureMessageContext';
  SecureMessages?: Maybe<Array<Maybe<SecureMessage>>>;
  /** The number of currently unread messages */
  UnreadMessageCount: Scalars['Decimal'];
};

export type SecureMessageType = {
  __typename?: 'SecureMessageType';
  Description: Scalars['String'];
  DisplayOrder: Scalars['Int'];
  Id: Scalars['Uuid'];
  IsAccount: Scalars['Boolean'];
  IsSystem: Scalars['Boolean'];
  Name: Scalars['String'];
};

/** Request to update the profile specific ordering of an Account */
export type SetAccountOrderingInput = {
  /** Account to Apply Ordering */
  AccountId: Scalars['Uuid'];
  /** Optional Id of an existing ordering entry to update, null or empty to update all orderings for this account */
  Id?: InputMaybe<Scalars['Uuid']>;
  /** User defined order for the account */
  Ordering?: InputMaybe<Scalars['Int']>;
};

/** Is a statement of account. */
export type StatementDocument = {
  __typename?: 'StatementDocument';
  /** object identifier of the linked account. */
  AccountId: Scalars['Uuid'];
  /** number of the linked account. */
  AccountNumber?: Maybe<Scalars['String']>;
  /** ad-hoc status of the statement. */
  AdHoc?: Maybe<Scalars['Boolean']>;
  /** who created the item. */
  CreatedByFullName?: Maybe<Scalars['String']>;
  /** work pool the creator is in. */
  CreatedByWorkpool?: Maybe<Scalars['String']>;
  /** date the entity was created. */
  CreatedOn?: Maybe<Scalars['DateTime']>;
  /** object identifier of the file. */
  FileId: Scalars['Uuid'];
  /** name of the imported statement file. */
  Filename?: Maybe<Scalars['String']>;
  /** whether the statement file has been attached. */
  HasFile?: Maybe<Scalars['Boolean']>;
  /** The database identifier of the record. */
  Id: Scalars['Uuid'];
  /** object identifier of the linked instrument. */
  InstrumentId: Scalars['Uuid'];
  /** number of the linked instrument. */
  InstrumentNumber?: Maybe<Scalars['String']>;
  IsCopied?: Maybe<Scalars['Boolean']>;
  /** if the record is to be deleted. */
  IsDeleted?: Maybe<Scalars['Boolean']>;
  IsExisting?: Maybe<Scalars['Boolean']>;
  /** if the record has been modified. */
  IsModified?: Maybe<Scalars['Boolean']>;
  /** if the record has been newly added. */
  IsNew?: Maybe<Scalars['Boolean']>;
  /** who last modified the entity. */
  ModifiedByFullName?: Maybe<Scalars['String']>;
  /** date the entity was last modified. */
  ModifiedOn?: Maybe<Scalars['DateTime']>;
  /** statement number. */
  Number?: Maybe<Scalars['String']>;
  /** object identifier of the addressee party. */
  PartyId: Scalars['Uuid'];
  /** name of the addressee party. */
  PartyName?: Maybe<Scalars['String']>;
  /** start date of the statement period. */
  PeriodFrom: Scalars['DateTime'];
  /** end date of the statement period. */
  PeriodTo: Scalars['DateTime'];
  /** date the statement was processed. */
  ProcessedDate: Scalars['DateTime'];
  /** CLR type of the DTO. */
  Type?: Maybe<Scalars['String']>;
};

export type StopPendingFundsTransferInput = {
  FundsTransferId: Scalars['Uuid'];
  StopOn?: InputMaybe<Scalars['DateTime']>;
  /** Id of the PayAnyone request to correlate with response */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type StopPendingFundsTransferResponse = {
  __typename?: 'StopPendingFundsTransferResponse';
  Code?: Maybe<Scalars['String']>;
  FundsTransfer?: Maybe<FundsTransfer>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type StringFilterInput = {
  /** Where is equal to enum */
  _eq?: InputMaybe<Scalars['String']>;
  /** Where enum is in list */
  _in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Where not equal to enum */
  _neq?: InputMaybe<Scalars['String']>;
};

export type SuspendCardInput = {
  CardId: Scalars['Uuid'];
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SuspendCardResponse = {
  __typename?: 'SuspendCardResponse';
  Code?: Maybe<Scalars['String']>;
  Data?: Maybe<Card>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum TaskFrequencyPeriod {
  Annually = 'ANNUALLY',
  Daily = 'DAILY',
  Dayofmonth = 'DAYOFMONTH',
  Firstofmonth = 'FIRSTOFMONTH',
  Fortnightly = 'FORTNIGHTLY',
  Lastofmonth = 'LASTOFMONTH',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Quarterly = 'QUARTERLY',
  Quarterlyfinancialyear = 'QUARTERLYFINANCIALYEAR',
  Schedule = 'SCHEDULE',
  Sixmonthly = 'SIXMONTHLY',
  Weekday = 'WEEKDAY',
  Weekly = 'WEEKLY'
}

export type ToDoItem = {
  __typename?: 'ToDoItem';
  AccountNumber?: Maybe<Scalars['String']>;
  Id: Scalars['Uuid'];
  Messages: Array<Note>;
  State: ToDoItemState;
  Text?: Maybe<Scalars['String']>;
  Type: ToDoItemType;
  WithId?: Maybe<Scalars['Uuid']>;
};

export enum ToDoItemState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Completedunsuccessfully = 'COMPLETEDUNSUCCESSFULLY',
  Created = 'CREATED',
  Suspended = 'SUSPENDED',
  Takenup = 'TAKENUP'
}

export type ToDoItemType = {
  __typename?: 'ToDoItemType';
  Description: Scalars['String'];
  Id: Scalars['Uuid'];
  SecureMessageType?: Maybe<SecureMessageType>;
};

export type ToDoItemTypesInput = {
  /** Provide to filter on whether to do item type is for secure messages */
  IsSecureMessage?: InputMaybe<Scalars['Boolean']>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Category for Account Transactions eg Visa Categories */
export type TransactionCategory = {
  __typename?: 'TransactionCategory';
  /** Category Code eg. Visa code */
  code?: Maybe<Scalars['String']>;
  /** Id of the category */
  id: Scalars['Uuid'];
  /** Human readable name */
  name?: Maybe<Scalars['String']>;
};

export type TransferAccount = {
  __typename?: 'TransferAccount';
  AccountCategory?: Maybe<Scalars['String']>;
  AccountId?: Maybe<Scalars['Uuid']>;
  AccountIsValidForNPP: Scalars['Boolean'];
  AccountName: Scalars['String'];
  AccountNumber?: Maybe<Scalars['String']>;
  AllowBPay: Scalars['Boolean'];
  AllowDirectDebit: Scalars['Boolean'];
  AllowInterAccount: Scalars['Boolean'];
  AllowOperate: Scalars['Boolean'];
  AllowPayAnyone: Scalars['Boolean'];
  AllowRead: Scalars['Boolean'];
  AllowRedraw: Scalars['Boolean'];
  BSB?: Maybe<Scalars['String']>;
  BillerCode?: Maybe<Scalars['Long']>;
  CapitalAccountNumber?: Maybe<Array<Maybe<Scalars['String']>>>;
  FunderAllowsNPP: Scalars['Boolean'];
  InstrumentId?: Maybe<Scalars['Uuid']>;
  IsBPay: Scalars['Boolean'];
  IsBankAccount: Scalars['Boolean'];
  IsDirectCredit: Scalars['Boolean'];
  IsDirectDebit: Scalars['Boolean'];
  IsExternal: Scalars['Boolean'];
  IsNominatedAccount: Scalars['Boolean'];
  MinimumDirectDebitDate?: Maybe<Scalars['DateTime']>;
  RedrawBalance?: Maybe<Scalars['Decimal']>;
};

export type UpdateProfileAccountCategoriesInput = {
  /** User defined order for the account */
  Updates: Array<ProfileAccountCategoryInput>;
  /**
   * Relay Spec https://facebook.github.io/relay/graphql/mutations.htm
   * enforced camelCase to match spec
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateProfileAccountCategoriesResponse = {
  __typename?: 'UpdateProfileAccountCategoriesResponse';
  Code?: Maybe<Scalars['String']>;
  Failed?: Maybe<Array<Maybe<FailedCategory>>>;
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  Updated?: Maybe<Array<Maybe<ProfileCustomCategory>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  /** Text body to display */
  Body?: Maybe<Scalars['String']>;
  /** Can the notification be dismissed */
  Dismissable: Scalars['Boolean'];
  /** When the notification is shown from. */
  EffectiveFrom: Scalars['DateTime'];
  /** When the notification is shown until. */
  EffectiveTo?: Maybe<Scalars['DateTime']>;
  /** Is this notification enabled */
  Enabled: Scalars['Boolean'];
  /** Category of the Notification */
  UserNotificationType?: Maybe<UserNotificationType>;
};

export type UserNotificationInteraction = {
  __typename?: 'UserNotificationInteraction';
  /** When the Notification was dismissed or acknowledged */
  Dismissed?: Maybe<Scalars['DateTime']>;
  Id: Scalars['Uuid'];
  Notification?: Maybe<UserNotification>;
  /** When the notification was first viewed by / delivered */
  Viewed?: Maybe<Scalars['DateTime']>;
};

export type UserNotificationType = {
  __typename?: 'UserNotificationType';
  /** Short code to reference the type */
  Code?: Maybe<Scalars['String']>;
  /** Description of the type */
  Description?: Maybe<Scalars['String']>;
};

export type UserSession = {
  __typename?: 'UserSession';
  /** Authorities on accounts for this profile */
  AccountAuthorities?: Maybe<Array<Maybe<AccountAuthority>>>;
  AccountCategorisation?: Maybe<Array<Maybe<AccountCategorisation>>>;
  /** The Accounts that have been ordered by this profile */
  AccountOrdering?: Maybe<Array<Maybe<ProfileAccountOrdering>>>;
  /** The maximum BPay payment limit allow for the application instance */
  BPayLimitMax: Scalars['Decimal'];
  /** Whether the user can use the Trusted Device feature */
  CanUseTrustedDevice: Scalars['Boolean'];
  CurrentServerTime: Scalars['DateTime'];
  CurrentSession?: Maybe<LoginAttempt>;
  Features?: Maybe<Array<Maybe<Scalars['String']>>>;
  FinanceSummary?: Maybe<FinanceSummary>;
  /** The profile has an active Temporary Password */
  HasTempPassword: Scalars['Boolean'];
  Id: Scalars['Uuid'];
  IsDeleted?: Maybe<Scalars['Boolean']>;
  IsFirstLogin?: Maybe<Scalars['Boolean']>;
  /** Whether InterInstrument Transfers are enabled */
  IsInterInstrumentTransferEnabled: Scalars['Boolean'];
  IsSharia?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the profile is using authentication, note that this can be Google Auth or any other authenticator. */
  IsUsingGoogleAuth: Scalars['Boolean'];
  LastLoginAttempt: Scalars['DateTime'];
  LastLoginFrom?: Maybe<Scalars['String']>;
  LastPasswordChange: Scalars['DateTime'];
  LastTermsAcceptance?: Maybe<Scalars['DateTime']>;
  LoginAttempts?: Maybe<Array<Maybe<LoginAttempt>>>;
  /** Indicates whether Multifactor authentication is enabled for the application instance */
  MFAEnforced: Scalars['Boolean'];
  /** The profiles MFAType, representing if SMS or email is selected for MFA. */
  MFAType?: Maybe<MfaType>;
  Notifications?: Maybe<Array<Maybe<InterestConversionNotification>>>;
  Party?: Maybe<Party>;
  /** Indicates whether payment limits are using the new method where linked to a party instead of profile */
  PartyPaymentLimitsEnabled: Scalars['Boolean'];
  /** The maximum pay anyone payment limit allow for the application instance */
  PayAnyoneLimitMax: Scalars['Decimal'];
  ProfileCustomCategories?: Maybe<Array<Maybe<ProfileCustomCategory>>>;
  /** The maximum redraw payment limit allow for the application instance */
  RedrawLimitMax: Scalars['Decimal'];
  /**
   * Whether the current session/device is considered a trusted device.
   * This is useful if you're storing your trusted device token in a http cookie and can't directly check if it's valid
   */
  TrustedDeviceInUse: Scalars['Boolean'];
  /** The number of currently unread messages */
  UnreadMessageCount: Scalars['Decimal'];
  /** The profile requires mfa / 2fa */
  UseMultiFactorAuth: Scalars['Boolean'];
};

export type ValueFilterOfFileTypeInput = {
  /** Where equal to value */
  _eq?: InputMaybe<FileType>;
  /** Where value is in list */
  _in?: InputMaybe<Array<FileType>>;
  /** Where not equal to value */
  _neq?: InputMaybe<FileType>;
};

export type ValueFilterOfGuidInput = {
  /** Where equal to value */
  _eq?: InputMaybe<Scalars['Uuid']>;
  /** Where value is in list */
  _in?: InputMaybe<Array<Scalars['Uuid']>>;
  /** Where not equal to value */
  _neq?: InputMaybe<Scalars['Uuid']>;
};

export type ValueFilterOfPrivacyLevelInput = {
  /** Where equal to value */
  _eq?: InputMaybe<PrivacyLevel>;
  /** Where value is in list */
  _in?: InputMaybe<Array<PrivacyLevel>>;
  /** Where not equal to value */
  _neq?: InputMaybe<PrivacyLevel>;
};

export type CurrentUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserNotificationsQuery = { __typename?: 'Query', userNotifications?: Array<{ __typename?: 'InterestConversionNotification', Id: any, ConversionType?: string | undefined, ConversionDate?: Date | undefined, NewInstalmentFrequency?: string | undefined, Dismissed?: boolean | undefined, Account?: { __typename?: 'Account', InstrumentId?: any | undefined, Number?: string | undefined, Id: any } | undefined, NewInstalmentAmount?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined } | undefined> | undefined };

export type AccountByIdOrNumberQueryVariables = Exact<{
  idOrNumber: Scalars['String'];
}>;


export type AccountByIdOrNumberQuery = { __typename?: 'Query', accountByIdOrNumber?: { __typename?: 'Account', Id: any, Number?: string | undefined, Description?: string | undefined, DisplayOrder?: number | undefined, InstrumentId?: any | undefined, LegacyNumber?: string | undefined, ProductType?: string | undefined, CurrentBalance?: number | undefined, Redraw?: number | undefined, ArrearsBalance?: number | undefined, InterestType?: string | undefined, CardAccount?: boolean | undefined, CardAvailable?: boolean | undefined, MonthlyInstalment?: number | undefined, NextInstalmentDue?: Date | undefined, OffsetAccount?: boolean | undefined, BpayNumber?: string | undefined, BillerCode?: string | undefined, Rate?: number | undefined, RemainingDisbursementAmount?: number | undefined, Transactions?: Array<{ __typename?: 'AccountTransaction', Id: any, SequenceNumber?: string | undefined, TransactionNumber?: string | undefined, Processed: Date, Effective: Date, EffectiveDate: Date, TransactionType?: string | undefined, StatementText?: string | undefined, Increase?: number | undefined, Decrease?: number | undefined, Balance?: number | undefined, Note?: string | undefined, WasReversed?: boolean | undefined, WasDishonoured?: boolean | undefined, WasBackedOut?: boolean | undefined, WasWaived?: boolean | undefined, AppearsOnStatement?: boolean | undefined, CreatedOn: Date, IsPending?: boolean | undefined } | undefined> | undefined, Statements?: Array<{ __typename?: 'StatementDocument', Id: any, Number?: string | undefined, InstrumentId: any, AccountNumber?: string | undefined, AccountId: any, PartyId: any, ProcessedDate: Date, PeriodFrom: Date, PeriodTo: Date, FileId: any, Filename?: string | undefined, Type?: string | undefined, AdHoc?: boolean | undefined } | undefined> | undefined, Cards?: Array<{ __typename?: 'Card', Id: any, Number?: string | undefined, HolderRelationship?: string | undefined, State?: string | undefined, ExpiryDate: Date, Type?: string | undefined, NameOnCard?: string | undefined } | undefined> | undefined, CurrentUserAccountAuthority?: { __typename?: 'AccountAuthority', Id: any, BPay: boolean, Operate: boolean, InterAccount: boolean, DirectDebit: boolean, PayAnyone: boolean, Redraw: boolean, View: boolean } | undefined } | undefined };

export type ChangeAccountDescriptionMutationVariables = Exact<{
  input: ChangeAccountDescriptionInput;
}>;


export type ChangeAccountDescriptionMutation = { __typename?: 'Mutation', changeAccountDescription?: { __typename?: 'ChangeAccountDescriptionResponse', Code?: string | undefined, Message?: string | undefined, Success: boolean, Data?: { __typename?: 'Account', Id: any, Description?: string | undefined } | undefined } | undefined };

export type InstrumentAuthorityAccountsQueryVariables = Exact<{
  account: Scalars['String'];
  date?: InputMaybe<Scalars['DateTime']>;
}>;


export type InstrumentAuthorityAccountsQuery = { __typename?: 'Query', instrumentByAccount?: { __typename?: 'Instrument', Id: any, Accounts?: Array<{ __typename?: 'Account', Id: any, Number?: string | undefined, Description?: string | undefined, Redraw?: number | undefined, CurrentBalance?: number | undefined, CurrentUserAccountAuthority?: { __typename?: 'AccountAuthority', Id: any, BPay: boolean, Operate: boolean, InterAccount: boolean, DirectDebit: boolean, PayAnyone: boolean, Redraw: boolean, View: boolean } | undefined } | undefined> | undefined } | undefined, accountLimits?: Array<{ __typename?: 'EffectiveAccountLimit', Id?: string | undefined, EffectiveDate: Date, Limits?: { __typename?: 'AccountLimit', DailyRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DailyBPayLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyBPayLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined } | undefined } | undefined> | undefined };

export type BpayBillerDetailsQueryVariables = Exact<{
  input: BpayBillerDetailsInput;
}>;


export type BpayBillerDetailsQuery = { __typename?: 'Query', bpayBiller?: { __typename?: 'BpayBiller', Id?: string | undefined, Billercode: any, BillerDescription?: string | undefined } | undefined };

export type BpayBillerHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type BpayBillerHistoryQuery = { __typename?: 'Query', userSession?: { __typename?: 'UserSession', Id: any, Party?: { __typename?: 'Party', Id: any, BpayBillerHistory?: Array<{ __typename?: 'BpayBiller', Id?: string | undefined, Billercode: any, BillerDescription?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, HasPendingTransfer?: boolean | undefined } | undefined> | undefined } | undefined } | undefined };

export type BpayTransferRequestMutationVariables = Exact<{
  input: BpayTransferRequestInput;
}>;


export type BpayTransferRequestMutation = { __typename?: 'Mutation', bpayTransferRequest?: { __typename?: 'BpayTransferRequestResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, clientMutationId?: string | undefined, FundsTransfer?: { __typename?: 'FundsTransfer', Id: any, ApplicationInstance?: string | undefined, ReceiptNumber?: string | undefined, AccountId?: any | undefined, TransferType?: any | undefined, TaskId?: any | undefined, TransferTypeDescription?: string | undefined, StartingOn?: Date | undefined, Frequency?: string | undefined, FurtherNotice?: boolean | undefined, EndingOn?: Date | undefined, FromAccountId?: any | undefined, FromAccountDescription?: string | undefined, ToAccountId?: any | undefined, ToAccountDescription?: string | undefined, Billercode?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, Amount?: number | undefined, RegularPayment?: boolean | undefined, NextScheduledDate?: Date | undefined, DepositDescription?: string | undefined, WithdrawalDescription?: string | undefined, NumberOfTimes?: boolean | undefined, SpecifiedDate?: boolean | undefined } | undefined, ValidationErrors?: Array<{ __typename?: 'ErrorMessage', Code?: string | undefined, Message?: string | undefined } | undefined> | undefined } | undefined };

export type StopPendingFundsTransferMutationVariables = Exact<{
  input: StopPendingFundsTransferInput;
}>;


export type StopPendingFundsTransferMutation = { __typename?: 'Mutation', stopPendingFundsTransfer?: { __typename?: 'StopPendingFundsTransferResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, clientMutationId?: string | undefined, FundsTransfer?: { __typename: 'FundsTransfer', Id: any, ApplicationInstance?: string | undefined, ReceiptNumber?: string | undefined, AccountId?: any | undefined, TransferType?: any | undefined, TaskId?: any | undefined, TransferTypeDescription?: string | undefined, StartingOn?: Date | undefined, Frequency?: string | undefined, FurtherNotice?: boolean | undefined, EndingOn?: Date | undefined, FromAccountId?: any | undefined, FromAccountDescription?: string | undefined, ToAccountId?: any | undefined, ToAccountDescription?: string | undefined, Billercode?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, Amount?: number | undefined, RegularPayment?: boolean | undefined, NextScheduledDate?: Date | undefined, DepositDescription?: string | undefined, WithdrawalDescription?: string | undefined, NumberOfTimes?: boolean | undefined, SpecifiedDate?: boolean | undefined } | undefined } | undefined };

export type CreateBpayBillerMutationVariables = Exact<{
  input: CreateBpayBillerInput;
}>;


export type CreateBpayBillerMutation = { __typename?: 'Mutation', createBpayBiller?: { __typename?: 'CreateBpayBillerResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, clientMutationId?: string | undefined, NewBpayBiller?: { __typename?: 'BpayBiller', Id?: string | undefined, Billercode: any, BillerDescription?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, HasPendingTransfer?: boolean | undefined } | undefined } | undefined };

export type DeleteBpayPartyBillerMutationVariables = Exact<{
  input: DeleteBpayPartyBillerInput;
}>;


export type DeleteBpayPartyBillerMutation = { __typename?: 'Mutation', deleteBpayPartyBiller?: { __typename?: 'DeleteBpayPartyBillerResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, clientMutationId?: string | undefined, PartyBillerHistoryId: any } | undefined };

export type BankBranchDetailsQueryVariables = Exact<{
  args: BankBranchDetailsInput;
}>;


export type BankBranchDetailsQuery = { __typename?: 'Query', bankBranchLookup?: { __typename?: 'BankBranch', BankIdentifier?: string | undefined, BankName?: string | undefined, Description?: string | undefined } | undefined };

export type TransferLimitValidationQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
}>;


export type TransferLimitValidationQuery = { __typename?: 'Query', accountLimits?: Array<{ __typename?: 'EffectiveAccountLimit', EffectiveDate: Date, Id?: string | undefined, Limits?: { __typename?: 'AccountLimit', RemainingDailyRedrawLimit?: { __typename?: 'Money', Amount: number, CurrencyCode?: string | undefined } | undefined, RemainingDailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyBPayLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined } | undefined } | undefined> | undefined, accountByIdOrNumber?: { __typename?: 'Account', Id: any, Redraw?: number | undefined } | undefined };

export type AccountFundsTransfersQueryVariables = Exact<{
  accountIdOrNumber: Scalars['String'];
  transactionFilter?: InputMaybe<LookBackDaysInput>;
}>;


export type AccountFundsTransfersQuery = { __typename?: 'Query', accountByIdOrNumber?: { __typename?: 'Account', Id: any, Number?: string | undefined, Description?: string | undefined, DisplayOrder?: number | undefined, InstrumentId?: any | undefined, LegacyNumber?: string | undefined, ProductType?: string | undefined, CurrentBalance?: number | undefined, Redraw?: number | undefined, InterestType?: string | undefined, CardAccount?: boolean | undefined, MonthlyInstalment?: number | undefined, NextInstalmentDue?: Date | undefined, PendingAccountFundsTransfers?: Array<{ __typename?: 'FundsTransfer', Id: any, ApplicationInstance?: string | undefined, ReceiptNumber?: string | undefined, AccountId?: any | undefined, TransferType?: any | undefined, TaskId?: any | undefined, TransferTypeDescription?: string | undefined, StartingOn?: Date | undefined, Frequency?: string | undefined, FurtherNotice?: boolean | undefined, EndingOn?: Date | undefined, FromAccountId?: any | undefined, FromAccountDescription?: string | undefined, ToAccountId?: any | undefined, ToAccountDescription?: string | undefined, Billercode?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, Amount?: number | undefined, RegularPayment?: boolean | undefined, NextScheduledDate?: Date | undefined, DepositDescription?: string | undefined, WithdrawalDescription?: string | undefined, NumberOfTimes?: boolean | undefined, NumberOfTimesAmount?: number | undefined, RemainingNumberOfTimes?: number | undefined, SpecifiedDate?: boolean | undefined, CreatedOn?: Date | undefined } | undefined> | undefined, ProcessedAccountFundsTransfers?: Array<{ __typename?: 'FundsTransfer', Id: any, ApplicationInstance?: string | undefined, ReceiptNumber?: string | undefined, AccountId?: any | undefined, TransferType?: any | undefined, TaskId?: any | undefined, TransferTypeDescription?: string | undefined, StartingOn?: Date | undefined, Frequency?: string | undefined, FurtherNotice?: boolean | undefined, EndingOn?: Date | undefined, FromAccountId?: any | undefined, FromAccountDescription?: string | undefined, ToAccountId?: any | undefined, ToAccountDescription?: string | undefined, Billercode?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, Amount?: number | undefined, RegularPayment?: boolean | undefined, NextScheduledDate?: Date | undefined, DepositDescription?: string | undefined, WithdrawalDescription?: string | undefined, NumberOfTimes?: boolean | undefined, NumberOfTimesAmount?: number | undefined, RemainingNumberOfTimes?: number | undefined, SpecifiedDate?: boolean | undefined, CreatedOn?: Date | undefined } | undefined> | undefined, BankAccounts?: Array<{ __typename?: 'BankAccount', AccountName?: string | undefined, Id: any, BankIdentifierText?: string | undefined, BankIdentifierId?: any | undefined, AccountNumber?: string | undefined, Suffix?: string | undefined, Nominated?: boolean | undefined, HasDirectDebitAuthority?: boolean | undefined, HasDirectCreditAuthority?: boolean | undefined, IsPayAnyone?: boolean | undefined, BankName?: string | undefined } | undefined> | undefined, AccountLimits?: Array<{ __typename?: 'EffectiveAccountLimit', Id?: string | undefined, EffectiveDate: Date, Limits?: { __typename?: 'AccountLimit', DailyRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined } | undefined } | undefined> | undefined, CurrentUserAccountAuthority?: { __typename?: 'AccountAuthority', Id: any, BPay: boolean, Operate: boolean, InterAccount: boolean, DirectDebit: boolean, PayAnyone: boolean, Redraw: boolean, View: boolean } | undefined } | undefined };

export type CreatePayAnyoneBankAccountMutationVariables = Exact<{
  input: CreatePayAnyoneBankAccountInput;
}>;


export type CreatePayAnyoneBankAccountMutation = { __typename?: 'Mutation', createPayAnyoneBankAccount?: { __typename?: 'CreatePayAnyoneBankAccountResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, clientMutationId?: string | undefined, NewPartyBankAccount?: { __typename?: 'PartyBankAccount', Id: any, Description?: string | undefined, DirectCredit: boolean, DirectDebit: boolean, IsUsedByTransfer: boolean, PartyId: any, PayAnyone: boolean, Viewable?: boolean | undefined, BankAccount?: { __typename?: 'BankAccount', Id: any, AccountName?: string | undefined, AccountNumber?: string | undefined, BankIdentifierText?: string | undefined, BankName?: string | undefined, HasDirectCreditAuthority?: boolean | undefined, HasDirectDebitAuthority?: boolean | undefined, IsPayAnyone?: boolean | undefined } | undefined } | undefined } | undefined };

export type CurrentUserPartyBankAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPartyBankAccountsQuery = { __typename?: 'Query', userSession?: { __typename?: 'UserSession', Id: any, Party?: { __typename?: 'Party', Id: any, PartyBankAccounts?: Array<{ __typename?: 'PartyBankAccount', Id: any, PartyId: any, Viewable?: boolean | undefined, PayAnyone: boolean, DirectCredit: boolean, DirectDebit: boolean, Bpay: boolean, Description?: string | undefined, Deleted: boolean, IsUsedByTransfer: boolean, IsPayWayCustomer: boolean, BankAccount?: { __typename?: 'BankAccount', AccountName?: string | undefined, BankIdentifierId?: any | undefined, BankIdentifierText?: string | undefined, AccountNumber?: string | undefined, Suffix?: string | undefined, Nominated?: boolean | undefined, HasDirectDebitAuthority?: boolean | undefined, HasDirectCreditAuthority?: boolean | undefined, IsPayAnyone?: boolean | undefined, BankName?: string | undefined, Id: any, HasPendingTransfer?: boolean | undefined } | undefined } | undefined> | undefined } | undefined } | undefined };

export type DeletePartyBankAccountMutationVariables = Exact<{
  input: DeletePartyBankAccountInput;
}>;


export type DeletePartyBankAccountMutation = { __typename?: 'Mutation', deletePartyBankAccount?: { __typename?: 'DeletePartyBankAccountResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, PartyBankAccountId: any } | undefined };

export type RequestPayAnyoneTransferMutationVariables = Exact<{
  input: RequestPayAnyoneTransferInput;
}>;


export type RequestPayAnyoneTransferMutation = { __typename?: 'Mutation', requestPayAnyoneTransfer?: { __typename?: 'RequestPayAnyoneTransferResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, clientMutationId?: string | undefined, FundsTransfer?: { __typename?: 'FundsTransfer', Id: any, ApplicationInstance?: string | undefined, ReceiptNumber?: string | undefined, AccountId?: any | undefined, TransferType?: any | undefined, TaskId?: any | undefined, TransferTypeDescription?: string | undefined, StartingOn?: Date | undefined, Frequency?: string | undefined, FurtherNotice?: boolean | undefined, EndingOn?: Date | undefined, FromAccountId?: any | undefined, FromAccountDescription?: string | undefined, ToAccountId?: any | undefined, ToAccountDescription?: string | undefined, Billercode?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, Amount?: number | undefined, RegularPayment?: boolean | undefined, NextScheduledDate?: Date | undefined, DepositDescription?: string | undefined, WithdrawalDescription?: string | undefined, NumberOfTimes?: boolean | undefined, SpecifiedDate?: boolean | undefined } | undefined } | undefined };

export type InstrumentByAccountIdQueryVariables = Exact<{
  account: Scalars['String'];
}>;


export type InstrumentByAccountIdQuery = { __typename?: 'Query', instrumentByAccount?: { __typename?: 'Instrument', Id: any, Accounts?: Array<{ __typename?: 'Account', Id: any, Number?: string | undefined, Description?: string | undefined, Redraw?: number | undefined, CurrentBalance?: number | undefined, ProductType?: string | undefined, CurrentUserAccountAuthority?: { __typename?: 'AccountAuthority', Id: any, BPay: boolean, Operate: boolean, InterAccount: boolean, DirectDebit: boolean, PayAnyone: boolean, Redraw: boolean, View: boolean } | undefined } | undefined> | undefined } | undefined };

export type AccountLimitQueryVariables = Exact<{
  accountId: Scalars['String'];
  date?: InputMaybe<Scalars['DateTime']>;
}>;


export type AccountLimitQuery = { __typename?: 'Query', accountLimits?: Array<{ __typename?: 'EffectiveAccountLimit', Id?: string | undefined, EffectiveDate: Date, Limits?: { __typename?: 'AccountLimit', DailyRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined } | undefined } | undefined> | undefined };

export type PartyPaymentLimitMutationVariables = Exact<{
  input: PartyPaymentLimitInput;
}>;


export type PartyPaymentLimitMutation = { __typename?: 'Mutation', setPartyPaymentLimit?: { __typename?: 'PartyPaymentLimitResponse', clientMutationId?: string | undefined, Code?: string | undefined, Message?: string | undefined, Success: boolean } | undefined };

export type RequestPayAnyoneTransferMutationMutationVariables = Exact<{
  input: RequestPayAnyoneTransferInput;
}>;


export type RequestPayAnyoneTransferMutationMutation = { __typename?: 'Mutation', requestPayAnyoneTransfer?: { __typename?: 'RequestPayAnyoneTransferResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, clientMutationId?: string | undefined, FundsTransfer?: { __typename?: 'FundsTransfer', Id: any, ApplicationInstance?: string | undefined, ReceiptNumber?: string | undefined, AccountId?: any | undefined, TransferType?: any | undefined, TaskId?: any | undefined, TransferTypeDescription?: string | undefined, StartingOn?: Date | undefined, Frequency?: string | undefined, FurtherNotice?: boolean | undefined, EndingOn?: Date | undefined, FromAccountId?: any | undefined, FromAccountDescription?: string | undefined, ToAccountId?: any | undefined, ToAccountDescription?: string | undefined, Billercode?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, Amount?: number | undefined, RegularPayment?: boolean | undefined, NextScheduledDate?: Date | undefined, DepositDescription?: string | undefined, WithdrawalDescription?: string | undefined, NumberOfTimes?: boolean | undefined, SpecifiedDate?: boolean | undefined } | undefined } | undefined };

export type UpdatePendingAccountFundsTransfersFragmentFragment = { __typename: 'Account', Id: any, PendingAccountFundsTransfers?: Array<{ __typename?: 'FundsTransfer', Id: any, ApplicationInstance?: string | undefined, ReceiptNumber?: string | undefined, AccountId?: any | undefined, TransferType?: any | undefined, TaskId?: any | undefined, TransferTypeDescription?: string | undefined, StartingOn?: Date | undefined, Frequency?: string | undefined, FurtherNotice?: boolean | undefined, EndingOn?: Date | undefined, FromAccountId?: any | undefined, FromAccountDescription?: string | undefined, ToAccountId?: any | undefined, ToAccountDescription?: string | undefined, Billercode?: string | undefined, BillerName?: string | undefined, CustomerReferenceNumber?: string | undefined, Amount?: number | undefined, RegularPayment?: boolean | undefined, NextScheduledDate?: Date | undefined, DepositDescription?: string | undefined, WithdrawalDescription?: string | undefined, NumberOfTimes?: boolean | undefined, SpecifiedDate?: boolean | undefined } | undefined> | undefined };

export type CloseOtherSessionsMutationVariables = Exact<{
  input: ForceCloseCurrentUserSessionsInput;
}>;


export type CloseOtherSessionsMutation = { __typename?: 'Mutation', closeCurrentUserSessions?: { __typename?: 'ForceCloseCurrentUserSessionsResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, clientMutationId?: string | undefined, Data?: { __typename?: 'UserSession', Id: any, Features?: Array<string | undefined> | undefined, CurrentServerTime: Date, LastLoginAttempt: Date, LastLoginFrom?: string | undefined, LastPasswordChange: Date, IsFirstLogin?: boolean | undefined, CurrentSession?: { __typename?: 'LoginAttempt', Id: any, IsDeleted?: boolean | undefined, LastActivity: Date, SessionStart: Date, EventDate: Date, IpAddress?: string | undefined, Successful?: boolean | undefined, ClientVersion?: string | undefined, UserAgentHeader?: string | undefined, Expires: Date } | undefined, LoginAttempts?: Array<{ __typename?: 'LoginAttempt', Id: any, EventDate: Date, IpAddress?: string | undefined, Successful?: boolean | undefined, ClientVersion?: string | undefined, UserAgentHeader?: string | undefined, IsDeleted?: boolean | undefined, LastActivity: Date, SessionStart: Date, Expires: Date } | undefined> | undefined } | undefined } | undefined };

export type ChangeCurrentUserPasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangeCurrentUserPasswordMutation = { __typename?: 'Mutation', changeCurrentUserPassword?: { __typename?: 'ChangePasswordResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined, UserSession?: { __typename?: 'UserSession', Id: any, Features?: Array<string | undefined> | undefined, CurrentServerTime: Date, LastLoginAttempt: Date, LastLoginFrom?: string | undefined, LastPasswordChange: Date, IsFirstLogin?: boolean | undefined, HasTempPassword: boolean, UseMultiFactorAuth: boolean, Party?: { __typename?: 'Party', Id: any, PartyNumber?: string | undefined, FullName?: string | undefined, OrganisationName?: string | undefined, FirstName?: string | undefined, LastName?: string | undefined } | undefined } | undefined } | undefined };

export type PasswordValidatorByApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type PasswordValidatorByApplicationQuery = { __typename?: 'Query', passwordValidatorByApplication?: { __typename?: 'PasswordValidator', MinimumPasswordLength: number, RequireLowerCaseCharacters: boolean, MinimumLowerCaseCharacterCount: number, RequireUpperCaseCharacters: boolean, MinimumUpperCaseCharacterCount: number, RequireNumberCharacters: boolean, MinimumNumberCharacterCount: number, RequireBaseSymbols: boolean, MinimumBaseSymbolCharacterCount: number, RequireExtendedSymbols: boolean, MinimumExtendedSymbolCharacterCount: number, ProhibitSequentialAlphabetCharacters: boolean, ProhibitSequentialNumberCharacters: boolean, ProhibitRepeatingAlphabetCharacters: boolean, ProhibitRepeatingNumberCharacters: boolean, ProhibitRepeatingSymbolCharacters: boolean, MinimumPasswordHistory: number } | undefined };

export type BankingUserLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type BankingUserLogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutPayload', Code?: string | undefined, Success: boolean, Message?: string | undefined } | undefined };

export type RequestPasswordResetMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'ResetPasswordResponse', Code?: string | undefined, Success: boolean, Message?: string | undefined } | undefined };

export type ArchiveSecureMessageMutationVariables = Exact<{
  input: ArchiveSecureMessageInput;
}>;


export type ArchiveSecureMessageMutation = { __typename?: 'Mutation', archiveSecureMessage?: { __typename?: 'ArchiveSecureMessageResponse', clientMutationId?: string | undefined, Code?: string | undefined, Message?: string | undefined, Success: boolean } | undefined };

export type ReadSecureMessageMutationVariables = Exact<{
  input: ReadSecureMessageInput;
}>;


export type ReadSecureMessageMutation = { __typename?: 'Mutation', readSecureMessage?: { __typename?: 'ReadSecureMessageResponse', clientMutationId?: string | undefined, Code?: string | undefined, Message?: string | undefined, Success: boolean } | undefined };

export type CreateNewSecureMessageMutationVariables = Exact<{
  input: RequestNewSecureMessageInput;
}>;


export type CreateNewSecureMessageMutation = { __typename?: 'Mutation', requestNewSecureMessage?: { __typename?: 'RequestNewSecureMessageResponse', Code?: string | undefined, clientMutationId?: string | undefined, Message?: string | undefined, Success: boolean, GraphSecureMessage?: { __typename?: 'SecureMessage', DateArchived?: Date | undefined, DateRead?: Date | undefined, DateReplied?: Date | undefined, Id: any, IsArchived: boolean, IsRead: boolean, IsReplied: boolean, ProfileId: any, ShortDescription?: string | undefined, Subject?: string | undefined, Type?: string | undefined, ToDoItem: { __typename?: 'ToDoItem', AccountNumber?: string | undefined, Id: any, State: ToDoItemState, Text?: string | undefined, WithId?: any | undefined, Messages: Array<{ __typename?: 'Note', CreatedBy: any, CreatedOn: Date, Id: any, Text: string, Party: any }>, Type: { __typename?: 'ToDoItemType', Id: any, Description: string, SecureMessageType?: { __typename?: 'SecureMessageType', Id: any, IsAccount: boolean, IsSystem: boolean, Description: string, DisplayOrder: number, Name: string } | undefined } } } | undefined } | undefined };

export type CreateNewSecureReplyMutationVariables = Exact<{
  input: RequestNewSecureReplyInput;
}>;


export type CreateNewSecureReplyMutation = { __typename?: 'Mutation', requestNewSecureReply?: { __typename?: 'RequestNewSecureReplyResponse', Code?: string | undefined, clientMutationId?: string | undefined, Message?: string | undefined, Success: boolean, GraphSecureMessage?: { __typename?: 'SecureMessage', DateArchived?: Date | undefined, DateRead?: Date | undefined, DateReplied?: Date | undefined, Id: any, IsArchived: boolean, IsRead: boolean, IsReplied: boolean, ProfileId: any, ShortDescription?: string | undefined, Subject?: string | undefined, ToDoItem: { __typename?: 'ToDoItem', AccountNumber?: string | undefined, Id: any, State: ToDoItemState, Text?: string | undefined, WithId?: any | undefined, Messages: Array<{ __typename?: 'Note', CreatedBy: any, CreatedOn: Date, Id: any, Text: string, Party: any }>, Type: { __typename?: 'ToDoItemType', Id: any, Description: string, SecureMessageType?: { __typename?: 'SecureMessageType', Id: any, IsAccount: boolean, IsSystem: boolean, Description: string, DisplayOrder: number, Name: string } | undefined } } } | undefined } | undefined };

export type SecureMessagesByPartyQueryVariables = Exact<{ [key: string]: never; }>;


export type SecureMessagesByPartyQuery = { __typename?: 'Query', secureMessagesByParty?: { __typename?: 'SecureMessageContext', UnreadMessageCount: number, SecureMessages?: Array<{ __typename?: 'SecureMessage', Id: any, ProfileId: any, IsArchived: boolean, DateArchived?: Date | undefined, IsRead: boolean, DateRead?: Date | undefined, IsReplied: boolean, DateReplied?: Date | undefined, Subject?: string | undefined, Type?: string | undefined, ShortDescription?: string | undefined, ToDoItem: { __typename?: 'ToDoItem', Id: any, WithId?: any | undefined, State: ToDoItemState, Text?: string | undefined, AccountNumber?: string | undefined, Messages: Array<{ __typename?: 'Note', Id: any, CreatedOn: Date, CreatedBy: any, Text: string, Party: any }>, Type: { __typename?: 'ToDoItemType', Id: any, Description: string, SecureMessageType?: { __typename?: 'SecureMessageType', Id: any, IsAccount: boolean, IsSystem: boolean, Description: string, DisplayOrder: number, Name: string } | undefined } } } | undefined> | undefined } | undefined };

export type UnreadMessagesCountByPartyQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadMessagesCountByPartyQuery = { __typename?: 'Query', secureMessagesByParty?: { __typename?: 'SecureMessageContext', UnreadMessageCount: number } | undefined };

export type AcceptTermsMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTermsMutation = { __typename?: 'Mutation', acceptTerms?: { __typename?: 'AcceptTermsPayload', Code?: string | undefined, Success: boolean, Message?: string | undefined, UserSession: { __typename?: 'UserSession', Id: any, LastTermsAcceptance?: Date | undefined } } | undefined };

export type BankingUserLoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type BankingUserLoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginResponse', Code?: string | undefined, Message?: string | undefined, Success: boolean, UserSession?: { __typename?: 'UserSession', Id: any, Features?: Array<string | undefined> | undefined, CurrentServerTime: Date, LastLoginAttempt: Date, LastLoginFrom?: string | undefined, LastPasswordChange: Date, IsFirstLogin?: boolean | undefined, IsSharia?: boolean | undefined, FinanceSummary?: { __typename?: 'FinanceSummary', Id: any } | undefined, Party?: { __typename?: 'Party', Id: any, PartyNumber?: string | undefined, FirstName?: string | undefined, LastName?: string | undefined, FullName?: string | undefined } | undefined } | undefined } | undefined };

export type BankingUserLoginV2MutationVariables = Exact<{
  input: LoginV2Input;
}>;


export type BankingUserLoginV2Mutation = { __typename?: 'Mutation', loginV2?: { __typename?: 'LoginV2Response', AccessToken?: string | undefined, TrustedDeviceToken?: string | undefined, CanUseTrustedDevice?: boolean | undefined, AuthMessage?: string | undefined, AuthError?: LoginV3AuthError | undefined, AuthSucceeded: boolean, IsUsingGoogleAuth: boolean, UserSession?: { __typename?: 'UserSession', Id: any, Features?: Array<string | undefined> | undefined, CurrentServerTime: Date, LastLoginAttempt: Date, LastLoginFrom?: string | undefined, LastPasswordChange: Date, IsFirstLogin?: boolean | undefined, IsSharia?: boolean | undefined, FinanceSummary?: { __typename?: 'FinanceSummary', Id: any } | undefined, Party?: { __typename?: 'Party', Id: any, PartyNumber?: string | undefined, FirstName?: string | undefined, LastName?: string | undefined, FullName?: string | undefined } | undefined } | undefined } | undefined };

export type DisableProfileAuthenticatorMutationVariables = Exact<{
  input: DisableProfileAuthenticatorInput;
}>;


export type DisableProfileAuthenticatorMutation = { __typename?: 'Mutation', disableProfileAuthenticator?: { __typename?: 'DisableProfileAuthenticatorResponse', clientMutationId?: string | undefined, Code?: string | undefined, Message?: string | undefined, Success: boolean } | undefined };

export type EnableProfileAuthenticatorMutationVariables = Exact<{
  input: EnableProfileAuthenticatorInput;
}>;


export type EnableProfileAuthenticatorMutation = { __typename?: 'Mutation', enableProfileAuthenticator?: { __typename?: 'EnableProfileAuthenticatorResponse', clientMutationId?: string | undefined, Code?: string | undefined, Message?: string | undefined, Success: boolean } | undefined };

export type GenerateAuthSecretMutationVariables = Exact<{
  input: GenerateAuthSecretInput;
}>;


export type GenerateAuthSecretMutation = { __typename?: 'Mutation', generateAuthSecret?: { __typename?: 'GenerateAuthSecretResponse', clientMutationId?: string | undefined, Code?: string | undefined, Message?: string | undefined, Success: boolean, AuthSecret?: string | undefined } | undefined };

export type IsUserAuthenticatedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsUserAuthenticatedQuery = { __typename?: 'Query', userSession?: { __typename?: 'UserSession', Id: any, Features?: Array<string | undefined> | undefined, CurrentServerTime: Date, LastLoginAttempt: Date, LastLoginFrom?: string | undefined, LastPasswordChange: Date, LastTermsAcceptance?: Date | undefined, IsFirstLogin?: boolean | undefined, HasTempPassword: boolean, UseMultiFactorAuth: boolean, IsUsingGoogleAuth: boolean, MFAEnforced: boolean, PartyPaymentLimitsEnabled: boolean, UnreadMessageCount: number, Party?: { __typename?: 'Party', Id: any, PartyNumber?: string | undefined, FullName?: string | undefined, OrganisationName?: string | undefined, FirstName?: string | undefined, LastName?: string | undefined, SearchName?: string | undefined, PreferredCorrespondanceType?: PreferredCorrespondanceType | undefined } | undefined, CurrentSession?: { __typename?: 'LoginAttempt', Id: any, IsDeleted?: boolean | undefined, LastActivity: Date, SessionStart: Date, Expires: Date, EventDate: Date, IpAddress?: string | undefined, Successful?: boolean | undefined, ClientVersion?: string | undefined, UserAgentHeader?: string | undefined } | undefined, LoginAttempts?: Array<{ __typename?: 'LoginAttempt', Id: any, IsDeleted?: boolean | undefined, LastActivity: Date, SessionStart: Date, Expires: Date, EventDate: Date, IpAddress?: string | undefined, Successful?: boolean | undefined, ClientVersion?: string | undefined, UserAgentHeader?: string | undefined } | undefined> | undefined } | undefined };

export type PartyChangeElectronicCommsStatusMutationVariables = Exact<{
  input: ChangeElectronicCommsStatusInput;
}>;


export type PartyChangeElectronicCommsStatusMutation = { __typename?: 'Mutation', changeElectronicCommsStatus?: { __typename?: 'ChangeElectronicCommsStatusResponse', clientMutationId?: string | undefined, Code?: string | undefined, Success: boolean, Message?: string | undefined, SMSNotificationStatus: boolean, EmailNotificationStatus: boolean, StatementNotificationStatus: boolean } | undefined };

export type PartyChangeMarketingCommsStatusMutationVariables = Exact<{
  input: ChangeMarketingCommsStatusInput;
}>;


export type PartyChangeMarketingCommsStatusMutation = { __typename?: 'Mutation', changeMarketingCommsStatus?: { __typename?: 'ChangeMarketingCommsStatusResponse', clientMutationId?: string | undefined, Code?: string | undefined, Success: boolean, Message?: string | undefined, MarketingStatus: boolean } | undefined };

export type PartyChangePersonalDetailsMutationVariables = Exact<{
  input: PartyPersonalDetailsInput;
}>;


export type PartyChangePersonalDetailsMutation = { __typename?: 'Mutation', partyPersonalDetails?: { __typename?: 'PartyPersonalDetailsResponse', clientMutationId?: string | undefined, Code?: string | undefined, Success: boolean, Message?: string | undefined, PreferredCorrespondenceMethod?: string | undefined } | undefined };

export type PartyElectronicCommsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type PartyElectronicCommsStatusQuery = { __typename?: 'Query', electronicComms?: { __typename?: 'ElectronicCommsStatus', SMSNotificationStatus: boolean, EmailNotificationStatus: boolean, StatementNotificationStatus: boolean } | undefined };

export type PartyProfileDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type PartyProfileDetailsQuery = { __typename?: 'Query', userSession?: { __typename?: 'UserSession', Id: any, IsDeleted?: boolean | undefined, LastLoginAttempt: Date, LastLoginFrom?: string | undefined, LastPasswordChange: Date, PartyPaymentLimitsEnabled: boolean, UseMultiFactorAuth: boolean, Party?: { __typename?: 'Party', AcceptsAdvertising: boolean, EntityType?: string | undefined, FirstName?: string | undefined, Id: any, LastName?: string | undefined, OrganisationName?: string | undefined, PartyNumber?: string | undefined, PreferredCorrespondanceType?: PreferredCorrespondanceType | undefined, Addresses?: Array<{ __typename?: 'GraphAssociatedAddress', Id: any, IsDefaultMailingAddress: boolean, IsDefaultResidentialAddress: boolean, IsDeleted: boolean, IsPrevious: boolean, Address?: { __typename?: 'Address', AddressDetailType: AddressDetailType, AddressLine1?: string | undefined, AddressLine2?: string | undefined, AddressLine3?: string | undefined, AddressLine4?: string | undefined, Building?: string | undefined, FloorName?: string | undefined, FloorNumber?: string | undefined, HasBeenVerified: boolean, Id: any, IsValid: boolean, LotNumber?: string | undefined, PostalBoxDetails?: string | undefined, PostalCode?: string | undefined, PropertyName?: string | undefined, StreetName?: string | undefined, StreetNumberFrom?: string | undefined, StreetNumberTo?: string | undefined, StreetType?: string | undefined, SuburbTown?: string | undefined, UnitNumber?: string | undefined, Country?: { __typename?: 'Country', Name?: string | undefined } | undefined, Region?: { __typename?: 'GeographicRegion', Abbreviation?: string | undefined, Name?: string | undefined } | undefined } | undefined } | undefined> | undefined, Contacts?: Array<{ __typename?: 'GraphContact', Details?: string | undefined, Id: any, IsDeleted: boolean, IsPreferredEmail: boolean, IsPreferredPhone: boolean, IsPreferredSms: boolean, Type?: { __typename?: 'GraphContactType', Description?: string | undefined, Id: any, IsPhone: boolean, ReceiveMessages: boolean } | undefined } | undefined> | undefined } | undefined } | undefined };

export type IndueCardActivateCardMutationVariables = Exact<{
  input: IndueCardActivateCardInput;
}>;


export type IndueCardActivateCardMutation = { __typename?: 'Mutation', indueActivateCard?: { __typename?: 'IndueCardActivateCardResponse', Result: boolean, Success: boolean, ActivateCardResult: boolean, ChangePinResult: boolean, Card?: { __typename?: 'IndueCard', Id: any, Status: IndueCardStatus } | undefined } | undefined };

export type IndueCardChangePinMutationVariables = Exact<{
  input: IndueCardChangePinInput;
}>;


export type IndueCardChangePinMutation = { __typename?: 'Mutation', changePin?: { __typename?: 'IndueCardChangeResponse', Result: boolean, Card: { __typename?: 'IndueCard', CardNumber?: string | undefined, ExpiryDate?: Date | undefined, Id: any, Status: IndueCardStatus } } | undefined };

export type IndueCardChangeStatusMutationVariables = Exact<{
  input: IndueCardChangeStatusInput;
}>;


export type IndueCardChangeStatusMutation = { __typename?: 'Mutation', changeStatus?: { __typename?: 'IndueCardChangeResponse', Result: boolean, Card: { __typename?: 'IndueCard', CardNumber?: string | undefined, ExpiryDate?: Date | undefined, Id: any, Status: IndueCardStatus } } | undefined };

export type IndueCardCreateCardMutationVariables = Exact<{
  input: IndueCardCreateCardInput;
}>;


export type IndueCardCreateCardMutation = { __typename?: 'Mutation', createCard?: { __typename?: 'IndueCardCreateCardResponse', Success: boolean, Code?: string | undefined, Message?: string | undefined, Card?: { __typename?: 'IndueCard', Id: any, Status: IndueCardStatus } | undefined } | undefined };

export type IndueCardDetailsQueryVariables = Exact<{
  input: IndueCardDetailsInput;
}>;


export type IndueCardDetailsQuery = { __typename?: 'Query', indueCardDetails?: { __typename?: 'IndueCard', CardNumber?: string | undefined, ExpiryDate?: Date | undefined, Id: any, Status: IndueCardStatus, CanActivate: boolean, CanHold: boolean, CanUnHold: boolean, CanReportLostStolen: boolean, CanClose: boolean } | undefined };

export type IndueCardsandAssociationsByAccountQueryVariables = Exact<{
  accountId: Scalars['Uuid'];
  accountIdString: Scalars['String'];
}>;


export type IndueCardsandAssociationsByAccountQuery = { __typename?: 'Query', indueCardsByAccount?: Array<{ __typename?: 'IndueCard', CardNumber?: string | undefined, ExpiryDate?: Date | undefined, Id: any, Status: IndueCardStatus, CanActivate: boolean, CanHold: boolean, CanUnHold: boolean, CanReportLostStolen: boolean, CanClose: boolean } | undefined> | undefined, partyAssociationByAccount?: { __typename?: 'PartyAccountAssociation', IsPrimaryBorrower: boolean, IsSecondaryBorrower: boolean, IsNonBorrower: boolean, PrimaryBorrowerHasCard: boolean } | undefined, accountByIdOrNumber?: { __typename?: 'Account', Id: any, CurrentUserAccountAuthority?: { __typename?: 'AccountAuthority', Id: any, BPay: boolean, Operate: boolean, InterAccount: boolean, DirectDebit: boolean, PayAnyone: boolean, Redraw: boolean, View: boolean } | undefined } | undefined };

export type IndueCardsByAccountQueryVariables = Exact<{
  input: IndueCardsByAccountInput;
}>;


export type IndueCardsByAccountQuery = { __typename?: 'Query', indueCardsByAccount?: Array<{ __typename?: 'IndueCard', CardNumber?: string | undefined, ExpiryDate?: Date | undefined, Id: any, Status: IndueCardStatus, CanActivate: boolean, CanHold: boolean, CanUnHold: boolean, CanReportLostStolen: boolean, CanClose: boolean } | undefined> | undefined };

export type PartyAssociationByAccountQueryVariables = Exact<{
  input: PartyAssociationByAccountInput;
}>;


export type PartyAssociationByAccountQuery = { __typename?: 'Query', partyAssociationByAccount?: { __typename?: 'PartyAccountAssociation', IsPrimaryBorrower: boolean, IsSecondaryBorrower: boolean, IsNonBorrower: boolean, PrimaryBorrowerHasCard: boolean } | undefined };

export type RequestNewMultiFactorSecurityTokenMutationVariables = Exact<{
  input: RequestMultiFactorAuthorisationInput;
}>;


export type RequestNewMultiFactorSecurityTokenMutation = { __typename?: 'Mutation', requestMultiFactorAuthorisation?: { __typename?: 'RequestMultiFactorAuthorisationResponse', clientMutationId?: string | undefined, Code?: string | undefined, Message?: string | undefined, Success: boolean } | undefined };

export type DisbursementRequestMutationVariables = Exact<{
  input: DisbursementRequestInput;
}>;


export type DisbursementRequestMutation = { __typename?: 'Mutation', disbursementRequest?: { __typename?: 'DisbursementRequestResponse', clientMutationId?: string | undefined, Code?: string | undefined, Success: boolean, Message?: string | undefined, Data?: { __typename?: 'DisbursementStage', Id: any, PayeeName?: string | undefined, BankIdentifierText?: string | undefined, AccountNumber?: string | undefined, PaymentDescription?: string | undefined, RequestedAmount: number, PaymentDate: Date, Documents?: Array<{ __typename?: 'File', Id: any, FileName?: string | undefined, Name?: string | undefined, CreatedOn: Date, DocumentType: FileType, IsDeleted: boolean, PrivacyLevel: PrivacyLevel } | undefined> | undefined } | undefined } | undefined };

export type FinanceSummaryQueryInlineQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceSummaryQueryInlineQuery = { __typename?: 'Query', financeSummary?: { __typename?: 'FinanceSummary', Id: any, TotalPrincipal?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, TotalRedraw?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, Instruments?: Array<{ __typename?: 'Instrument', Id: any, Number?: string | undefined, LoanPurpose?: string | undefined, Description?: string | undefined, TotalPrincipal?: number | undefined, TotalRedraw?: number | undefined, Status?: string | undefined, IsUnderHardshipAgreement?: boolean | undefined, InstrumentType?: string | undefined, Term?: number | undefined, TotalTermMonths?: any | undefined, RemainingTermMonths: any, MaturityDate?: Date | undefined, PrimaryBorrower?: string | undefined, Accounts?: Array<{ __typename?: 'Account', Id: any, Number?: string | undefined, Description?: string | undefined, DisplayOrder?: number | undefined, InstrumentId?: any | undefined, LegacyNumber?: string | undefined, ProductType?: string | undefined, CurrentBalance?: number | undefined, Redraw?: number | undefined, InterestType?: string | undefined, CardAccount?: boolean | undefined, RemainingDisbursementAmount?: number | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };

export type FinanceSummaryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceSummaryQueryQuery = { __typename?: 'Query', financeSummary?: { __typename?: 'FinanceSummary', TotalPrincipal?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, TotalRedraw?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, Instruments?: Array<{ __typename?: 'Instrument', Id: any, Number?: string | undefined, Description?: string | undefined, TotalPrincipal?: number | undefined, TotalRedraw?: number | undefined, Status?: string | undefined, IsUnderHardshipAgreement?: boolean | undefined, InstrumentType?: string | undefined, PrimaryBorrower?: string | undefined, Accounts?: Array<{ __typename?: 'Account', Id: any, Number?: string | undefined, Description?: string | undefined, DisplayOrder?: number | undefined, InstrumentId?: any | undefined, LegacyNumber?: string | undefined, ProductType?: string | undefined, CurrentBalance?: number | undefined, Redraw?: number | undefined, InterestType?: string | undefined, CardAccount?: boolean | undefined, RemainingDisbursementAmount?: number | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };

export type InstrumentByIdOrNumberQueryVariables = Exact<{
  idOrNumber: Scalars['String'];
}>;


export type InstrumentByIdOrNumberQuery = { __typename?: 'Query', instrumentByIdOrNumber?: { __typename?: 'Instrument', Id: any, Number?: string | undefined, LoanPurpose?: string | undefined, Description?: string | undefined, TotalPrincipal?: number | undefined, TotalRedraw?: number | undefined, Status?: string | undefined, IsUnderHardshipAgreement?: boolean | undefined, InstrumentType?: string | undefined, Term?: number | undefined, TotalTermMonths?: any | undefined, RemainingTermMonths: any, MaturityDate?: Date | undefined, RedrawConsideration?: string | undefined, PrimaryBorrower?: string | undefined, Accounts?: Array<{ __typename?: 'Account', Id: any, Number?: string | undefined, Description?: string | undefined, DisplayOrder?: number | undefined, InstrumentId?: any | undefined, LegacyNumber?: string | undefined, ProductType?: string | undefined, CurrentBalance?: number | undefined, Redraw?: number | undefined, InterestType?: string | undefined, CardAccount?: boolean | undefined, RedrawFlag?: boolean | undefined, OffsetAccount?: boolean | undefined, CardAvailable?: boolean | undefined } | undefined> | undefined } | undefined };

export type IsShariaQueryVariables = Exact<{ [key: string]: never; }>;


export type IsShariaQuery = { __typename?: 'Query', userSession?: { __typename?: 'UserSession', Id: any, IsSharia?: boolean | undefined } | undefined };

export type MaxLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type MaxLimitsQuery = { __typename?: 'Query', userSession?: { __typename?: 'UserSession', Id: any, RedrawLimitMax: number, PayAnyoneLimitMax: number, BPayLimitMax: number } | undefined };

export type PartyLimitQueryVariables = Exact<{ [key: string]: never; }>;


export type PartyLimitQuery = { __typename?: 'Query', partyLimits?: { __typename?: 'AccountLimit', LimitEffectiveTo?: Date | undefined, DailyRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DefaultRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyRedrawLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DefaultPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyPayAnyoneLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DailyBPayLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, DefaultBPayLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined, RemainingDailyBPayLimit?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined } | undefined };

export type SecureMessageTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SecureMessageTypesQuery = { __typename?: 'Query', secureMessageTypes?: Array<{ __typename?: 'SecureMessageType', Id: any, IsAccount: boolean, IsSystem: boolean, Name: string, Description: string, DisplayOrder: number } | undefined> | undefined };

export type StatementsByPartyIdQueryVariables = Exact<{ [key: string]: never; }>;


export type StatementsByPartyIdQuery = { __typename?: 'Query', statementsByPartyId?: Array<{ __typename?: 'StatementDocument', Id: any, AccountId: any, AccountNumber?: string | undefined, AdHoc?: boolean | undefined, CreatedOn?: Date | undefined, InstrumentId: any, Number?: string | undefined, PeriodFrom: Date, PeriodTo: Date, Filename?: string | undefined, FileId: any } | undefined> | undefined };

export type ToDoItemTypesQueryVariables = Exact<{
  input: ToDoItemTypesInput;
}>;


export type ToDoItemTypesQuery = { __typename?: 'Query', toDoItemTypes?: Array<{ __typename?: 'ToDoItemType', Id: any, Description: string, SecureMessageType?: { __typename?: 'SecureMessageType', Id: any, IsAccount: boolean, IsSystem: boolean, Description: string, DisplayOrder: number, Name: string } | undefined } | undefined> | undefined };

export type TransferAccountsByPartyQueryVariables = Exact<{ [key: string]: never; }>;


export type TransferAccountsByPartyQuery = { __typename?: 'Query', transferAccountsByParty?: Array<{ __typename?: 'TransferAccount', AccountId?: any | undefined, AccountCategory?: string | undefined, AccountName: string, AccountNumber?: string | undefined, BSB?: string | undefined, BillerCode?: any | undefined, RedrawBalance?: number | undefined, IsBankAccount: boolean, IsExternal: boolean, IsBPay: boolean, InstrumentId?: any | undefined, AllowRead: boolean, AllowOperate: boolean, AllowInterAccount: boolean, AllowDirectDebit: boolean, AllowBPay: boolean, AllowRedraw: boolean, AllowPayAnyone: boolean, CapitalAccountNumber?: Array<string | undefined> | undefined, IsDirectDebit: boolean, IsDirectCredit: boolean, FunderAllowsNPP: boolean, AccountIsValidForNPP: boolean, MinimumDirectDebitDate?: Date | undefined } | undefined> | undefined };

export type DismissNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID'];
}>;


export type DismissNotificationMutation = { __typename?: 'Mutation', dismissNotification?: { __typename?: 'DismissNotificationResult', Code: string, Success: boolean, Message?: string | undefined, Data?: { __typename?: 'InterestConversionNotification', Id: any, ConversionType?: string | undefined, ConversionDate?: Date | undefined, NewInstalmentFrequency?: string | undefined, Dismissed?: boolean | undefined, Account?: { __typename?: 'Account', InstrumentId?: any | undefined, Number?: string | undefined, Id: any } | undefined, NewInstalmentAmount?: { __typename?: 'Money', CurrencyCode?: string | undefined, Amount: number } | undefined } | undefined } | undefined };

export const UpdatePendingAccountFundsTransfersFragmentFragmentDoc = gql`
    fragment updatePendingAccountFundsTransfersFragment on Account {
  __typename
  Id
  PendingAccountFundsTransfers {
    Id
    ApplicationInstance
    ReceiptNumber
    AccountId
    TransferType
    TaskId
    TransferTypeDescription
    StartingOn
    Frequency
    FurtherNotice
    EndingOn
    FromAccountId
    FromAccountDescription
    ToAccountId
    ToAccountDescription
    Billercode
    BillerName
    CustomerReferenceNumber
    Amount
    RegularPayment
    NextScheduledDate
    DepositDescription
    WithdrawalDescription
    NumberOfTimes
    SpecifiedDate
  }
}
    `;
export const CurrentUserNotificationsDocument = gql`
    query currentUserNotifications {
  userNotifications {
    Id
    Account {
      InstrumentId
      Number
      Id
    }
    ConversionType
    ConversionDate
    NewInstalmentAmount {
      CurrencyCode
      Amount
    }
    NewInstalmentFrequency
    Dismissed @client
  }
}
    `;
export type CurrentUserNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>, 'query'>;

    export const CurrentUserNotificationsComponent = (props: CurrentUserNotificationsComponentProps) => (
      <ApolloReactComponents.Query<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables> query={CurrentUserNotificationsDocument} {...props} />
    );
    
export type CurrentUserNotificationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>
    } & TChildProps;
export function withCurrentUserNotifications<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentUserNotificationsQuery,
  CurrentUserNotificationsQueryVariables,
  CurrentUserNotificationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables, CurrentUserNotificationsProps<TChildProps, TDataName>>(CurrentUserNotificationsDocument, {
      alias: 'currentUserNotifications',
      ...operationOptions
    });
};

/**
 * __useCurrentUserNotificationsQuery__
 *
 * To run a query within a React component, call `useCurrentUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>(CurrentUserNotificationsDocument, options);
      }
export function useCurrentUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>(CurrentUserNotificationsDocument, options);
        }
export type CurrentUserNotificationsQueryHookResult = ReturnType<typeof useCurrentUserNotificationsQuery>;
export type CurrentUserNotificationsLazyQueryHookResult = ReturnType<typeof useCurrentUserNotificationsLazyQuery>;
export type CurrentUserNotificationsQueryResult = Apollo.QueryResult<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>;
export const AccountByIdOrNumberDocument = gql`
    query accountByIdOrNumber($idOrNumber: String!) {
  accountByIdOrNumber(idOrNumber: $idOrNumber) {
    Id
    Number
    Description
    DisplayOrder
    InstrumentId
    LegacyNumber
    ProductType
    CurrentBalance
    Redraw
    ArrearsBalance
    InterestType
    CardAccount
    CardAvailable
    MonthlyInstalment
    NextInstalmentDue
    OffsetAccount
    BpayNumber
    BillerCode
    Rate
    RemainingDisbursementAmount
    Transactions {
      Id
      SequenceNumber
      TransactionNumber
      Processed
      Effective
      EffectiveDate
      TransactionType
      StatementText
      Increase
      Decrease
      Balance
      Note
      WasReversed
      WasDishonoured
      WasBackedOut
      WasWaived
      AppearsOnStatement
      CreatedOn
      IsPending
    }
    Statements {
      Id
      Number
      InstrumentId
      AccountNumber
      AccountId
      PartyId
      ProcessedDate
      PeriodFrom
      PeriodTo
      FileId
      Filename
      Type
      AdHoc
    }
    Cards {
      Id
      Number
      HolderRelationship
      State
      ExpiryDate
      Type
      NameOnCard
    }
    CurrentUserAccountAuthority {
      Id
      BPay
      Operate
      InterAccount
      DirectDebit
      PayAnyone
      Redraw
      View
    }
  }
}
    `;
export type AccountByIdOrNumberComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables>, 'query'> & ({ variables: AccountByIdOrNumberQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountByIdOrNumberComponent = (props: AccountByIdOrNumberComponentProps) => (
      <ApolloReactComponents.Query<AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables> query={AccountByIdOrNumberDocument} {...props} />
    );
    
export type AccountByIdOrNumberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables>
    } & TChildProps;
export function withAccountByIdOrNumber<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountByIdOrNumberQuery,
  AccountByIdOrNumberQueryVariables,
  AccountByIdOrNumberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables, AccountByIdOrNumberProps<TChildProps, TDataName>>(AccountByIdOrNumberDocument, {
      alias: 'accountByIdOrNumber',
      ...operationOptions
    });
};

/**
 * __useAccountByIdOrNumberQuery__
 *
 * To run a query within a React component, call `useAccountByIdOrNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountByIdOrNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountByIdOrNumberQuery({
 *   variables: {
 *      idOrNumber: // value for 'idOrNumber'
 *   },
 * });
 */
export function useAccountByIdOrNumberQuery(baseOptions: Apollo.QueryHookOptions<AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables>(AccountByIdOrNumberDocument, options);
      }
export function useAccountByIdOrNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables>(AccountByIdOrNumberDocument, options);
        }
export type AccountByIdOrNumberQueryHookResult = ReturnType<typeof useAccountByIdOrNumberQuery>;
export type AccountByIdOrNumberLazyQueryHookResult = ReturnType<typeof useAccountByIdOrNumberLazyQuery>;
export type AccountByIdOrNumberQueryResult = Apollo.QueryResult<AccountByIdOrNumberQuery, AccountByIdOrNumberQueryVariables>;
export const ChangeAccountDescriptionDocument = gql`
    mutation changeAccountDescription($input: ChangeAccountDescriptionInput!) {
  changeAccountDescription(input: $input) {
    Code
    Message
    Success
    Data {
      Id
      Description
    }
  }
}
    `;
export type ChangeAccountDescriptionMutationFn = Apollo.MutationFunction<ChangeAccountDescriptionMutation, ChangeAccountDescriptionMutationVariables>;
export type ChangeAccountDescriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ChangeAccountDescriptionMutation, ChangeAccountDescriptionMutationVariables>, 'mutation'>;

    export const ChangeAccountDescriptionComponent = (props: ChangeAccountDescriptionComponentProps) => (
      <ApolloReactComponents.Mutation<ChangeAccountDescriptionMutation, ChangeAccountDescriptionMutationVariables> mutation={ChangeAccountDescriptionDocument} {...props} />
    );
    
export type ChangeAccountDescriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ChangeAccountDescriptionMutation, ChangeAccountDescriptionMutationVariables>
    } & TChildProps;
export function withChangeAccountDescription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ChangeAccountDescriptionMutation,
  ChangeAccountDescriptionMutationVariables,
  ChangeAccountDescriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ChangeAccountDescriptionMutation, ChangeAccountDescriptionMutationVariables, ChangeAccountDescriptionProps<TChildProps, TDataName>>(ChangeAccountDescriptionDocument, {
      alias: 'changeAccountDescription',
      ...operationOptions
    });
};

/**
 * __useChangeAccountDescriptionMutation__
 *
 * To run a mutation, you first call `useChangeAccountDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAccountDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAccountDescriptionMutation, { data, loading, error }] = useChangeAccountDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeAccountDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAccountDescriptionMutation, ChangeAccountDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAccountDescriptionMutation, ChangeAccountDescriptionMutationVariables>(ChangeAccountDescriptionDocument, options);
      }
export type ChangeAccountDescriptionMutationHookResult = ReturnType<typeof useChangeAccountDescriptionMutation>;
export type ChangeAccountDescriptionMutationResult = Apollo.MutationResult<ChangeAccountDescriptionMutation>;
export type ChangeAccountDescriptionMutationOptions = Apollo.BaseMutationOptions<ChangeAccountDescriptionMutation, ChangeAccountDescriptionMutationVariables>;
export const InstrumentAuthorityAccountsDocument = gql`
    query instrumentAuthorityAccounts($account: String!, $date: DateTime) {
  instrumentByAccount(account: {Id: $account}) {
    Id
    Accounts {
      Id
      Number
      Description
      Redraw
      CurrentBalance
      CurrentUserAccountAuthority {
        Id
        BPay
        Operate
        InterAccount
        DirectDebit
        PayAnyone
        Redraw
        View
      }
    }
  }
  accountLimits(
    accountId: $account
    filter: {DateRange: {From: $date, To: $date}}
  ) {
    Id
    EffectiveDate
    Limits {
      DailyRedrawLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyRedrawLimit {
        CurrencyCode
        Amount
      }
      DailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
      DailyBPayLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyBPayLimit {
        CurrencyCode
        Amount
      }
    }
  }
}
    `;
export type InstrumentAuthorityAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables>, 'query'> & ({ variables: InstrumentAuthorityAccountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InstrumentAuthorityAccountsComponent = (props: InstrumentAuthorityAccountsComponentProps) => (
      <ApolloReactComponents.Query<InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables> query={InstrumentAuthorityAccountsDocument} {...props} />
    );
    
export type InstrumentAuthorityAccountsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables>
    } & TChildProps;
export function withInstrumentAuthorityAccounts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InstrumentAuthorityAccountsQuery,
  InstrumentAuthorityAccountsQueryVariables,
  InstrumentAuthorityAccountsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables, InstrumentAuthorityAccountsProps<TChildProps, TDataName>>(InstrumentAuthorityAccountsDocument, {
      alias: 'instrumentAuthorityAccounts',
      ...operationOptions
    });
};

/**
 * __useInstrumentAuthorityAccountsQuery__
 *
 * To run a query within a React component, call `useInstrumentAuthorityAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentAuthorityAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentAuthorityAccountsQuery({
 *   variables: {
 *      account: // value for 'account'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useInstrumentAuthorityAccountsQuery(baseOptions: Apollo.QueryHookOptions<InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables>(InstrumentAuthorityAccountsDocument, options);
      }
export function useInstrumentAuthorityAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables>(InstrumentAuthorityAccountsDocument, options);
        }
export type InstrumentAuthorityAccountsQueryHookResult = ReturnType<typeof useInstrumentAuthorityAccountsQuery>;
export type InstrumentAuthorityAccountsLazyQueryHookResult = ReturnType<typeof useInstrumentAuthorityAccountsLazyQuery>;
export type InstrumentAuthorityAccountsQueryResult = Apollo.QueryResult<InstrumentAuthorityAccountsQuery, InstrumentAuthorityAccountsQueryVariables>;
export const BpayBillerDetailsDocument = gql`
    query BpayBillerDetails($input: BpayBillerDetailsInput!) {
  bpayBiller(input: $input) {
    Id
    Billercode
    BillerDescription
  }
}
    `;
export type BpayBillerDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables>, 'query'> & ({ variables: BpayBillerDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BpayBillerDetailsComponent = (props: BpayBillerDetailsComponentProps) => (
      <ApolloReactComponents.Query<BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables> query={BpayBillerDetailsDocument} {...props} />
    );
    
export type BpayBillerDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables>
    } & TChildProps;
export function withBpayBillerDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BpayBillerDetailsQuery,
  BpayBillerDetailsQueryVariables,
  BpayBillerDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables, BpayBillerDetailsProps<TChildProps, TDataName>>(BpayBillerDetailsDocument, {
      alias: 'bpayBillerDetails',
      ...operationOptions
    });
};

/**
 * __useBpayBillerDetailsQuery__
 *
 * To run a query within a React component, call `useBpayBillerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBpayBillerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBpayBillerDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBpayBillerDetailsQuery(baseOptions: Apollo.QueryHookOptions<BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables>(BpayBillerDetailsDocument, options);
      }
export function useBpayBillerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables>(BpayBillerDetailsDocument, options);
        }
export type BpayBillerDetailsQueryHookResult = ReturnType<typeof useBpayBillerDetailsQuery>;
export type BpayBillerDetailsLazyQueryHookResult = ReturnType<typeof useBpayBillerDetailsLazyQuery>;
export type BpayBillerDetailsQueryResult = Apollo.QueryResult<BpayBillerDetailsQuery, BpayBillerDetailsQueryVariables>;
export const BpayBillerHistoryDocument = gql`
    query bpayBillerHistory {
  userSession {
    Id
    Party {
      Id
      BpayBillerHistory {
        Id
        Billercode
        BillerDescription
        BillerName
        CustomerReferenceNumber
        HasPendingTransfer
      }
    }
  }
}
    `;
export type BpayBillerHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables>, 'query'>;

    export const BpayBillerHistoryComponent = (props: BpayBillerHistoryComponentProps) => (
      <ApolloReactComponents.Query<BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables> query={BpayBillerHistoryDocument} {...props} />
    );
    
export type BpayBillerHistoryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables>
    } & TChildProps;
export function withBpayBillerHistory<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BpayBillerHistoryQuery,
  BpayBillerHistoryQueryVariables,
  BpayBillerHistoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables, BpayBillerHistoryProps<TChildProps, TDataName>>(BpayBillerHistoryDocument, {
      alias: 'bpayBillerHistory',
      ...operationOptions
    });
};

/**
 * __useBpayBillerHistoryQuery__
 *
 * To run a query within a React component, call `useBpayBillerHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBpayBillerHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBpayBillerHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBpayBillerHistoryQuery(baseOptions?: Apollo.QueryHookOptions<BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables>(BpayBillerHistoryDocument, options);
      }
export function useBpayBillerHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables>(BpayBillerHistoryDocument, options);
        }
export type BpayBillerHistoryQueryHookResult = ReturnType<typeof useBpayBillerHistoryQuery>;
export type BpayBillerHistoryLazyQueryHookResult = ReturnType<typeof useBpayBillerHistoryLazyQuery>;
export type BpayBillerHistoryQueryResult = Apollo.QueryResult<BpayBillerHistoryQuery, BpayBillerHistoryQueryVariables>;
export const BpayTransferRequestDocument = gql`
    mutation bpayTransferRequest($input: BpayTransferRequestInput!) {
  bpayTransferRequest(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
    ValidationErrors {
      Code
      Message
    }
  }
}
    `;
export type BpayTransferRequestMutationFn = Apollo.MutationFunction<BpayTransferRequestMutation, BpayTransferRequestMutationVariables>;
export type BpayTransferRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BpayTransferRequestMutation, BpayTransferRequestMutationVariables>, 'mutation'>;

    export const BpayTransferRequestComponent = (props: BpayTransferRequestComponentProps) => (
      <ApolloReactComponents.Mutation<BpayTransferRequestMutation, BpayTransferRequestMutationVariables> mutation={BpayTransferRequestDocument} {...props} />
    );
    
export type BpayTransferRequestProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<BpayTransferRequestMutation, BpayTransferRequestMutationVariables>
    } & TChildProps;
export function withBpayTransferRequest<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BpayTransferRequestMutation,
  BpayTransferRequestMutationVariables,
  BpayTransferRequestProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, BpayTransferRequestMutation, BpayTransferRequestMutationVariables, BpayTransferRequestProps<TChildProps, TDataName>>(BpayTransferRequestDocument, {
      alias: 'bpayTransferRequest',
      ...operationOptions
    });
};

/**
 * __useBpayTransferRequestMutation__
 *
 * To run a mutation, you first call `useBpayTransferRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBpayTransferRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bpayTransferRequestMutation, { data, loading, error }] = useBpayTransferRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBpayTransferRequestMutation(baseOptions?: Apollo.MutationHookOptions<BpayTransferRequestMutation, BpayTransferRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BpayTransferRequestMutation, BpayTransferRequestMutationVariables>(BpayTransferRequestDocument, options);
      }
export type BpayTransferRequestMutationHookResult = ReturnType<typeof useBpayTransferRequestMutation>;
export type BpayTransferRequestMutationResult = Apollo.MutationResult<BpayTransferRequestMutation>;
export type BpayTransferRequestMutationOptions = Apollo.BaseMutationOptions<BpayTransferRequestMutation, BpayTransferRequestMutationVariables>;
export const StopPendingFundsTransferDocument = gql`
    mutation stopPendingFundsTransfer($input: StopPendingFundsTransferInput!) {
  stopPendingFundsTransfer(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      __typename
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
  }
}
    `;
export type StopPendingFundsTransferMutationFn = Apollo.MutationFunction<StopPendingFundsTransferMutation, StopPendingFundsTransferMutationVariables>;
export type StopPendingFundsTransferComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StopPendingFundsTransferMutation, StopPendingFundsTransferMutationVariables>, 'mutation'>;

    export const StopPendingFundsTransferComponent = (props: StopPendingFundsTransferComponentProps) => (
      <ApolloReactComponents.Mutation<StopPendingFundsTransferMutation, StopPendingFundsTransferMutationVariables> mutation={StopPendingFundsTransferDocument} {...props} />
    );
    
export type StopPendingFundsTransferProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<StopPendingFundsTransferMutation, StopPendingFundsTransferMutationVariables>
    } & TChildProps;
export function withStopPendingFundsTransfer<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StopPendingFundsTransferMutation,
  StopPendingFundsTransferMutationVariables,
  StopPendingFundsTransferProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, StopPendingFundsTransferMutation, StopPendingFundsTransferMutationVariables, StopPendingFundsTransferProps<TChildProps, TDataName>>(StopPendingFundsTransferDocument, {
      alias: 'stopPendingFundsTransfer',
      ...operationOptions
    });
};

/**
 * __useStopPendingFundsTransferMutation__
 *
 * To run a mutation, you first call `useStopPendingFundsTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopPendingFundsTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopPendingFundsTransferMutation, { data, loading, error }] = useStopPendingFundsTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStopPendingFundsTransferMutation(baseOptions?: Apollo.MutationHookOptions<StopPendingFundsTransferMutation, StopPendingFundsTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopPendingFundsTransferMutation, StopPendingFundsTransferMutationVariables>(StopPendingFundsTransferDocument, options);
      }
export type StopPendingFundsTransferMutationHookResult = ReturnType<typeof useStopPendingFundsTransferMutation>;
export type StopPendingFundsTransferMutationResult = Apollo.MutationResult<StopPendingFundsTransferMutation>;
export type StopPendingFundsTransferMutationOptions = Apollo.BaseMutationOptions<StopPendingFundsTransferMutation, StopPendingFundsTransferMutationVariables>;
export const CreateBpayBillerDocument = gql`
    mutation createBpayBiller($input: CreateBpayBillerInput!) {
  createBpayBiller(input: $input) {
    Code
    Success
    Message
    clientMutationId
    NewBpayBiller {
      Id
      Billercode
      BillerDescription
      BillerName
      CustomerReferenceNumber
      HasPendingTransfer
    }
  }
}
    `;
export type CreateBpayBillerMutationFn = Apollo.MutationFunction<CreateBpayBillerMutation, CreateBpayBillerMutationVariables>;
export type CreateBpayBillerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateBpayBillerMutation, CreateBpayBillerMutationVariables>, 'mutation'>;

    export const CreateBpayBillerComponent = (props: CreateBpayBillerComponentProps) => (
      <ApolloReactComponents.Mutation<CreateBpayBillerMutation, CreateBpayBillerMutationVariables> mutation={CreateBpayBillerDocument} {...props} />
    );
    
export type CreateBpayBillerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateBpayBillerMutation, CreateBpayBillerMutationVariables>
    } & TChildProps;
export function withCreateBpayBiller<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateBpayBillerMutation,
  CreateBpayBillerMutationVariables,
  CreateBpayBillerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateBpayBillerMutation, CreateBpayBillerMutationVariables, CreateBpayBillerProps<TChildProps, TDataName>>(CreateBpayBillerDocument, {
      alias: 'createBpayBiller',
      ...operationOptions
    });
};

/**
 * __useCreateBpayBillerMutation__
 *
 * To run a mutation, you first call `useCreateBpayBillerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBpayBillerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBpayBillerMutation, { data, loading, error }] = useCreateBpayBillerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBpayBillerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBpayBillerMutation, CreateBpayBillerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBpayBillerMutation, CreateBpayBillerMutationVariables>(CreateBpayBillerDocument, options);
      }
export type CreateBpayBillerMutationHookResult = ReturnType<typeof useCreateBpayBillerMutation>;
export type CreateBpayBillerMutationResult = Apollo.MutationResult<CreateBpayBillerMutation>;
export type CreateBpayBillerMutationOptions = Apollo.BaseMutationOptions<CreateBpayBillerMutation, CreateBpayBillerMutationVariables>;
export const DeleteBpayPartyBillerDocument = gql`
    mutation deleteBpayPartyBiller($input: DeleteBpayPartyBillerInput!) {
  deleteBpayPartyBiller(input: $input) {
    Code
    Success
    Message
    clientMutationId
    PartyBillerHistoryId
  }
}
    `;
export type DeleteBpayPartyBillerMutationFn = Apollo.MutationFunction<DeleteBpayPartyBillerMutation, DeleteBpayPartyBillerMutationVariables>;
export type DeleteBpayPartyBillerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteBpayPartyBillerMutation, DeleteBpayPartyBillerMutationVariables>, 'mutation'>;

    export const DeleteBpayPartyBillerComponent = (props: DeleteBpayPartyBillerComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteBpayPartyBillerMutation, DeleteBpayPartyBillerMutationVariables> mutation={DeleteBpayPartyBillerDocument} {...props} />
    );
    
export type DeleteBpayPartyBillerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteBpayPartyBillerMutation, DeleteBpayPartyBillerMutationVariables>
    } & TChildProps;
export function withDeleteBpayPartyBiller<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteBpayPartyBillerMutation,
  DeleteBpayPartyBillerMutationVariables,
  DeleteBpayPartyBillerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteBpayPartyBillerMutation, DeleteBpayPartyBillerMutationVariables, DeleteBpayPartyBillerProps<TChildProps, TDataName>>(DeleteBpayPartyBillerDocument, {
      alias: 'deleteBpayPartyBiller',
      ...operationOptions
    });
};

/**
 * __useDeleteBpayPartyBillerMutation__
 *
 * To run a mutation, you first call `useDeleteBpayPartyBillerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBpayPartyBillerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBpayPartyBillerMutation, { data, loading, error }] = useDeleteBpayPartyBillerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBpayPartyBillerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBpayPartyBillerMutation, DeleteBpayPartyBillerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBpayPartyBillerMutation, DeleteBpayPartyBillerMutationVariables>(DeleteBpayPartyBillerDocument, options);
      }
export type DeleteBpayPartyBillerMutationHookResult = ReturnType<typeof useDeleteBpayPartyBillerMutation>;
export type DeleteBpayPartyBillerMutationResult = Apollo.MutationResult<DeleteBpayPartyBillerMutation>;
export type DeleteBpayPartyBillerMutationOptions = Apollo.BaseMutationOptions<DeleteBpayPartyBillerMutation, DeleteBpayPartyBillerMutationVariables>;
export const BankBranchDetailsDocument = gql`
    query BankBranchDetails($args: BankBranchDetailsInput!) {
  bankBranchLookup(input: $args) {
    BankIdentifier
    BankName
    Description
  }
}
    `;
export type BankBranchDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BankBranchDetailsQuery, BankBranchDetailsQueryVariables>, 'query'> & ({ variables: BankBranchDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BankBranchDetailsComponent = (props: BankBranchDetailsComponentProps) => (
      <ApolloReactComponents.Query<BankBranchDetailsQuery, BankBranchDetailsQueryVariables> query={BankBranchDetailsDocument} {...props} />
    );
    
export type BankBranchDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BankBranchDetailsQuery, BankBranchDetailsQueryVariables>
    } & TChildProps;
export function withBankBranchDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BankBranchDetailsQuery,
  BankBranchDetailsQueryVariables,
  BankBranchDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BankBranchDetailsQuery, BankBranchDetailsQueryVariables, BankBranchDetailsProps<TChildProps, TDataName>>(BankBranchDetailsDocument, {
      alias: 'bankBranchDetails',
      ...operationOptions
    });
};

/**
 * __useBankBranchDetailsQuery__
 *
 * To run a query within a React component, call `useBankBranchDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankBranchDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankBranchDetailsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useBankBranchDetailsQuery(baseOptions: Apollo.QueryHookOptions<BankBranchDetailsQuery, BankBranchDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankBranchDetailsQuery, BankBranchDetailsQueryVariables>(BankBranchDetailsDocument, options);
      }
export function useBankBranchDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankBranchDetailsQuery, BankBranchDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankBranchDetailsQuery, BankBranchDetailsQueryVariables>(BankBranchDetailsDocument, options);
        }
export type BankBranchDetailsQueryHookResult = ReturnType<typeof useBankBranchDetailsQuery>;
export type BankBranchDetailsLazyQueryHookResult = ReturnType<typeof useBankBranchDetailsLazyQuery>;
export type BankBranchDetailsQueryResult = Apollo.QueryResult<BankBranchDetailsQuery, BankBranchDetailsQueryVariables>;
export const TransferLimitValidationDocument = gql`
    query transferLimitValidation($accountId: String, $date: DateTime) {
  accountLimits(
    accountId: $accountId
    filter: {DateRange: {From: $date, To: $date}}
  ) {
    EffectiveDate
    Id
    Limits {
      RemainingDailyRedrawLimit {
        Amount
        CurrencyCode
      }
      RemainingDailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyBPayLimit {
        CurrencyCode
        Amount
      }
    }
  }
  accountByIdOrNumber(idOrNumber: $accountId) {
    Id
    Redraw
  }
}
    `;
export type TransferLimitValidationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TransferLimitValidationQuery, TransferLimitValidationQueryVariables>, 'query'>;

    export const TransferLimitValidationComponent = (props: TransferLimitValidationComponentProps) => (
      <ApolloReactComponents.Query<TransferLimitValidationQuery, TransferLimitValidationQueryVariables> query={TransferLimitValidationDocument} {...props} />
    );
    
export type TransferLimitValidationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TransferLimitValidationQuery, TransferLimitValidationQueryVariables>
    } & TChildProps;
export function withTransferLimitValidation<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TransferLimitValidationQuery,
  TransferLimitValidationQueryVariables,
  TransferLimitValidationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TransferLimitValidationQuery, TransferLimitValidationQueryVariables, TransferLimitValidationProps<TChildProps, TDataName>>(TransferLimitValidationDocument, {
      alias: 'transferLimitValidation',
      ...operationOptions
    });
};

/**
 * __useTransferLimitValidationQuery__
 *
 * To run a query within a React component, call `useTransferLimitValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferLimitValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferLimitValidationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTransferLimitValidationQuery(baseOptions?: Apollo.QueryHookOptions<TransferLimitValidationQuery, TransferLimitValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferLimitValidationQuery, TransferLimitValidationQueryVariables>(TransferLimitValidationDocument, options);
      }
export function useTransferLimitValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferLimitValidationQuery, TransferLimitValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferLimitValidationQuery, TransferLimitValidationQueryVariables>(TransferLimitValidationDocument, options);
        }
export type TransferLimitValidationQueryHookResult = ReturnType<typeof useTransferLimitValidationQuery>;
export type TransferLimitValidationLazyQueryHookResult = ReturnType<typeof useTransferLimitValidationLazyQuery>;
export type TransferLimitValidationQueryResult = Apollo.QueryResult<TransferLimitValidationQuery, TransferLimitValidationQueryVariables>;
export const AccountFundsTransfersDocument = gql`
    query accountFundsTransfers($accountIdOrNumber: String!, $transactionFilter: LookBackDaysInput = {Days: 90}) {
  accountByIdOrNumber(idOrNumber: $accountIdOrNumber) {
    Id
    Number
    Description
    DisplayOrder
    InstrumentId
    LegacyNumber
    ProductType
    CurrentBalance
    Redraw
    InterestType
    CardAccount
    MonthlyInstalment
    NextInstalmentDue
    PendingAccountFundsTransfers {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      NumberOfTimesAmount
      RemainingNumberOfTimes
      SpecifiedDate
      CreatedOn
    }
    ProcessedAccountFundsTransfers(filter: $transactionFilter) {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      NumberOfTimesAmount
      RemainingNumberOfTimes
      SpecifiedDate
      CreatedOn
    }
    BankAccounts {
      AccountName
      Id
      BankIdentifierText
      BankIdentifierId
      AccountNumber
      Suffix
      Nominated
      HasDirectDebitAuthority
      HasDirectCreditAuthority
      IsPayAnyone
      BankName
    }
    AccountLimits {
      Id
      EffectiveDate
      Limits {
        DailyRedrawLimit {
          CurrencyCode
          Amount
        }
        RemainingDailyRedrawLimit {
          CurrencyCode
          Amount
        }
        DailyPayAnyoneLimit {
          CurrencyCode
          Amount
        }
        RemainingDailyPayAnyoneLimit {
          CurrencyCode
          Amount
        }
      }
    }
    CurrentUserAccountAuthority {
      Id
      BPay
      Operate
      InterAccount
      DirectDebit
      PayAnyone
      Redraw
      View
    }
  }
}
    `;
export type AccountFundsTransfersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables>, 'query'> & ({ variables: AccountFundsTransfersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountFundsTransfersComponent = (props: AccountFundsTransfersComponentProps) => (
      <ApolloReactComponents.Query<AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables> query={AccountFundsTransfersDocument} {...props} />
    );
    
export type AccountFundsTransfersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables>
    } & TChildProps;
export function withAccountFundsTransfers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountFundsTransfersQuery,
  AccountFundsTransfersQueryVariables,
  AccountFundsTransfersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables, AccountFundsTransfersProps<TChildProps, TDataName>>(AccountFundsTransfersDocument, {
      alias: 'accountFundsTransfers',
      ...operationOptions
    });
};

/**
 * __useAccountFundsTransfersQuery__
 *
 * To run a query within a React component, call `useAccountFundsTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountFundsTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountFundsTransfersQuery({
 *   variables: {
 *      accountIdOrNumber: // value for 'accountIdOrNumber'
 *      transactionFilter: // value for 'transactionFilter'
 *   },
 * });
 */
export function useAccountFundsTransfersQuery(baseOptions: Apollo.QueryHookOptions<AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables>(AccountFundsTransfersDocument, options);
      }
export function useAccountFundsTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables>(AccountFundsTransfersDocument, options);
        }
export type AccountFundsTransfersQueryHookResult = ReturnType<typeof useAccountFundsTransfersQuery>;
export type AccountFundsTransfersLazyQueryHookResult = ReturnType<typeof useAccountFundsTransfersLazyQuery>;
export type AccountFundsTransfersQueryResult = Apollo.QueryResult<AccountFundsTransfersQuery, AccountFundsTransfersQueryVariables>;
export const CreatePayAnyoneBankAccountDocument = gql`
    mutation createPayAnyoneBankAccount($input: CreatePayAnyoneBankAccountInput!) {
  createPayAnyoneBankAccount(input: $input) {
    Code
    Success
    Message
    clientMutationId
    NewPartyBankAccount {
      Id
      BankAccount {
        Id
        AccountName
        AccountNumber
        BankIdentifierText
        BankName
        HasDirectCreditAuthority
        HasDirectDebitAuthority
        IsPayAnyone
      }
      Description
      DirectCredit
      DirectDebit
      IsUsedByTransfer
      PartyId
      PayAnyone
      Viewable
    }
  }
}
    `;
export type CreatePayAnyoneBankAccountMutationFn = Apollo.MutationFunction<CreatePayAnyoneBankAccountMutation, CreatePayAnyoneBankAccountMutationVariables>;
export type CreatePayAnyoneBankAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreatePayAnyoneBankAccountMutation, CreatePayAnyoneBankAccountMutationVariables>, 'mutation'>;

    export const CreatePayAnyoneBankAccountComponent = (props: CreatePayAnyoneBankAccountComponentProps) => (
      <ApolloReactComponents.Mutation<CreatePayAnyoneBankAccountMutation, CreatePayAnyoneBankAccountMutationVariables> mutation={CreatePayAnyoneBankAccountDocument} {...props} />
    );
    
export type CreatePayAnyoneBankAccountProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreatePayAnyoneBankAccountMutation, CreatePayAnyoneBankAccountMutationVariables>
    } & TChildProps;
export function withCreatePayAnyoneBankAccount<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreatePayAnyoneBankAccountMutation,
  CreatePayAnyoneBankAccountMutationVariables,
  CreatePayAnyoneBankAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreatePayAnyoneBankAccountMutation, CreatePayAnyoneBankAccountMutationVariables, CreatePayAnyoneBankAccountProps<TChildProps, TDataName>>(CreatePayAnyoneBankAccountDocument, {
      alias: 'createPayAnyoneBankAccount',
      ...operationOptions
    });
};

/**
 * __useCreatePayAnyoneBankAccountMutation__
 *
 * To run a mutation, you first call `useCreatePayAnyoneBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayAnyoneBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayAnyoneBankAccountMutation, { data, loading, error }] = useCreatePayAnyoneBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayAnyoneBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayAnyoneBankAccountMutation, CreatePayAnyoneBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayAnyoneBankAccountMutation, CreatePayAnyoneBankAccountMutationVariables>(CreatePayAnyoneBankAccountDocument, options);
      }
export type CreatePayAnyoneBankAccountMutationHookResult = ReturnType<typeof useCreatePayAnyoneBankAccountMutation>;
export type CreatePayAnyoneBankAccountMutationResult = Apollo.MutationResult<CreatePayAnyoneBankAccountMutation>;
export type CreatePayAnyoneBankAccountMutationOptions = Apollo.BaseMutationOptions<CreatePayAnyoneBankAccountMutation, CreatePayAnyoneBankAccountMutationVariables>;
export const CurrentUserPartyBankAccountsDocument = gql`
    query currentUserPartyBankAccounts {
  userSession {
    Id
    Party {
      Id
      PartyBankAccounts {
        Id
        PartyId
        Viewable
        PayAnyone
        DirectCredit
        DirectDebit
        Bpay
        Description
        Deleted
        IsUsedByTransfer
        IsPayWayCustomer
        BankAccount {
          AccountName
          BankIdentifierId
          BankIdentifierText
          AccountNumber
          Suffix
          Nominated
          HasDirectDebitAuthority
          HasDirectCreditAuthority
          IsPayAnyone
          BankName
          Id
          HasPendingTransfer
        }
      }
    }
  }
}
    `;
export type CurrentUserPartyBankAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables>, 'query'>;

    export const CurrentUserPartyBankAccountsComponent = (props: CurrentUserPartyBankAccountsComponentProps) => (
      <ApolloReactComponents.Query<CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables> query={CurrentUserPartyBankAccountsDocument} {...props} />
    );
    
export type CurrentUserPartyBankAccountsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables>
    } & TChildProps;
export function withCurrentUserPartyBankAccounts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentUserPartyBankAccountsQuery,
  CurrentUserPartyBankAccountsQueryVariables,
  CurrentUserPartyBankAccountsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables, CurrentUserPartyBankAccountsProps<TChildProps, TDataName>>(CurrentUserPartyBankAccountsDocument, {
      alias: 'currentUserPartyBankAccounts',
      ...operationOptions
    });
};

/**
 * __useCurrentUserPartyBankAccountsQuery__
 *
 * To run a query within a React component, call `useCurrentUserPartyBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPartyBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPartyBankAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPartyBankAccountsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables>(CurrentUserPartyBankAccountsDocument, options);
      }
export function useCurrentUserPartyBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables>(CurrentUserPartyBankAccountsDocument, options);
        }
export type CurrentUserPartyBankAccountsQueryHookResult = ReturnType<typeof useCurrentUserPartyBankAccountsQuery>;
export type CurrentUserPartyBankAccountsLazyQueryHookResult = ReturnType<typeof useCurrentUserPartyBankAccountsLazyQuery>;
export type CurrentUserPartyBankAccountsQueryResult = Apollo.QueryResult<CurrentUserPartyBankAccountsQuery, CurrentUserPartyBankAccountsQueryVariables>;
export const DeletePartyBankAccountDocument = gql`
    mutation deletePartyBankAccount($input: DeletePartyBankAccountInput!) {
  deletePartyBankAccount(input: $input) {
    Code
    Success
    Message
    PartyBankAccountId
  }
}
    `;
export type DeletePartyBankAccountMutationFn = Apollo.MutationFunction<DeletePartyBankAccountMutation, DeletePartyBankAccountMutationVariables>;
export type DeletePartyBankAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeletePartyBankAccountMutation, DeletePartyBankAccountMutationVariables>, 'mutation'>;

    export const DeletePartyBankAccountComponent = (props: DeletePartyBankAccountComponentProps) => (
      <ApolloReactComponents.Mutation<DeletePartyBankAccountMutation, DeletePartyBankAccountMutationVariables> mutation={DeletePartyBankAccountDocument} {...props} />
    );
    
export type DeletePartyBankAccountProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeletePartyBankAccountMutation, DeletePartyBankAccountMutationVariables>
    } & TChildProps;
export function withDeletePartyBankAccount<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeletePartyBankAccountMutation,
  DeletePartyBankAccountMutationVariables,
  DeletePartyBankAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeletePartyBankAccountMutation, DeletePartyBankAccountMutationVariables, DeletePartyBankAccountProps<TChildProps, TDataName>>(DeletePartyBankAccountDocument, {
      alias: 'deletePartyBankAccount',
      ...operationOptions
    });
};

/**
 * __useDeletePartyBankAccountMutation__
 *
 * To run a mutation, you first call `useDeletePartyBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartyBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartyBankAccountMutation, { data, loading, error }] = useDeletePartyBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePartyBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartyBankAccountMutation, DeletePartyBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartyBankAccountMutation, DeletePartyBankAccountMutationVariables>(DeletePartyBankAccountDocument, options);
      }
export type DeletePartyBankAccountMutationHookResult = ReturnType<typeof useDeletePartyBankAccountMutation>;
export type DeletePartyBankAccountMutationResult = Apollo.MutationResult<DeletePartyBankAccountMutation>;
export type DeletePartyBankAccountMutationOptions = Apollo.BaseMutationOptions<DeletePartyBankAccountMutation, DeletePartyBankAccountMutationVariables>;
export const RequestPayAnyoneTransferDocument = gql`
    mutation requestPayAnyoneTransfer($input: RequestPayAnyoneTransferInput!) {
  requestPayAnyoneTransfer(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
  }
}
    `;
export type RequestPayAnyoneTransferMutationFn = Apollo.MutationFunction<RequestPayAnyoneTransferMutation, RequestPayAnyoneTransferMutationVariables>;
export type RequestPayAnyoneTransferComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestPayAnyoneTransferMutation, RequestPayAnyoneTransferMutationVariables>, 'mutation'>;

    export const RequestPayAnyoneTransferComponent = (props: RequestPayAnyoneTransferComponentProps) => (
      <ApolloReactComponents.Mutation<RequestPayAnyoneTransferMutation, RequestPayAnyoneTransferMutationVariables> mutation={RequestPayAnyoneTransferDocument} {...props} />
    );
    
export type RequestPayAnyoneTransferProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RequestPayAnyoneTransferMutation, RequestPayAnyoneTransferMutationVariables>
    } & TChildProps;
export function withRequestPayAnyoneTransfer<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestPayAnyoneTransferMutation,
  RequestPayAnyoneTransferMutationVariables,
  RequestPayAnyoneTransferProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestPayAnyoneTransferMutation, RequestPayAnyoneTransferMutationVariables, RequestPayAnyoneTransferProps<TChildProps, TDataName>>(RequestPayAnyoneTransferDocument, {
      alias: 'requestPayAnyoneTransfer',
      ...operationOptions
    });
};

/**
 * __useRequestPayAnyoneTransferMutation__
 *
 * To run a mutation, you first call `useRequestPayAnyoneTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPayAnyoneTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPayAnyoneTransferMutation, { data, loading, error }] = useRequestPayAnyoneTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPayAnyoneTransferMutation(baseOptions?: Apollo.MutationHookOptions<RequestPayAnyoneTransferMutation, RequestPayAnyoneTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPayAnyoneTransferMutation, RequestPayAnyoneTransferMutationVariables>(RequestPayAnyoneTransferDocument, options);
      }
export type RequestPayAnyoneTransferMutationHookResult = ReturnType<typeof useRequestPayAnyoneTransferMutation>;
export type RequestPayAnyoneTransferMutationResult = Apollo.MutationResult<RequestPayAnyoneTransferMutation>;
export type RequestPayAnyoneTransferMutationOptions = Apollo.BaseMutationOptions<RequestPayAnyoneTransferMutation, RequestPayAnyoneTransferMutationVariables>;
export const InstrumentByAccountIdDocument = gql`
    query instrumentByAccountId($account: String!) {
  instrumentByAccount(account: {Id: $account}) {
    Id
    Accounts {
      Id
      Number
      Description
      Redraw
      CurrentBalance
      ProductType
      CurrentUserAccountAuthority {
        Id
        BPay
        Operate
        InterAccount
        DirectDebit
        PayAnyone
        Redraw
        View
      }
    }
  }
}
    `;
export type InstrumentByAccountIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables>, 'query'> & ({ variables: InstrumentByAccountIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InstrumentByAccountIdComponent = (props: InstrumentByAccountIdComponentProps) => (
      <ApolloReactComponents.Query<InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables> query={InstrumentByAccountIdDocument} {...props} />
    );
    
export type InstrumentByAccountIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables>
    } & TChildProps;
export function withInstrumentByAccountId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InstrumentByAccountIdQuery,
  InstrumentByAccountIdQueryVariables,
  InstrumentByAccountIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables, InstrumentByAccountIdProps<TChildProps, TDataName>>(InstrumentByAccountIdDocument, {
      alias: 'instrumentByAccountId',
      ...operationOptions
    });
};

/**
 * __useInstrumentByAccountIdQuery__
 *
 * To run a query within a React component, call `useInstrumentByAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentByAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentByAccountIdQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useInstrumentByAccountIdQuery(baseOptions: Apollo.QueryHookOptions<InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables>(InstrumentByAccountIdDocument, options);
      }
export function useInstrumentByAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables>(InstrumentByAccountIdDocument, options);
        }
export type InstrumentByAccountIdQueryHookResult = ReturnType<typeof useInstrumentByAccountIdQuery>;
export type InstrumentByAccountIdLazyQueryHookResult = ReturnType<typeof useInstrumentByAccountIdLazyQuery>;
export type InstrumentByAccountIdQueryResult = Apollo.QueryResult<InstrumentByAccountIdQuery, InstrumentByAccountIdQueryVariables>;
export const AccountLimitDocument = gql`
    query accountLimit($accountId: String!, $date: DateTime) {
  accountLimits(
    accountId: $accountId
    filter: {DateRange: {From: $date, To: $date}}
  ) {
    Id
    EffectiveDate
    Limits {
      DailyRedrawLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyRedrawLimit {
        CurrencyCode
        Amount
      }
      DailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
    }
  }
}
    `;
export type AccountLimitComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountLimitQuery, AccountLimitQueryVariables>, 'query'> & ({ variables: AccountLimitQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountLimitComponent = (props: AccountLimitComponentProps) => (
      <ApolloReactComponents.Query<AccountLimitQuery, AccountLimitQueryVariables> query={AccountLimitDocument} {...props} />
    );
    
export type AccountLimitProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountLimitQuery, AccountLimitQueryVariables>
    } & TChildProps;
export function withAccountLimit<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountLimitQuery,
  AccountLimitQueryVariables,
  AccountLimitProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountLimitQuery, AccountLimitQueryVariables, AccountLimitProps<TChildProps, TDataName>>(AccountLimitDocument, {
      alias: 'accountLimit',
      ...operationOptions
    });
};

/**
 * __useAccountLimitQuery__
 *
 * To run a query within a React component, call `useAccountLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountLimitQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAccountLimitQuery(baseOptions: Apollo.QueryHookOptions<AccountLimitQuery, AccountLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountLimitQuery, AccountLimitQueryVariables>(AccountLimitDocument, options);
      }
export function useAccountLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountLimitQuery, AccountLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountLimitQuery, AccountLimitQueryVariables>(AccountLimitDocument, options);
        }
export type AccountLimitQueryHookResult = ReturnType<typeof useAccountLimitQuery>;
export type AccountLimitLazyQueryHookResult = ReturnType<typeof useAccountLimitLazyQuery>;
export type AccountLimitQueryResult = Apollo.QueryResult<AccountLimitQuery, AccountLimitQueryVariables>;
export const PartyPaymentLimitDocument = gql`
    mutation partyPaymentLimit($input: PartyPaymentLimitInput!) {
  setPartyPaymentLimit(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export type PartyPaymentLimitMutationFn = Apollo.MutationFunction<PartyPaymentLimitMutation, PartyPaymentLimitMutationVariables>;
export type PartyPaymentLimitComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PartyPaymentLimitMutation, PartyPaymentLimitMutationVariables>, 'mutation'>;

    export const PartyPaymentLimitComponent = (props: PartyPaymentLimitComponentProps) => (
      <ApolloReactComponents.Mutation<PartyPaymentLimitMutation, PartyPaymentLimitMutationVariables> mutation={PartyPaymentLimitDocument} {...props} />
    );
    
export type PartyPaymentLimitProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<PartyPaymentLimitMutation, PartyPaymentLimitMutationVariables>
    } & TChildProps;
export function withPartyPaymentLimit<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PartyPaymentLimitMutation,
  PartyPaymentLimitMutationVariables,
  PartyPaymentLimitProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, PartyPaymentLimitMutation, PartyPaymentLimitMutationVariables, PartyPaymentLimitProps<TChildProps, TDataName>>(PartyPaymentLimitDocument, {
      alias: 'partyPaymentLimit',
      ...operationOptions
    });
};

/**
 * __usePartyPaymentLimitMutation__
 *
 * To run a mutation, you first call `usePartyPaymentLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartyPaymentLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partyPaymentLimitMutation, { data, loading, error }] = usePartyPaymentLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyPaymentLimitMutation(baseOptions?: Apollo.MutationHookOptions<PartyPaymentLimitMutation, PartyPaymentLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartyPaymentLimitMutation, PartyPaymentLimitMutationVariables>(PartyPaymentLimitDocument, options);
      }
export type PartyPaymentLimitMutationHookResult = ReturnType<typeof usePartyPaymentLimitMutation>;
export type PartyPaymentLimitMutationResult = Apollo.MutationResult<PartyPaymentLimitMutation>;
export type PartyPaymentLimitMutationOptions = Apollo.BaseMutationOptions<PartyPaymentLimitMutation, PartyPaymentLimitMutationVariables>;
export const RequestPayAnyoneTransferMutationDocument = gql`
    mutation requestPayAnyoneTransferMutation($input: RequestPayAnyoneTransferInput!) {
  requestPayAnyoneTransfer(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
  }
}
    `;
export type RequestPayAnyoneTransferMutationMutationFn = Apollo.MutationFunction<RequestPayAnyoneTransferMutationMutation, RequestPayAnyoneTransferMutationMutationVariables>;
export type RequestPayAnyoneTransferMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestPayAnyoneTransferMutationMutation, RequestPayAnyoneTransferMutationMutationVariables>, 'mutation'>;

    export const RequestPayAnyoneTransferMutationComponent = (props: RequestPayAnyoneTransferMutationComponentProps) => (
      <ApolloReactComponents.Mutation<RequestPayAnyoneTransferMutationMutation, RequestPayAnyoneTransferMutationMutationVariables> mutation={RequestPayAnyoneTransferMutationDocument} {...props} />
    );
    
export type RequestPayAnyoneTransferMutationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RequestPayAnyoneTransferMutationMutation, RequestPayAnyoneTransferMutationMutationVariables>
    } & TChildProps;
export function withRequestPayAnyoneTransferMutation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestPayAnyoneTransferMutationMutation,
  RequestPayAnyoneTransferMutationMutationVariables,
  RequestPayAnyoneTransferMutationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestPayAnyoneTransferMutationMutation, RequestPayAnyoneTransferMutationMutationVariables, RequestPayAnyoneTransferMutationProps<TChildProps, TDataName>>(RequestPayAnyoneTransferMutationDocument, {
      alias: 'requestPayAnyoneTransferMutation',
      ...operationOptions
    });
};

/**
 * __useRequestPayAnyoneTransferMutationMutation__
 *
 * To run a mutation, you first call `useRequestPayAnyoneTransferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPayAnyoneTransferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPayAnyoneTransferMutationMutation, { data, loading, error }] = useRequestPayAnyoneTransferMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPayAnyoneTransferMutationMutation(baseOptions?: Apollo.MutationHookOptions<RequestPayAnyoneTransferMutationMutation, RequestPayAnyoneTransferMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPayAnyoneTransferMutationMutation, RequestPayAnyoneTransferMutationMutationVariables>(RequestPayAnyoneTransferMutationDocument, options);
      }
export type RequestPayAnyoneTransferMutationMutationHookResult = ReturnType<typeof useRequestPayAnyoneTransferMutationMutation>;
export type RequestPayAnyoneTransferMutationMutationResult = Apollo.MutationResult<RequestPayAnyoneTransferMutationMutation>;
export type RequestPayAnyoneTransferMutationMutationOptions = Apollo.BaseMutationOptions<RequestPayAnyoneTransferMutationMutation, RequestPayAnyoneTransferMutationMutationVariables>;
export const CloseOtherSessionsDocument = gql`
    mutation CloseOtherSessions($input: ForceCloseCurrentUserSessionsInput!) {
  closeCurrentUserSessions(input: $input) {
    Code
    Success
    Message
    clientMutationId
    Data {
      Id
      Features
      CurrentServerTime
      LastLoginAttempt
      LastLoginFrom
      LastPasswordChange
      IsFirstLogin
      CurrentSession {
        Id
        IsDeleted
        LastActivity
        SessionStart
        EventDate
        IpAddress
        Successful
        ClientVersion
        UserAgentHeader
        Expires
      }
      LoginAttempts {
        Id
        EventDate
        IpAddress
        Successful
        ClientVersion
        UserAgentHeader
        IsDeleted
        LastActivity
        SessionStart
        Expires
      }
    }
  }
}
    `;
export type CloseOtherSessionsMutationFn = Apollo.MutationFunction<CloseOtherSessionsMutation, CloseOtherSessionsMutationVariables>;
export type CloseOtherSessionsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CloseOtherSessionsMutation, CloseOtherSessionsMutationVariables>, 'mutation'>;

    export const CloseOtherSessionsComponent = (props: CloseOtherSessionsComponentProps) => (
      <ApolloReactComponents.Mutation<CloseOtherSessionsMutation, CloseOtherSessionsMutationVariables> mutation={CloseOtherSessionsDocument} {...props} />
    );
    
export type CloseOtherSessionsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CloseOtherSessionsMutation, CloseOtherSessionsMutationVariables>
    } & TChildProps;
export function withCloseOtherSessions<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CloseOtherSessionsMutation,
  CloseOtherSessionsMutationVariables,
  CloseOtherSessionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CloseOtherSessionsMutation, CloseOtherSessionsMutationVariables, CloseOtherSessionsProps<TChildProps, TDataName>>(CloseOtherSessionsDocument, {
      alias: 'closeOtherSessions',
      ...operationOptions
    });
};

/**
 * __useCloseOtherSessionsMutation__
 *
 * To run a mutation, you first call `useCloseOtherSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseOtherSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeOtherSessionsMutation, { data, loading, error }] = useCloseOtherSessionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseOtherSessionsMutation(baseOptions?: Apollo.MutationHookOptions<CloseOtherSessionsMutation, CloseOtherSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseOtherSessionsMutation, CloseOtherSessionsMutationVariables>(CloseOtherSessionsDocument, options);
      }
export type CloseOtherSessionsMutationHookResult = ReturnType<typeof useCloseOtherSessionsMutation>;
export type CloseOtherSessionsMutationResult = Apollo.MutationResult<CloseOtherSessionsMutation>;
export type CloseOtherSessionsMutationOptions = Apollo.BaseMutationOptions<CloseOtherSessionsMutation, CloseOtherSessionsMutationVariables>;
export const ChangeCurrentUserPasswordDocument = gql`
    mutation changeCurrentUserPassword($input: ChangePasswordInput!) {
  changeCurrentUserPassword(input: $input) {
    Code
    Success
    Message
    UserSession {
      Id
      Features
      CurrentServerTime
      LastLoginAttempt
      LastLoginFrom
      LastPasswordChange
      IsFirstLogin
      HasTempPassword
      UseMultiFactorAuth
      Party {
        Id
        PartyNumber
        FullName
        OrganisationName
        FirstName
        LastName
      }
    }
  }
}
    `;
export type ChangeCurrentUserPasswordMutationFn = Apollo.MutationFunction<ChangeCurrentUserPasswordMutation, ChangeCurrentUserPasswordMutationVariables>;
export type ChangeCurrentUserPasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ChangeCurrentUserPasswordMutation, ChangeCurrentUserPasswordMutationVariables>, 'mutation'>;

    export const ChangeCurrentUserPasswordComponent = (props: ChangeCurrentUserPasswordComponentProps) => (
      <ApolloReactComponents.Mutation<ChangeCurrentUserPasswordMutation, ChangeCurrentUserPasswordMutationVariables> mutation={ChangeCurrentUserPasswordDocument} {...props} />
    );
    
export type ChangeCurrentUserPasswordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ChangeCurrentUserPasswordMutation, ChangeCurrentUserPasswordMutationVariables>
    } & TChildProps;
export function withChangeCurrentUserPassword<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ChangeCurrentUserPasswordMutation,
  ChangeCurrentUserPasswordMutationVariables,
  ChangeCurrentUserPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ChangeCurrentUserPasswordMutation, ChangeCurrentUserPasswordMutationVariables, ChangeCurrentUserPasswordProps<TChildProps, TDataName>>(ChangeCurrentUserPasswordDocument, {
      alias: 'changeCurrentUserPassword',
      ...operationOptions
    });
};

/**
 * __useChangeCurrentUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeCurrentUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCurrentUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCurrentUserPasswordMutation, { data, loading, error }] = useChangeCurrentUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCurrentUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCurrentUserPasswordMutation, ChangeCurrentUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCurrentUserPasswordMutation, ChangeCurrentUserPasswordMutationVariables>(ChangeCurrentUserPasswordDocument, options);
      }
export type ChangeCurrentUserPasswordMutationHookResult = ReturnType<typeof useChangeCurrentUserPasswordMutation>;
export type ChangeCurrentUserPasswordMutationResult = Apollo.MutationResult<ChangeCurrentUserPasswordMutation>;
export type ChangeCurrentUserPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeCurrentUserPasswordMutation, ChangeCurrentUserPasswordMutationVariables>;
export const PasswordValidatorByApplicationDocument = gql`
    query passwordValidatorByApplication {
  passwordValidatorByApplication {
    MinimumPasswordLength
    RequireLowerCaseCharacters
    MinimumLowerCaseCharacterCount
    RequireUpperCaseCharacters
    MinimumUpperCaseCharacterCount
    RequireNumberCharacters
    MinimumNumberCharacterCount
    RequireBaseSymbols
    MinimumBaseSymbolCharacterCount
    RequireExtendedSymbols
    MinimumExtendedSymbolCharacterCount
    ProhibitSequentialAlphabetCharacters
    ProhibitSequentialNumberCharacters
    ProhibitRepeatingAlphabetCharacters
    ProhibitRepeatingNumberCharacters
    ProhibitRepeatingSymbolCharacters
    MinimumPasswordHistory
  }
}
    `;
export type PasswordValidatorByApplicationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables>, 'query'>;

    export const PasswordValidatorByApplicationComponent = (props: PasswordValidatorByApplicationComponentProps) => (
      <ApolloReactComponents.Query<PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables> query={PasswordValidatorByApplicationDocument} {...props} />
    );
    
export type PasswordValidatorByApplicationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables>
    } & TChildProps;
export function withPasswordValidatorByApplication<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PasswordValidatorByApplicationQuery,
  PasswordValidatorByApplicationQueryVariables,
  PasswordValidatorByApplicationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables, PasswordValidatorByApplicationProps<TChildProps, TDataName>>(PasswordValidatorByApplicationDocument, {
      alias: 'passwordValidatorByApplication',
      ...operationOptions
    });
};

/**
 * __usePasswordValidatorByApplicationQuery__
 *
 * To run a query within a React component, call `usePasswordValidatorByApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasswordValidatorByApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasswordValidatorByApplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePasswordValidatorByApplicationQuery(baseOptions?: Apollo.QueryHookOptions<PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables>(PasswordValidatorByApplicationDocument, options);
      }
export function usePasswordValidatorByApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables>(PasswordValidatorByApplicationDocument, options);
        }
export type PasswordValidatorByApplicationQueryHookResult = ReturnType<typeof usePasswordValidatorByApplicationQuery>;
export type PasswordValidatorByApplicationLazyQueryHookResult = ReturnType<typeof usePasswordValidatorByApplicationLazyQuery>;
export type PasswordValidatorByApplicationQueryResult = Apollo.QueryResult<PasswordValidatorByApplicationQuery, PasswordValidatorByApplicationQueryVariables>;
export const BankingUserLogoutDocument = gql`
    mutation bankingUserLogout {
  logout {
    Code
    Success
    Message
  }
}
    `;
export type BankingUserLogoutMutationFn = Apollo.MutationFunction<BankingUserLogoutMutation, BankingUserLogoutMutationVariables>;
export type BankingUserLogoutComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BankingUserLogoutMutation, BankingUserLogoutMutationVariables>, 'mutation'>;

    export const BankingUserLogoutComponent = (props: BankingUserLogoutComponentProps) => (
      <ApolloReactComponents.Mutation<BankingUserLogoutMutation, BankingUserLogoutMutationVariables> mutation={BankingUserLogoutDocument} {...props} />
    );
    
export type BankingUserLogoutProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<BankingUserLogoutMutation, BankingUserLogoutMutationVariables>
    } & TChildProps;
export function withBankingUserLogout<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BankingUserLogoutMutation,
  BankingUserLogoutMutationVariables,
  BankingUserLogoutProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, BankingUserLogoutMutation, BankingUserLogoutMutationVariables, BankingUserLogoutProps<TChildProps, TDataName>>(BankingUserLogoutDocument, {
      alias: 'bankingUserLogout',
      ...operationOptions
    });
};

/**
 * __useBankingUserLogoutMutation__
 *
 * To run a mutation, you first call `useBankingUserLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankingUserLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankingUserLogoutMutation, { data, loading, error }] = useBankingUserLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useBankingUserLogoutMutation(baseOptions?: Apollo.MutationHookOptions<BankingUserLogoutMutation, BankingUserLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankingUserLogoutMutation, BankingUserLogoutMutationVariables>(BankingUserLogoutDocument, options);
      }
export type BankingUserLogoutMutationHookResult = ReturnType<typeof useBankingUserLogoutMutation>;
export type BankingUserLogoutMutationResult = Apollo.MutationResult<BankingUserLogoutMutation>;
export type BankingUserLogoutMutationOptions = Apollo.BaseMutationOptions<BankingUserLogoutMutation, BankingUserLogoutMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation requestPasswordReset($input: ResetPasswordInput!) {
  requestPasswordReset(input: $input) {
    Code
    Success
    Message
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export type RequestPasswordResetComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>, 'mutation'>;

    export const RequestPasswordResetComponent = (props: RequestPasswordResetComponentProps) => (
      <ApolloReactComponents.Mutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables> mutation={RequestPasswordResetDocument} {...props} />
    );
    
export type RequestPasswordResetProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>
    } & TChildProps;
export function withRequestPasswordReset<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables,
  RequestPasswordResetProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestPasswordResetMutation, RequestPasswordResetMutationVariables, RequestPasswordResetProps<TChildProps, TDataName>>(RequestPasswordResetDocument, {
      alias: 'requestPasswordReset',
      ...operationOptions
    });
};

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ArchiveSecureMessageDocument = gql`
    mutation archiveSecureMessage($input: ArchiveSecureMessageInput!) {
  archiveSecureMessage(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export type ArchiveSecureMessageMutationFn = Apollo.MutationFunction<ArchiveSecureMessageMutation, ArchiveSecureMessageMutationVariables>;
export type ArchiveSecureMessageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ArchiveSecureMessageMutation, ArchiveSecureMessageMutationVariables>, 'mutation'>;

    export const ArchiveSecureMessageComponent = (props: ArchiveSecureMessageComponentProps) => (
      <ApolloReactComponents.Mutation<ArchiveSecureMessageMutation, ArchiveSecureMessageMutationVariables> mutation={ArchiveSecureMessageDocument} {...props} />
    );
    
export type ArchiveSecureMessageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ArchiveSecureMessageMutation, ArchiveSecureMessageMutationVariables>
    } & TChildProps;
export function withArchiveSecureMessage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArchiveSecureMessageMutation,
  ArchiveSecureMessageMutationVariables,
  ArchiveSecureMessageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ArchiveSecureMessageMutation, ArchiveSecureMessageMutationVariables, ArchiveSecureMessageProps<TChildProps, TDataName>>(ArchiveSecureMessageDocument, {
      alias: 'archiveSecureMessage',
      ...operationOptions
    });
};

/**
 * __useArchiveSecureMessageMutation__
 *
 * To run a mutation, you first call `useArchiveSecureMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSecureMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSecureMessageMutation, { data, loading, error }] = useArchiveSecureMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveSecureMessageMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSecureMessageMutation, ArchiveSecureMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSecureMessageMutation, ArchiveSecureMessageMutationVariables>(ArchiveSecureMessageDocument, options);
      }
export type ArchiveSecureMessageMutationHookResult = ReturnType<typeof useArchiveSecureMessageMutation>;
export type ArchiveSecureMessageMutationResult = Apollo.MutationResult<ArchiveSecureMessageMutation>;
export type ArchiveSecureMessageMutationOptions = Apollo.BaseMutationOptions<ArchiveSecureMessageMutation, ArchiveSecureMessageMutationVariables>;
export const ReadSecureMessageDocument = gql`
    mutation readSecureMessage($input: ReadSecureMessageInput!) {
  readSecureMessage(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export type ReadSecureMessageMutationFn = Apollo.MutationFunction<ReadSecureMessageMutation, ReadSecureMessageMutationVariables>;
export type ReadSecureMessageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReadSecureMessageMutation, ReadSecureMessageMutationVariables>, 'mutation'>;

    export const ReadSecureMessageComponent = (props: ReadSecureMessageComponentProps) => (
      <ApolloReactComponents.Mutation<ReadSecureMessageMutation, ReadSecureMessageMutationVariables> mutation={ReadSecureMessageDocument} {...props} />
    );
    
export type ReadSecureMessageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ReadSecureMessageMutation, ReadSecureMessageMutationVariables>
    } & TChildProps;
export function withReadSecureMessage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReadSecureMessageMutation,
  ReadSecureMessageMutationVariables,
  ReadSecureMessageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ReadSecureMessageMutation, ReadSecureMessageMutationVariables, ReadSecureMessageProps<TChildProps, TDataName>>(ReadSecureMessageDocument, {
      alias: 'readSecureMessage',
      ...operationOptions
    });
};

/**
 * __useReadSecureMessageMutation__
 *
 * To run a mutation, you first call `useReadSecureMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadSecureMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readSecureMessageMutation, { data, loading, error }] = useReadSecureMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadSecureMessageMutation(baseOptions?: Apollo.MutationHookOptions<ReadSecureMessageMutation, ReadSecureMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadSecureMessageMutation, ReadSecureMessageMutationVariables>(ReadSecureMessageDocument, options);
      }
export type ReadSecureMessageMutationHookResult = ReturnType<typeof useReadSecureMessageMutation>;
export type ReadSecureMessageMutationResult = Apollo.MutationResult<ReadSecureMessageMutation>;
export type ReadSecureMessageMutationOptions = Apollo.BaseMutationOptions<ReadSecureMessageMutation, ReadSecureMessageMutationVariables>;
export const CreateNewSecureMessageDocument = gql`
    mutation createNewSecureMessage($input: RequestNewSecureMessageInput!) {
  requestNewSecureMessage(input: $input) {
    Code
    clientMutationId
    Message
    Success
    GraphSecureMessage {
      DateArchived
      DateRead
      DateReplied
      Id
      IsArchived
      IsRead
      IsReplied
      ProfileId
      ShortDescription
      Subject
      ToDoItem {
        AccountNumber
        Id
        Messages {
          CreatedBy
          CreatedOn
          Id
          Text
          Party
        }
        State
        Text
        WithId
        Type {
          Id
          Description
          SecureMessageType {
            Id
            IsAccount
            IsSystem
            Description
            DisplayOrder
            Name
          }
        }
      }
      Type
    }
  }
}
    `;
export type CreateNewSecureMessageMutationFn = Apollo.MutationFunction<CreateNewSecureMessageMutation, CreateNewSecureMessageMutationVariables>;
export type CreateNewSecureMessageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateNewSecureMessageMutation, CreateNewSecureMessageMutationVariables>, 'mutation'>;

    export const CreateNewSecureMessageComponent = (props: CreateNewSecureMessageComponentProps) => (
      <ApolloReactComponents.Mutation<CreateNewSecureMessageMutation, CreateNewSecureMessageMutationVariables> mutation={CreateNewSecureMessageDocument} {...props} />
    );
    
export type CreateNewSecureMessageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateNewSecureMessageMutation, CreateNewSecureMessageMutationVariables>
    } & TChildProps;
export function withCreateNewSecureMessage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateNewSecureMessageMutation,
  CreateNewSecureMessageMutationVariables,
  CreateNewSecureMessageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateNewSecureMessageMutation, CreateNewSecureMessageMutationVariables, CreateNewSecureMessageProps<TChildProps, TDataName>>(CreateNewSecureMessageDocument, {
      alias: 'createNewSecureMessage',
      ...operationOptions
    });
};

/**
 * __useCreateNewSecureMessageMutation__
 *
 * To run a mutation, you first call `useCreateNewSecureMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewSecureMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewSecureMessageMutation, { data, loading, error }] = useCreateNewSecureMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewSecureMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewSecureMessageMutation, CreateNewSecureMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewSecureMessageMutation, CreateNewSecureMessageMutationVariables>(CreateNewSecureMessageDocument, options);
      }
export type CreateNewSecureMessageMutationHookResult = ReturnType<typeof useCreateNewSecureMessageMutation>;
export type CreateNewSecureMessageMutationResult = Apollo.MutationResult<CreateNewSecureMessageMutation>;
export type CreateNewSecureMessageMutationOptions = Apollo.BaseMutationOptions<CreateNewSecureMessageMutation, CreateNewSecureMessageMutationVariables>;
export const CreateNewSecureReplyDocument = gql`
    mutation createNewSecureReply($input: RequestNewSecureReplyInput!) {
  requestNewSecureReply(input: $input) {
    Code
    clientMutationId
    Message
    Success
    GraphSecureMessage {
      DateArchived
      DateRead
      DateReplied
      Id
      IsArchived
      IsRead
      IsReplied
      ProfileId
      ShortDescription
      Subject
      ToDoItem {
        AccountNumber
        Id
        Messages {
          CreatedBy
          CreatedOn
          Id
          Text
          Party
        }
        State
        Text
        WithId
        Type {
          Id
          Description
          SecureMessageType {
            Id
            IsAccount
            IsSystem
            Description
            DisplayOrder
            Name
          }
        }
      }
    }
  }
}
    `;
export type CreateNewSecureReplyMutationFn = Apollo.MutationFunction<CreateNewSecureReplyMutation, CreateNewSecureReplyMutationVariables>;
export type CreateNewSecureReplyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateNewSecureReplyMutation, CreateNewSecureReplyMutationVariables>, 'mutation'>;

    export const CreateNewSecureReplyComponent = (props: CreateNewSecureReplyComponentProps) => (
      <ApolloReactComponents.Mutation<CreateNewSecureReplyMutation, CreateNewSecureReplyMutationVariables> mutation={CreateNewSecureReplyDocument} {...props} />
    );
    
export type CreateNewSecureReplyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateNewSecureReplyMutation, CreateNewSecureReplyMutationVariables>
    } & TChildProps;
export function withCreateNewSecureReply<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateNewSecureReplyMutation,
  CreateNewSecureReplyMutationVariables,
  CreateNewSecureReplyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateNewSecureReplyMutation, CreateNewSecureReplyMutationVariables, CreateNewSecureReplyProps<TChildProps, TDataName>>(CreateNewSecureReplyDocument, {
      alias: 'createNewSecureReply',
      ...operationOptions
    });
};

/**
 * __useCreateNewSecureReplyMutation__
 *
 * To run a mutation, you first call `useCreateNewSecureReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewSecureReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewSecureReplyMutation, { data, loading, error }] = useCreateNewSecureReplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewSecureReplyMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewSecureReplyMutation, CreateNewSecureReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewSecureReplyMutation, CreateNewSecureReplyMutationVariables>(CreateNewSecureReplyDocument, options);
      }
export type CreateNewSecureReplyMutationHookResult = ReturnType<typeof useCreateNewSecureReplyMutation>;
export type CreateNewSecureReplyMutationResult = Apollo.MutationResult<CreateNewSecureReplyMutation>;
export type CreateNewSecureReplyMutationOptions = Apollo.BaseMutationOptions<CreateNewSecureReplyMutation, CreateNewSecureReplyMutationVariables>;
export const SecureMessagesByPartyDocument = gql`
    query secureMessagesByParty {
  secureMessagesByParty {
    SecureMessages {
      Id
      ProfileId
      ToDoItem {
        Id
        WithId
        State
        Text
        Messages {
          Id
          CreatedOn
          CreatedBy
          Text
          Party
        }
        AccountNumber
        Type {
          Id
          Description
          SecureMessageType {
            Id
            IsAccount
            IsSystem
            Description
            DisplayOrder
            Name
          }
        }
      }
      IsArchived
      DateArchived
      IsRead
      DateRead
      IsReplied
      DateReplied
      Subject
      Type
      ShortDescription
    }
    UnreadMessageCount
  }
}
    `;
export type SecureMessagesByPartyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables>, 'query'>;

    export const SecureMessagesByPartyComponent = (props: SecureMessagesByPartyComponentProps) => (
      <ApolloReactComponents.Query<SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables> query={SecureMessagesByPartyDocument} {...props} />
    );
    
export type SecureMessagesByPartyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables>
    } & TChildProps;
export function withSecureMessagesByParty<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SecureMessagesByPartyQuery,
  SecureMessagesByPartyQueryVariables,
  SecureMessagesByPartyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables, SecureMessagesByPartyProps<TChildProps, TDataName>>(SecureMessagesByPartyDocument, {
      alias: 'secureMessagesByParty',
      ...operationOptions
    });
};

/**
 * __useSecureMessagesByPartyQuery__
 *
 * To run a query within a React component, call `useSecureMessagesByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureMessagesByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureMessagesByPartyQuery({
 *   variables: {
 *   },
 * });
 */
export function useSecureMessagesByPartyQuery(baseOptions?: Apollo.QueryHookOptions<SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables>(SecureMessagesByPartyDocument, options);
      }
export function useSecureMessagesByPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables>(SecureMessagesByPartyDocument, options);
        }
export type SecureMessagesByPartyQueryHookResult = ReturnType<typeof useSecureMessagesByPartyQuery>;
export type SecureMessagesByPartyLazyQueryHookResult = ReturnType<typeof useSecureMessagesByPartyLazyQuery>;
export type SecureMessagesByPartyQueryResult = Apollo.QueryResult<SecureMessagesByPartyQuery, SecureMessagesByPartyQueryVariables>;
export const UnreadMessagesCountByPartyDocument = gql`
    query unreadMessagesCountByParty {
  secureMessagesByParty {
    UnreadMessageCount
  }
}
    `;
export type UnreadMessagesCountByPartyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables>, 'query'>;

    export const UnreadMessagesCountByPartyComponent = (props: UnreadMessagesCountByPartyComponentProps) => (
      <ApolloReactComponents.Query<UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables> query={UnreadMessagesCountByPartyDocument} {...props} />
    );
    
export type UnreadMessagesCountByPartyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables>
    } & TChildProps;
export function withUnreadMessagesCountByParty<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnreadMessagesCountByPartyQuery,
  UnreadMessagesCountByPartyQueryVariables,
  UnreadMessagesCountByPartyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables, UnreadMessagesCountByPartyProps<TChildProps, TDataName>>(UnreadMessagesCountByPartyDocument, {
      alias: 'unreadMessagesCountByParty',
      ...operationOptions
    });
};

/**
 * __useUnreadMessagesCountByPartyQuery__
 *
 * To run a query within a React component, call `useUnreadMessagesCountByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadMessagesCountByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadMessagesCountByPartyQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadMessagesCountByPartyQuery(baseOptions?: Apollo.QueryHookOptions<UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables>(UnreadMessagesCountByPartyDocument, options);
      }
export function useUnreadMessagesCountByPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables>(UnreadMessagesCountByPartyDocument, options);
        }
export type UnreadMessagesCountByPartyQueryHookResult = ReturnType<typeof useUnreadMessagesCountByPartyQuery>;
export type UnreadMessagesCountByPartyLazyQueryHookResult = ReturnType<typeof useUnreadMessagesCountByPartyLazyQuery>;
export type UnreadMessagesCountByPartyQueryResult = Apollo.QueryResult<UnreadMessagesCountByPartyQuery, UnreadMessagesCountByPartyQueryVariables>;
export const AcceptTermsDocument = gql`
    mutation acceptTerms {
  acceptTerms {
    Code
    Success
    Message
    UserSession {
      Id
      LastTermsAcceptance
    }
  }
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;
export type AcceptTermsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AcceptTermsMutation, AcceptTermsMutationVariables>, 'mutation'>;

    export const AcceptTermsComponent = (props: AcceptTermsComponentProps) => (
      <ApolloReactComponents.Mutation<AcceptTermsMutation, AcceptTermsMutationVariables> mutation={AcceptTermsDocument} {...props} />
    );
    
export type AcceptTermsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>
    } & TChildProps;
export function withAcceptTerms<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcceptTermsMutation,
  AcceptTermsMutationVariables,
  AcceptTermsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AcceptTermsMutation, AcceptTermsMutationVariables, AcceptTermsProps<TChildProps, TDataName>>(AcceptTermsDocument, {
      alias: 'acceptTerms',
      ...operationOptions
    });
};

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const BankingUserLoginDocument = gql`
    mutation bankingUserLogin($input: LoginInput!) {
  login(input: $input) {
    Code
    Message
    Success
    UserSession {
      Id
      FinanceSummary {
        Id
      }
      Features
      CurrentServerTime
      LastLoginAttempt
      LastLoginFrom
      LastPasswordChange
      IsFirstLogin
      Party {
        Id
        PartyNumber
        FirstName
        LastName
        FullName
      }
      IsSharia
    }
  }
}
    `;
export type BankingUserLoginMutationFn = Apollo.MutationFunction<BankingUserLoginMutation, BankingUserLoginMutationVariables>;
export type BankingUserLoginComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BankingUserLoginMutation, BankingUserLoginMutationVariables>, 'mutation'>;

    export const BankingUserLoginComponent = (props: BankingUserLoginComponentProps) => (
      <ApolloReactComponents.Mutation<BankingUserLoginMutation, BankingUserLoginMutationVariables> mutation={BankingUserLoginDocument} {...props} />
    );
    
export type BankingUserLoginProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<BankingUserLoginMutation, BankingUserLoginMutationVariables>
    } & TChildProps;
export function withBankingUserLogin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BankingUserLoginMutation,
  BankingUserLoginMutationVariables,
  BankingUserLoginProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, BankingUserLoginMutation, BankingUserLoginMutationVariables, BankingUserLoginProps<TChildProps, TDataName>>(BankingUserLoginDocument, {
      alias: 'bankingUserLogin',
      ...operationOptions
    });
};

/**
 * __useBankingUserLoginMutation__
 *
 * To run a mutation, you first call `useBankingUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankingUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankingUserLoginMutation, { data, loading, error }] = useBankingUserLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankingUserLoginMutation(baseOptions?: Apollo.MutationHookOptions<BankingUserLoginMutation, BankingUserLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankingUserLoginMutation, BankingUserLoginMutationVariables>(BankingUserLoginDocument, options);
      }
export type BankingUserLoginMutationHookResult = ReturnType<typeof useBankingUserLoginMutation>;
export type BankingUserLoginMutationResult = Apollo.MutationResult<BankingUserLoginMutation>;
export type BankingUserLoginMutationOptions = Apollo.BaseMutationOptions<BankingUserLoginMutation, BankingUserLoginMutationVariables>;
export const BankingUserLoginV2Document = gql`
    mutation bankingUserLoginV2($input: LoginV2Input!) {
  loginV2(input: $input) {
    AccessToken
    TrustedDeviceToken
    CanUseTrustedDevice
    AuthMessage
    AuthError
    AuthSucceeded
    IsUsingGoogleAuth
    UserSession {
      Id
      FinanceSummary {
        Id
      }
      Features
      CurrentServerTime
      LastLoginAttempt
      LastLoginFrom
      LastPasswordChange
      IsFirstLogin
      Party {
        Id
        PartyNumber
        FirstName
        LastName
        FullName
      }
      IsSharia
    }
  }
}
    `;
export type BankingUserLoginV2MutationFn = Apollo.MutationFunction<BankingUserLoginV2Mutation, BankingUserLoginV2MutationVariables>;
export type BankingUserLoginV2ComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BankingUserLoginV2Mutation, BankingUserLoginV2MutationVariables>, 'mutation'>;

    export const BankingUserLoginV2Component = (props: BankingUserLoginV2ComponentProps) => (
      <ApolloReactComponents.Mutation<BankingUserLoginV2Mutation, BankingUserLoginV2MutationVariables> mutation={BankingUserLoginV2Document} {...props} />
    );
    
export type BankingUserLoginV2Props<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<BankingUserLoginV2Mutation, BankingUserLoginV2MutationVariables>
    } & TChildProps;
export function withBankingUserLoginV2<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BankingUserLoginV2Mutation,
  BankingUserLoginV2MutationVariables,
  BankingUserLoginV2Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, BankingUserLoginV2Mutation, BankingUserLoginV2MutationVariables, BankingUserLoginV2Props<TChildProps, TDataName>>(BankingUserLoginV2Document, {
      alias: 'bankingUserLoginV2',
      ...operationOptions
    });
};

/**
 * __useBankingUserLoginV2Mutation__
 *
 * To run a mutation, you first call `useBankingUserLoginV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankingUserLoginV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankingUserLoginV2Mutation, { data, loading, error }] = useBankingUserLoginV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankingUserLoginV2Mutation(baseOptions?: Apollo.MutationHookOptions<BankingUserLoginV2Mutation, BankingUserLoginV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankingUserLoginV2Mutation, BankingUserLoginV2MutationVariables>(BankingUserLoginV2Document, options);
      }
export type BankingUserLoginV2MutationHookResult = ReturnType<typeof useBankingUserLoginV2Mutation>;
export type BankingUserLoginV2MutationResult = Apollo.MutationResult<BankingUserLoginV2Mutation>;
export type BankingUserLoginV2MutationOptions = Apollo.BaseMutationOptions<BankingUserLoginV2Mutation, BankingUserLoginV2MutationVariables>;
export const DisableProfileAuthenticatorDocument = gql`
    mutation disableProfileAuthenticator($input: DisableProfileAuthenticatorInput!) {
  disableProfileAuthenticator(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export type DisableProfileAuthenticatorMutationFn = Apollo.MutationFunction<DisableProfileAuthenticatorMutation, DisableProfileAuthenticatorMutationVariables>;
export type DisableProfileAuthenticatorComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DisableProfileAuthenticatorMutation, DisableProfileAuthenticatorMutationVariables>, 'mutation'>;

    export const DisableProfileAuthenticatorComponent = (props: DisableProfileAuthenticatorComponentProps) => (
      <ApolloReactComponents.Mutation<DisableProfileAuthenticatorMutation, DisableProfileAuthenticatorMutationVariables> mutation={DisableProfileAuthenticatorDocument} {...props} />
    );
    
export type DisableProfileAuthenticatorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DisableProfileAuthenticatorMutation, DisableProfileAuthenticatorMutationVariables>
    } & TChildProps;
export function withDisableProfileAuthenticator<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DisableProfileAuthenticatorMutation,
  DisableProfileAuthenticatorMutationVariables,
  DisableProfileAuthenticatorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DisableProfileAuthenticatorMutation, DisableProfileAuthenticatorMutationVariables, DisableProfileAuthenticatorProps<TChildProps, TDataName>>(DisableProfileAuthenticatorDocument, {
      alias: 'disableProfileAuthenticator',
      ...operationOptions
    });
};

/**
 * __useDisableProfileAuthenticatorMutation__
 *
 * To run a mutation, you first call `useDisableProfileAuthenticatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableProfileAuthenticatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableProfileAuthenticatorMutation, { data, loading, error }] = useDisableProfileAuthenticatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableProfileAuthenticatorMutation(baseOptions?: Apollo.MutationHookOptions<DisableProfileAuthenticatorMutation, DisableProfileAuthenticatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableProfileAuthenticatorMutation, DisableProfileAuthenticatorMutationVariables>(DisableProfileAuthenticatorDocument, options);
      }
export type DisableProfileAuthenticatorMutationHookResult = ReturnType<typeof useDisableProfileAuthenticatorMutation>;
export type DisableProfileAuthenticatorMutationResult = Apollo.MutationResult<DisableProfileAuthenticatorMutation>;
export type DisableProfileAuthenticatorMutationOptions = Apollo.BaseMutationOptions<DisableProfileAuthenticatorMutation, DisableProfileAuthenticatorMutationVariables>;
export const EnableProfileAuthenticatorDocument = gql`
    mutation enableProfileAuthenticator($input: EnableProfileAuthenticatorInput!) {
  enableProfileAuthenticator(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export type EnableProfileAuthenticatorMutationFn = Apollo.MutationFunction<EnableProfileAuthenticatorMutation, EnableProfileAuthenticatorMutationVariables>;
export type EnableProfileAuthenticatorComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EnableProfileAuthenticatorMutation, EnableProfileAuthenticatorMutationVariables>, 'mutation'>;

    export const EnableProfileAuthenticatorComponent = (props: EnableProfileAuthenticatorComponentProps) => (
      <ApolloReactComponents.Mutation<EnableProfileAuthenticatorMutation, EnableProfileAuthenticatorMutationVariables> mutation={EnableProfileAuthenticatorDocument} {...props} />
    );
    
export type EnableProfileAuthenticatorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<EnableProfileAuthenticatorMutation, EnableProfileAuthenticatorMutationVariables>
    } & TChildProps;
export function withEnableProfileAuthenticator<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EnableProfileAuthenticatorMutation,
  EnableProfileAuthenticatorMutationVariables,
  EnableProfileAuthenticatorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EnableProfileAuthenticatorMutation, EnableProfileAuthenticatorMutationVariables, EnableProfileAuthenticatorProps<TChildProps, TDataName>>(EnableProfileAuthenticatorDocument, {
      alias: 'enableProfileAuthenticator',
      ...operationOptions
    });
};

/**
 * __useEnableProfileAuthenticatorMutation__
 *
 * To run a mutation, you first call `useEnableProfileAuthenticatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableProfileAuthenticatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableProfileAuthenticatorMutation, { data, loading, error }] = useEnableProfileAuthenticatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableProfileAuthenticatorMutation(baseOptions?: Apollo.MutationHookOptions<EnableProfileAuthenticatorMutation, EnableProfileAuthenticatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableProfileAuthenticatorMutation, EnableProfileAuthenticatorMutationVariables>(EnableProfileAuthenticatorDocument, options);
      }
export type EnableProfileAuthenticatorMutationHookResult = ReturnType<typeof useEnableProfileAuthenticatorMutation>;
export type EnableProfileAuthenticatorMutationResult = Apollo.MutationResult<EnableProfileAuthenticatorMutation>;
export type EnableProfileAuthenticatorMutationOptions = Apollo.BaseMutationOptions<EnableProfileAuthenticatorMutation, EnableProfileAuthenticatorMutationVariables>;
export const GenerateAuthSecretDocument = gql`
    mutation generateAuthSecret($input: GenerateAuthSecretInput!) {
  generateAuthSecret(input: $input) {
    clientMutationId
    Code
    Message
    Success
    AuthSecret
  }
}
    `;
export type GenerateAuthSecretMutationFn = Apollo.MutationFunction<GenerateAuthSecretMutation, GenerateAuthSecretMutationVariables>;
export type GenerateAuthSecretComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenerateAuthSecretMutation, GenerateAuthSecretMutationVariables>, 'mutation'>;

    export const GenerateAuthSecretComponent = (props: GenerateAuthSecretComponentProps) => (
      <ApolloReactComponents.Mutation<GenerateAuthSecretMutation, GenerateAuthSecretMutationVariables> mutation={GenerateAuthSecretDocument} {...props} />
    );
    
export type GenerateAuthSecretProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<GenerateAuthSecretMutation, GenerateAuthSecretMutationVariables>
    } & TChildProps;
export function withGenerateAuthSecret<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GenerateAuthSecretMutation,
  GenerateAuthSecretMutationVariables,
  GenerateAuthSecretProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GenerateAuthSecretMutation, GenerateAuthSecretMutationVariables, GenerateAuthSecretProps<TChildProps, TDataName>>(GenerateAuthSecretDocument, {
      alias: 'generateAuthSecret',
      ...operationOptions
    });
};

/**
 * __useGenerateAuthSecretMutation__
 *
 * To run a mutation, you first call `useGenerateAuthSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAuthSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAuthSecretMutation, { data, loading, error }] = useGenerateAuthSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAuthSecretMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAuthSecretMutation, GenerateAuthSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAuthSecretMutation, GenerateAuthSecretMutationVariables>(GenerateAuthSecretDocument, options);
      }
export type GenerateAuthSecretMutationHookResult = ReturnType<typeof useGenerateAuthSecretMutation>;
export type GenerateAuthSecretMutationResult = Apollo.MutationResult<GenerateAuthSecretMutation>;
export type GenerateAuthSecretMutationOptions = Apollo.BaseMutationOptions<GenerateAuthSecretMutation, GenerateAuthSecretMutationVariables>;
export const IsUserAuthenticatedDocument = gql`
    query isUserAuthenticated {
  userSession {
    Id
    Features
    CurrentServerTime
    LastLoginAttempt
    LastLoginFrom
    LastPasswordChange
    LastTermsAcceptance
    IsFirstLogin
    HasTempPassword
    UseMultiFactorAuth
    IsUsingGoogleAuth
    MFAEnforced
    PartyPaymentLimitsEnabled
    UnreadMessageCount
    Party {
      Id
      PartyNumber
      FullName
      OrganisationName
      FirstName
      LastName
      SearchName
      PreferredCorrespondanceType
    }
    CurrentSession {
      Id
      IsDeleted
      LastActivity
      SessionStart
      Expires
      EventDate
      IpAddress
      Successful
      ClientVersion
      UserAgentHeader
    }
    LoginAttempts {
      Id
      IsDeleted
      LastActivity
      SessionStart
      Expires
      EventDate
      IpAddress
      Successful
      ClientVersion
      UserAgentHeader
    }
  }
}
    `;
export type IsUserAuthenticatedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>, 'query'>;

    export const IsUserAuthenticatedComponent = (props: IsUserAuthenticatedComponentProps) => (
      <ApolloReactComponents.Query<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables> query={IsUserAuthenticatedDocument} {...props} />
    );
    
export type IsUserAuthenticatedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>
    } & TChildProps;
export function withIsUserAuthenticated<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IsUserAuthenticatedQuery,
  IsUserAuthenticatedQueryVariables,
  IsUserAuthenticatedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables, IsUserAuthenticatedProps<TChildProps, TDataName>>(IsUserAuthenticatedDocument, {
      alias: 'isUserAuthenticated',
      ...operationOptions
    });
};

/**
 * __useIsUserAuthenticatedQuery__
 *
 * To run a query within a React component, call `useIsUserAuthenticatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserAuthenticatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserAuthenticatedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsUserAuthenticatedQuery(baseOptions?: Apollo.QueryHookOptions<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>(IsUserAuthenticatedDocument, options);
      }
export function useIsUserAuthenticatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>(IsUserAuthenticatedDocument, options);
        }
export type IsUserAuthenticatedQueryHookResult = ReturnType<typeof useIsUserAuthenticatedQuery>;
export type IsUserAuthenticatedLazyQueryHookResult = ReturnType<typeof useIsUserAuthenticatedLazyQuery>;
export type IsUserAuthenticatedQueryResult = Apollo.QueryResult<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>;
export const PartyChangeElectronicCommsStatusDocument = gql`
    mutation partyChangeElectronicCommsStatus($input: ChangeElectronicCommsStatusInput!) {
  changeElectronicCommsStatus(input: $input) {
    clientMutationId
    Code
    Success
    Message
    SMSNotificationStatus
    EmailNotificationStatus
    StatementNotificationStatus
  }
}
    `;
export type PartyChangeElectronicCommsStatusMutationFn = Apollo.MutationFunction<PartyChangeElectronicCommsStatusMutation, PartyChangeElectronicCommsStatusMutationVariables>;
export type PartyChangeElectronicCommsStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PartyChangeElectronicCommsStatusMutation, PartyChangeElectronicCommsStatusMutationVariables>, 'mutation'>;

    export const PartyChangeElectronicCommsStatusComponent = (props: PartyChangeElectronicCommsStatusComponentProps) => (
      <ApolloReactComponents.Mutation<PartyChangeElectronicCommsStatusMutation, PartyChangeElectronicCommsStatusMutationVariables> mutation={PartyChangeElectronicCommsStatusDocument} {...props} />
    );
    
export type PartyChangeElectronicCommsStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<PartyChangeElectronicCommsStatusMutation, PartyChangeElectronicCommsStatusMutationVariables>
    } & TChildProps;
export function withPartyChangeElectronicCommsStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PartyChangeElectronicCommsStatusMutation,
  PartyChangeElectronicCommsStatusMutationVariables,
  PartyChangeElectronicCommsStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, PartyChangeElectronicCommsStatusMutation, PartyChangeElectronicCommsStatusMutationVariables, PartyChangeElectronicCommsStatusProps<TChildProps, TDataName>>(PartyChangeElectronicCommsStatusDocument, {
      alias: 'partyChangeElectronicCommsStatus',
      ...operationOptions
    });
};

/**
 * __usePartyChangeElectronicCommsStatusMutation__
 *
 * To run a mutation, you first call `usePartyChangeElectronicCommsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartyChangeElectronicCommsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partyChangeElectronicCommsStatusMutation, { data, loading, error }] = usePartyChangeElectronicCommsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyChangeElectronicCommsStatusMutation(baseOptions?: Apollo.MutationHookOptions<PartyChangeElectronicCommsStatusMutation, PartyChangeElectronicCommsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartyChangeElectronicCommsStatusMutation, PartyChangeElectronicCommsStatusMutationVariables>(PartyChangeElectronicCommsStatusDocument, options);
      }
export type PartyChangeElectronicCommsStatusMutationHookResult = ReturnType<typeof usePartyChangeElectronicCommsStatusMutation>;
export type PartyChangeElectronicCommsStatusMutationResult = Apollo.MutationResult<PartyChangeElectronicCommsStatusMutation>;
export type PartyChangeElectronicCommsStatusMutationOptions = Apollo.BaseMutationOptions<PartyChangeElectronicCommsStatusMutation, PartyChangeElectronicCommsStatusMutationVariables>;
export const PartyChangeMarketingCommsStatusDocument = gql`
    mutation partyChangeMarketingCommsStatus($input: ChangeMarketingCommsStatusInput!) {
  changeMarketingCommsStatus(input: $input) {
    clientMutationId
    Code
    Success
    Message
    MarketingStatus
  }
}
    `;
export type PartyChangeMarketingCommsStatusMutationFn = Apollo.MutationFunction<PartyChangeMarketingCommsStatusMutation, PartyChangeMarketingCommsStatusMutationVariables>;
export type PartyChangeMarketingCommsStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PartyChangeMarketingCommsStatusMutation, PartyChangeMarketingCommsStatusMutationVariables>, 'mutation'>;

    export const PartyChangeMarketingCommsStatusComponent = (props: PartyChangeMarketingCommsStatusComponentProps) => (
      <ApolloReactComponents.Mutation<PartyChangeMarketingCommsStatusMutation, PartyChangeMarketingCommsStatusMutationVariables> mutation={PartyChangeMarketingCommsStatusDocument} {...props} />
    );
    
export type PartyChangeMarketingCommsStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<PartyChangeMarketingCommsStatusMutation, PartyChangeMarketingCommsStatusMutationVariables>
    } & TChildProps;
export function withPartyChangeMarketingCommsStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PartyChangeMarketingCommsStatusMutation,
  PartyChangeMarketingCommsStatusMutationVariables,
  PartyChangeMarketingCommsStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, PartyChangeMarketingCommsStatusMutation, PartyChangeMarketingCommsStatusMutationVariables, PartyChangeMarketingCommsStatusProps<TChildProps, TDataName>>(PartyChangeMarketingCommsStatusDocument, {
      alias: 'partyChangeMarketingCommsStatus',
      ...operationOptions
    });
};

/**
 * __usePartyChangeMarketingCommsStatusMutation__
 *
 * To run a mutation, you first call `usePartyChangeMarketingCommsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartyChangeMarketingCommsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partyChangeMarketingCommsStatusMutation, { data, loading, error }] = usePartyChangeMarketingCommsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyChangeMarketingCommsStatusMutation(baseOptions?: Apollo.MutationHookOptions<PartyChangeMarketingCommsStatusMutation, PartyChangeMarketingCommsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartyChangeMarketingCommsStatusMutation, PartyChangeMarketingCommsStatusMutationVariables>(PartyChangeMarketingCommsStatusDocument, options);
      }
export type PartyChangeMarketingCommsStatusMutationHookResult = ReturnType<typeof usePartyChangeMarketingCommsStatusMutation>;
export type PartyChangeMarketingCommsStatusMutationResult = Apollo.MutationResult<PartyChangeMarketingCommsStatusMutation>;
export type PartyChangeMarketingCommsStatusMutationOptions = Apollo.BaseMutationOptions<PartyChangeMarketingCommsStatusMutation, PartyChangeMarketingCommsStatusMutationVariables>;
export const PartyChangePersonalDetailsDocument = gql`
    mutation partyChangePersonalDetails($input: PartyPersonalDetailsInput!) {
  partyPersonalDetails(input: $input) {
    clientMutationId
    Code
    Success
    Message
    PreferredCorrespondenceMethod
  }
}
    `;
export type PartyChangePersonalDetailsMutationFn = Apollo.MutationFunction<PartyChangePersonalDetailsMutation, PartyChangePersonalDetailsMutationVariables>;
export type PartyChangePersonalDetailsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PartyChangePersonalDetailsMutation, PartyChangePersonalDetailsMutationVariables>, 'mutation'>;

    export const PartyChangePersonalDetailsComponent = (props: PartyChangePersonalDetailsComponentProps) => (
      <ApolloReactComponents.Mutation<PartyChangePersonalDetailsMutation, PartyChangePersonalDetailsMutationVariables> mutation={PartyChangePersonalDetailsDocument} {...props} />
    );
    
export type PartyChangePersonalDetailsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<PartyChangePersonalDetailsMutation, PartyChangePersonalDetailsMutationVariables>
    } & TChildProps;
export function withPartyChangePersonalDetails<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PartyChangePersonalDetailsMutation,
  PartyChangePersonalDetailsMutationVariables,
  PartyChangePersonalDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, PartyChangePersonalDetailsMutation, PartyChangePersonalDetailsMutationVariables, PartyChangePersonalDetailsProps<TChildProps, TDataName>>(PartyChangePersonalDetailsDocument, {
      alias: 'partyChangePersonalDetails',
      ...operationOptions
    });
};

/**
 * __usePartyChangePersonalDetailsMutation__
 *
 * To run a mutation, you first call `usePartyChangePersonalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartyChangePersonalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partyChangePersonalDetailsMutation, { data, loading, error }] = usePartyChangePersonalDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyChangePersonalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<PartyChangePersonalDetailsMutation, PartyChangePersonalDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartyChangePersonalDetailsMutation, PartyChangePersonalDetailsMutationVariables>(PartyChangePersonalDetailsDocument, options);
      }
export type PartyChangePersonalDetailsMutationHookResult = ReturnType<typeof usePartyChangePersonalDetailsMutation>;
export type PartyChangePersonalDetailsMutationResult = Apollo.MutationResult<PartyChangePersonalDetailsMutation>;
export type PartyChangePersonalDetailsMutationOptions = Apollo.BaseMutationOptions<PartyChangePersonalDetailsMutation, PartyChangePersonalDetailsMutationVariables>;
export const PartyElectronicCommsStatusDocument = gql`
    query partyElectronicCommsStatus {
  electronicComms {
    SMSNotificationStatus
    EmailNotificationStatus
    StatementNotificationStatus
  }
}
    `;
export type PartyElectronicCommsStatusComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables>, 'query'>;

    export const PartyElectronicCommsStatusComponent = (props: PartyElectronicCommsStatusComponentProps) => (
      <ApolloReactComponents.Query<PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables> query={PartyElectronicCommsStatusDocument} {...props} />
    );
    
export type PartyElectronicCommsStatusProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables>
    } & TChildProps;
export function withPartyElectronicCommsStatus<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PartyElectronicCommsStatusQuery,
  PartyElectronicCommsStatusQueryVariables,
  PartyElectronicCommsStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables, PartyElectronicCommsStatusProps<TChildProps, TDataName>>(PartyElectronicCommsStatusDocument, {
      alias: 'partyElectronicCommsStatus',
      ...operationOptions
    });
};

/**
 * __usePartyElectronicCommsStatusQuery__
 *
 * To run a query within a React component, call `usePartyElectronicCommsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyElectronicCommsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyElectronicCommsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartyElectronicCommsStatusQuery(baseOptions?: Apollo.QueryHookOptions<PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables>(PartyElectronicCommsStatusDocument, options);
      }
export function usePartyElectronicCommsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables>(PartyElectronicCommsStatusDocument, options);
        }
export type PartyElectronicCommsStatusQueryHookResult = ReturnType<typeof usePartyElectronicCommsStatusQuery>;
export type PartyElectronicCommsStatusLazyQueryHookResult = ReturnType<typeof usePartyElectronicCommsStatusLazyQuery>;
export type PartyElectronicCommsStatusQueryResult = Apollo.QueryResult<PartyElectronicCommsStatusQuery, PartyElectronicCommsStatusQueryVariables>;
export const PartyProfileDetailsDocument = gql`
    query partyProfileDetails {
  userSession {
    Id
    IsDeleted
    LastLoginAttempt
    LastLoginFrom
    LastPasswordChange
    PartyPaymentLimitsEnabled
    Party {
      AcceptsAdvertising
      Addresses {
        Address {
          AddressDetailType
          AddressLine1
          AddressLine2
          AddressLine3
          AddressLine4
          Building
          Country {
            Name
          }
          FloorName
          FloorNumber
          HasBeenVerified
          Id
          IsValid
          LotNumber
          PostalBoxDetails
          PostalCode
          PropertyName
          Region {
            Abbreviation
            Name
          }
          StreetName
          StreetNumberFrom
          StreetNumberTo
          StreetType
          SuburbTown
          UnitNumber
        }
        Id
        IsDefaultMailingAddress
        IsDefaultResidentialAddress
        IsDeleted
        IsPrevious
      }
      Contacts {
        Details
        Id
        IsDeleted
        IsPreferredEmail
        IsPreferredPhone
        IsPreferredSms
        Type {
          Description
          Id
          IsPhone
          ReceiveMessages
        }
      }
      EntityType
      FirstName
      Id
      LastName
      OrganisationName
      PartyNumber
      PreferredCorrespondanceType
    }
    UseMultiFactorAuth
  }
}
    `;
export type PartyProfileDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables>, 'query'>;

    export const PartyProfileDetailsComponent = (props: PartyProfileDetailsComponentProps) => (
      <ApolloReactComponents.Query<PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables> query={PartyProfileDetailsDocument} {...props} />
    );
    
export type PartyProfileDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables>
    } & TChildProps;
export function withPartyProfileDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PartyProfileDetailsQuery,
  PartyProfileDetailsQueryVariables,
  PartyProfileDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables, PartyProfileDetailsProps<TChildProps, TDataName>>(PartyProfileDetailsDocument, {
      alias: 'partyProfileDetails',
      ...operationOptions
    });
};

/**
 * __usePartyProfileDetailsQuery__
 *
 * To run a query within a React component, call `usePartyProfileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyProfileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyProfileDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartyProfileDetailsQuery(baseOptions?: Apollo.QueryHookOptions<PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables>(PartyProfileDetailsDocument, options);
      }
export function usePartyProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables>(PartyProfileDetailsDocument, options);
        }
export type PartyProfileDetailsQueryHookResult = ReturnType<typeof usePartyProfileDetailsQuery>;
export type PartyProfileDetailsLazyQueryHookResult = ReturnType<typeof usePartyProfileDetailsLazyQuery>;
export type PartyProfileDetailsQueryResult = Apollo.QueryResult<PartyProfileDetailsQuery, PartyProfileDetailsQueryVariables>;
export const IndueCardActivateCardDocument = gql`
    mutation IndueCardActivateCard($input: IndueCardActivateCardInput!) {
  indueActivateCard(input: $input) {
    Result
    Success
    ActivateCardResult
    ChangePinResult
    Card {
      Id
      Status
    }
  }
}
    `;
export type IndueCardActivateCardMutationFn = Apollo.MutationFunction<IndueCardActivateCardMutation, IndueCardActivateCardMutationVariables>;
export type IndueCardActivateCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IndueCardActivateCardMutation, IndueCardActivateCardMutationVariables>, 'mutation'>;

    export const IndueCardActivateCardComponent = (props: IndueCardActivateCardComponentProps) => (
      <ApolloReactComponents.Mutation<IndueCardActivateCardMutation, IndueCardActivateCardMutationVariables> mutation={IndueCardActivateCardDocument} {...props} />
    );
    
export type IndueCardActivateCardProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<IndueCardActivateCardMutation, IndueCardActivateCardMutationVariables>
    } & TChildProps;
export function withIndueCardActivateCard<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IndueCardActivateCardMutation,
  IndueCardActivateCardMutationVariables,
  IndueCardActivateCardProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, IndueCardActivateCardMutation, IndueCardActivateCardMutationVariables, IndueCardActivateCardProps<TChildProps, TDataName>>(IndueCardActivateCardDocument, {
      alias: 'indueCardActivateCard',
      ...operationOptions
    });
};

/**
 * __useIndueCardActivateCardMutation__
 *
 * To run a mutation, you first call `useIndueCardActivateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndueCardActivateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indueCardActivateCardMutation, { data, loading, error }] = useIndueCardActivateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardActivateCardMutation(baseOptions?: Apollo.MutationHookOptions<IndueCardActivateCardMutation, IndueCardActivateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IndueCardActivateCardMutation, IndueCardActivateCardMutationVariables>(IndueCardActivateCardDocument, options);
      }
export type IndueCardActivateCardMutationHookResult = ReturnType<typeof useIndueCardActivateCardMutation>;
export type IndueCardActivateCardMutationResult = Apollo.MutationResult<IndueCardActivateCardMutation>;
export type IndueCardActivateCardMutationOptions = Apollo.BaseMutationOptions<IndueCardActivateCardMutation, IndueCardActivateCardMutationVariables>;
export const IndueCardChangePinDocument = gql`
    mutation IndueCardChangePin($input: IndueCardChangePinInput!) {
  changePin(input: $input) {
    Result
    Card {
      CardNumber
      ExpiryDate
      Id
      Status
    }
  }
}
    `;
export type IndueCardChangePinMutationFn = Apollo.MutationFunction<IndueCardChangePinMutation, IndueCardChangePinMutationVariables>;
export type IndueCardChangePinComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IndueCardChangePinMutation, IndueCardChangePinMutationVariables>, 'mutation'>;

    export const IndueCardChangePinComponent = (props: IndueCardChangePinComponentProps) => (
      <ApolloReactComponents.Mutation<IndueCardChangePinMutation, IndueCardChangePinMutationVariables> mutation={IndueCardChangePinDocument} {...props} />
    );
    
export type IndueCardChangePinProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<IndueCardChangePinMutation, IndueCardChangePinMutationVariables>
    } & TChildProps;
export function withIndueCardChangePin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IndueCardChangePinMutation,
  IndueCardChangePinMutationVariables,
  IndueCardChangePinProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, IndueCardChangePinMutation, IndueCardChangePinMutationVariables, IndueCardChangePinProps<TChildProps, TDataName>>(IndueCardChangePinDocument, {
      alias: 'indueCardChangePin',
      ...operationOptions
    });
};

/**
 * __useIndueCardChangePinMutation__
 *
 * To run a mutation, you first call `useIndueCardChangePinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndueCardChangePinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indueCardChangePinMutation, { data, loading, error }] = useIndueCardChangePinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardChangePinMutation(baseOptions?: Apollo.MutationHookOptions<IndueCardChangePinMutation, IndueCardChangePinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IndueCardChangePinMutation, IndueCardChangePinMutationVariables>(IndueCardChangePinDocument, options);
      }
export type IndueCardChangePinMutationHookResult = ReturnType<typeof useIndueCardChangePinMutation>;
export type IndueCardChangePinMutationResult = Apollo.MutationResult<IndueCardChangePinMutation>;
export type IndueCardChangePinMutationOptions = Apollo.BaseMutationOptions<IndueCardChangePinMutation, IndueCardChangePinMutationVariables>;
export const IndueCardChangeStatusDocument = gql`
    mutation IndueCardChangeStatus($input: IndueCardChangeStatusInput!) {
  changeStatus(input: $input) {
    Result
    Card {
      CardNumber
      ExpiryDate
      Id
      Status
    }
  }
}
    `;
export type IndueCardChangeStatusMutationFn = Apollo.MutationFunction<IndueCardChangeStatusMutation, IndueCardChangeStatusMutationVariables>;
export type IndueCardChangeStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IndueCardChangeStatusMutation, IndueCardChangeStatusMutationVariables>, 'mutation'>;

    export const IndueCardChangeStatusComponent = (props: IndueCardChangeStatusComponentProps) => (
      <ApolloReactComponents.Mutation<IndueCardChangeStatusMutation, IndueCardChangeStatusMutationVariables> mutation={IndueCardChangeStatusDocument} {...props} />
    );
    
export type IndueCardChangeStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<IndueCardChangeStatusMutation, IndueCardChangeStatusMutationVariables>
    } & TChildProps;
export function withIndueCardChangeStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IndueCardChangeStatusMutation,
  IndueCardChangeStatusMutationVariables,
  IndueCardChangeStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, IndueCardChangeStatusMutation, IndueCardChangeStatusMutationVariables, IndueCardChangeStatusProps<TChildProps, TDataName>>(IndueCardChangeStatusDocument, {
      alias: 'indueCardChangeStatus',
      ...operationOptions
    });
};

/**
 * __useIndueCardChangeStatusMutation__
 *
 * To run a mutation, you first call `useIndueCardChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndueCardChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indueCardChangeStatusMutation, { data, loading, error }] = useIndueCardChangeStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardChangeStatusMutation(baseOptions?: Apollo.MutationHookOptions<IndueCardChangeStatusMutation, IndueCardChangeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IndueCardChangeStatusMutation, IndueCardChangeStatusMutationVariables>(IndueCardChangeStatusDocument, options);
      }
export type IndueCardChangeStatusMutationHookResult = ReturnType<typeof useIndueCardChangeStatusMutation>;
export type IndueCardChangeStatusMutationResult = Apollo.MutationResult<IndueCardChangeStatusMutation>;
export type IndueCardChangeStatusMutationOptions = Apollo.BaseMutationOptions<IndueCardChangeStatusMutation, IndueCardChangeStatusMutationVariables>;
export const IndueCardCreateCardDocument = gql`
    mutation IndueCardCreateCard($input: IndueCardCreateCardInput!) {
  createCard(input: $input) {
    Success
    Code
    Message
    Card {
      Id
      Status
    }
  }
}
    `;
export type IndueCardCreateCardMutationFn = Apollo.MutationFunction<IndueCardCreateCardMutation, IndueCardCreateCardMutationVariables>;
export type IndueCardCreateCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IndueCardCreateCardMutation, IndueCardCreateCardMutationVariables>, 'mutation'>;

    export const IndueCardCreateCardComponent = (props: IndueCardCreateCardComponentProps) => (
      <ApolloReactComponents.Mutation<IndueCardCreateCardMutation, IndueCardCreateCardMutationVariables> mutation={IndueCardCreateCardDocument} {...props} />
    );
    
export type IndueCardCreateCardProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<IndueCardCreateCardMutation, IndueCardCreateCardMutationVariables>
    } & TChildProps;
export function withIndueCardCreateCard<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IndueCardCreateCardMutation,
  IndueCardCreateCardMutationVariables,
  IndueCardCreateCardProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, IndueCardCreateCardMutation, IndueCardCreateCardMutationVariables, IndueCardCreateCardProps<TChildProps, TDataName>>(IndueCardCreateCardDocument, {
      alias: 'indueCardCreateCard',
      ...operationOptions
    });
};

/**
 * __useIndueCardCreateCardMutation__
 *
 * To run a mutation, you first call `useIndueCardCreateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndueCardCreateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indueCardCreateCardMutation, { data, loading, error }] = useIndueCardCreateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardCreateCardMutation(baseOptions?: Apollo.MutationHookOptions<IndueCardCreateCardMutation, IndueCardCreateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IndueCardCreateCardMutation, IndueCardCreateCardMutationVariables>(IndueCardCreateCardDocument, options);
      }
export type IndueCardCreateCardMutationHookResult = ReturnType<typeof useIndueCardCreateCardMutation>;
export type IndueCardCreateCardMutationResult = Apollo.MutationResult<IndueCardCreateCardMutation>;
export type IndueCardCreateCardMutationOptions = Apollo.BaseMutationOptions<IndueCardCreateCardMutation, IndueCardCreateCardMutationVariables>;
export const IndueCardDetailsDocument = gql`
    query indueCardDetails($input: IndueCardDetailsInput!) {
  indueCardDetails(input: $input) {
    CardNumber
    ExpiryDate
    Id
    Status
    CanActivate
    CanHold
    CanUnHold
    CanReportLostStolen
    CanClose
  }
}
    `;
export type IndueCardDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IndueCardDetailsQuery, IndueCardDetailsQueryVariables>, 'query'> & ({ variables: IndueCardDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IndueCardDetailsComponent = (props: IndueCardDetailsComponentProps) => (
      <ApolloReactComponents.Query<IndueCardDetailsQuery, IndueCardDetailsQueryVariables> query={IndueCardDetailsDocument} {...props} />
    );
    
export type IndueCardDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IndueCardDetailsQuery, IndueCardDetailsQueryVariables>
    } & TChildProps;
export function withIndueCardDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IndueCardDetailsQuery,
  IndueCardDetailsQueryVariables,
  IndueCardDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IndueCardDetailsQuery, IndueCardDetailsQueryVariables, IndueCardDetailsProps<TChildProps, TDataName>>(IndueCardDetailsDocument, {
      alias: 'indueCardDetails',
      ...operationOptions
    });
};

/**
 * __useIndueCardDetailsQuery__
 *
 * To run a query within a React component, call `useIndueCardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndueCardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndueCardDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardDetailsQuery(baseOptions: Apollo.QueryHookOptions<IndueCardDetailsQuery, IndueCardDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndueCardDetailsQuery, IndueCardDetailsQueryVariables>(IndueCardDetailsDocument, options);
      }
export function useIndueCardDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndueCardDetailsQuery, IndueCardDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndueCardDetailsQuery, IndueCardDetailsQueryVariables>(IndueCardDetailsDocument, options);
        }
export type IndueCardDetailsQueryHookResult = ReturnType<typeof useIndueCardDetailsQuery>;
export type IndueCardDetailsLazyQueryHookResult = ReturnType<typeof useIndueCardDetailsLazyQuery>;
export type IndueCardDetailsQueryResult = Apollo.QueryResult<IndueCardDetailsQuery, IndueCardDetailsQueryVariables>;
export const IndueCardsandAssociationsByAccountDocument = gql`
    query indueCardsandAssociationsByAccount($accountId: Uuid!, $accountIdString: String!) {
  indueCardsByAccount(input: {AccountId: $accountId}) {
    CardNumber
    ExpiryDate
    Id
    Status
    CanActivate
    CanHold
    CanUnHold
    CanReportLostStolen
    CanClose
  }
  partyAssociationByAccount(input: {Id: $accountIdString}) {
    IsPrimaryBorrower
    IsSecondaryBorrower
    IsNonBorrower
    PrimaryBorrowerHasCard
  }
  accountByIdOrNumber(idOrNumber: $accountIdString) {
    Id
    CurrentUserAccountAuthority {
      Id
      BPay
      Operate
      InterAccount
      DirectDebit
      PayAnyone
      Redraw
      View
    }
  }
}
    `;
export type IndueCardsandAssociationsByAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables>, 'query'> & ({ variables: IndueCardsandAssociationsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IndueCardsandAssociationsByAccountComponent = (props: IndueCardsandAssociationsByAccountComponentProps) => (
      <ApolloReactComponents.Query<IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables> query={IndueCardsandAssociationsByAccountDocument} {...props} />
    );
    
export type IndueCardsandAssociationsByAccountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables>
    } & TChildProps;
export function withIndueCardsandAssociationsByAccount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IndueCardsandAssociationsByAccountQuery,
  IndueCardsandAssociationsByAccountQueryVariables,
  IndueCardsandAssociationsByAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables, IndueCardsandAssociationsByAccountProps<TChildProps, TDataName>>(IndueCardsandAssociationsByAccountDocument, {
      alias: 'indueCardsandAssociationsByAccount',
      ...operationOptions
    });
};

/**
 * __useIndueCardsandAssociationsByAccountQuery__
 *
 * To run a query within a React component, call `useIndueCardsandAssociationsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndueCardsandAssociationsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndueCardsandAssociationsByAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      accountIdString: // value for 'accountIdString'
 *   },
 * });
 */
export function useIndueCardsandAssociationsByAccountQuery(baseOptions: Apollo.QueryHookOptions<IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables>(IndueCardsandAssociationsByAccountDocument, options);
      }
export function useIndueCardsandAssociationsByAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables>(IndueCardsandAssociationsByAccountDocument, options);
        }
export type IndueCardsandAssociationsByAccountQueryHookResult = ReturnType<typeof useIndueCardsandAssociationsByAccountQuery>;
export type IndueCardsandAssociationsByAccountLazyQueryHookResult = ReturnType<typeof useIndueCardsandAssociationsByAccountLazyQuery>;
export type IndueCardsandAssociationsByAccountQueryResult = Apollo.QueryResult<IndueCardsandAssociationsByAccountQuery, IndueCardsandAssociationsByAccountQueryVariables>;
export const IndueCardsByAccountDocument = gql`
    query indueCardsByAccount($input: IndueCardsByAccountInput!) {
  indueCardsByAccount(input: $input) {
    CardNumber
    ExpiryDate
    Id
    Status
    CanActivate
    CanHold
    CanUnHold
    CanReportLostStolen
    CanClose
  }
}
    `;
export type IndueCardsByAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables>, 'query'> & ({ variables: IndueCardsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IndueCardsByAccountComponent = (props: IndueCardsByAccountComponentProps) => (
      <ApolloReactComponents.Query<IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables> query={IndueCardsByAccountDocument} {...props} />
    );
    
export type IndueCardsByAccountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables>
    } & TChildProps;
export function withIndueCardsByAccount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IndueCardsByAccountQuery,
  IndueCardsByAccountQueryVariables,
  IndueCardsByAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables, IndueCardsByAccountProps<TChildProps, TDataName>>(IndueCardsByAccountDocument, {
      alias: 'indueCardsByAccount',
      ...operationOptions
    });
};

/**
 * __useIndueCardsByAccountQuery__
 *
 * To run a query within a React component, call `useIndueCardsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndueCardsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndueCardsByAccountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardsByAccountQuery(baseOptions: Apollo.QueryHookOptions<IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables>(IndueCardsByAccountDocument, options);
      }
export function useIndueCardsByAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables>(IndueCardsByAccountDocument, options);
        }
export type IndueCardsByAccountQueryHookResult = ReturnType<typeof useIndueCardsByAccountQuery>;
export type IndueCardsByAccountLazyQueryHookResult = ReturnType<typeof useIndueCardsByAccountLazyQuery>;
export type IndueCardsByAccountQueryResult = Apollo.QueryResult<IndueCardsByAccountQuery, IndueCardsByAccountQueryVariables>;
export const PartyAssociationByAccountDocument = gql`
    query partyAssociationByAccount($input: PartyAssociationByAccountInput!) {
  partyAssociationByAccount(input: $input) {
    IsPrimaryBorrower
    IsSecondaryBorrower
    IsNonBorrower
    PrimaryBorrowerHasCard
  }
}
    `;
export type PartyAssociationByAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables>, 'query'> & ({ variables: PartyAssociationByAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PartyAssociationByAccountComponent = (props: PartyAssociationByAccountComponentProps) => (
      <ApolloReactComponents.Query<PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables> query={PartyAssociationByAccountDocument} {...props} />
    );
    
export type PartyAssociationByAccountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables>
    } & TChildProps;
export function withPartyAssociationByAccount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PartyAssociationByAccountQuery,
  PartyAssociationByAccountQueryVariables,
  PartyAssociationByAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables, PartyAssociationByAccountProps<TChildProps, TDataName>>(PartyAssociationByAccountDocument, {
      alias: 'partyAssociationByAccount',
      ...operationOptions
    });
};

/**
 * __usePartyAssociationByAccountQuery__
 *
 * To run a query within a React component, call `usePartyAssociationByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyAssociationByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyAssociationByAccountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyAssociationByAccountQuery(baseOptions: Apollo.QueryHookOptions<PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables>(PartyAssociationByAccountDocument, options);
      }
export function usePartyAssociationByAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables>(PartyAssociationByAccountDocument, options);
        }
export type PartyAssociationByAccountQueryHookResult = ReturnType<typeof usePartyAssociationByAccountQuery>;
export type PartyAssociationByAccountLazyQueryHookResult = ReturnType<typeof usePartyAssociationByAccountLazyQuery>;
export type PartyAssociationByAccountQueryResult = Apollo.QueryResult<PartyAssociationByAccountQuery, PartyAssociationByAccountQueryVariables>;
export const RequestNewMultiFactorSecurityTokenDocument = gql`
    mutation requestNewMultiFactorSecurityToken($input: RequestMultiFactorAuthorisationInput!) {
  requestMultiFactorAuthorisation(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export type RequestNewMultiFactorSecurityTokenMutationFn = Apollo.MutationFunction<RequestNewMultiFactorSecurityTokenMutation, RequestNewMultiFactorSecurityTokenMutationVariables>;
export type RequestNewMultiFactorSecurityTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestNewMultiFactorSecurityTokenMutation, RequestNewMultiFactorSecurityTokenMutationVariables>, 'mutation'>;

    export const RequestNewMultiFactorSecurityTokenComponent = (props: RequestNewMultiFactorSecurityTokenComponentProps) => (
      <ApolloReactComponents.Mutation<RequestNewMultiFactorSecurityTokenMutation, RequestNewMultiFactorSecurityTokenMutationVariables> mutation={RequestNewMultiFactorSecurityTokenDocument} {...props} />
    );
    
export type RequestNewMultiFactorSecurityTokenProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RequestNewMultiFactorSecurityTokenMutation, RequestNewMultiFactorSecurityTokenMutationVariables>
    } & TChildProps;
export function withRequestNewMultiFactorSecurityToken<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestNewMultiFactorSecurityTokenMutation,
  RequestNewMultiFactorSecurityTokenMutationVariables,
  RequestNewMultiFactorSecurityTokenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestNewMultiFactorSecurityTokenMutation, RequestNewMultiFactorSecurityTokenMutationVariables, RequestNewMultiFactorSecurityTokenProps<TChildProps, TDataName>>(RequestNewMultiFactorSecurityTokenDocument, {
      alias: 'requestNewMultiFactorSecurityToken',
      ...operationOptions
    });
};

/**
 * __useRequestNewMultiFactorSecurityTokenMutation__
 *
 * To run a mutation, you first call `useRequestNewMultiFactorSecurityTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNewMultiFactorSecurityTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNewMultiFactorSecurityTokenMutation, { data, loading, error }] = useRequestNewMultiFactorSecurityTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestNewMultiFactorSecurityTokenMutation(baseOptions?: Apollo.MutationHookOptions<RequestNewMultiFactorSecurityTokenMutation, RequestNewMultiFactorSecurityTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestNewMultiFactorSecurityTokenMutation, RequestNewMultiFactorSecurityTokenMutationVariables>(RequestNewMultiFactorSecurityTokenDocument, options);
      }
export type RequestNewMultiFactorSecurityTokenMutationHookResult = ReturnType<typeof useRequestNewMultiFactorSecurityTokenMutation>;
export type RequestNewMultiFactorSecurityTokenMutationResult = Apollo.MutationResult<RequestNewMultiFactorSecurityTokenMutation>;
export type RequestNewMultiFactorSecurityTokenMutationOptions = Apollo.BaseMutationOptions<RequestNewMultiFactorSecurityTokenMutation, RequestNewMultiFactorSecurityTokenMutationVariables>;
export const DisbursementRequestDocument = gql`
    mutation disbursementRequest($input: DisbursementRequestInput!) {
  disbursementRequest(input: $input) {
    clientMutationId
    Code
    Success
    Message
    Data {
      Id
      PayeeName
      BankIdentifierText
      AccountNumber
      PaymentDescription
      RequestedAmount
      PaymentDate
      Documents {
        Id
        FileName
        Name
        CreatedOn
        DocumentType
        IsDeleted
        PrivacyLevel
      }
    }
  }
}
    `;
export type DisbursementRequestMutationFn = Apollo.MutationFunction<DisbursementRequestMutation, DisbursementRequestMutationVariables>;
export type DisbursementRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DisbursementRequestMutation, DisbursementRequestMutationVariables>, 'mutation'>;

    export const DisbursementRequestComponent = (props: DisbursementRequestComponentProps) => (
      <ApolloReactComponents.Mutation<DisbursementRequestMutation, DisbursementRequestMutationVariables> mutation={DisbursementRequestDocument} {...props} />
    );
    
export type DisbursementRequestProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DisbursementRequestMutation, DisbursementRequestMutationVariables>
    } & TChildProps;
export function withDisbursementRequest<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DisbursementRequestMutation,
  DisbursementRequestMutationVariables,
  DisbursementRequestProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DisbursementRequestMutation, DisbursementRequestMutationVariables, DisbursementRequestProps<TChildProps, TDataName>>(DisbursementRequestDocument, {
      alias: 'disbursementRequest',
      ...operationOptions
    });
};

/**
 * __useDisbursementRequestMutation__
 *
 * To run a mutation, you first call `useDisbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disbursementRequestMutation, { data, loading, error }] = useDisbursementRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<DisbursementRequestMutation, DisbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisbursementRequestMutation, DisbursementRequestMutationVariables>(DisbursementRequestDocument, options);
      }
export type DisbursementRequestMutationHookResult = ReturnType<typeof useDisbursementRequestMutation>;
export type DisbursementRequestMutationResult = Apollo.MutationResult<DisbursementRequestMutation>;
export type DisbursementRequestMutationOptions = Apollo.BaseMutationOptions<DisbursementRequestMutation, DisbursementRequestMutationVariables>;
export const FinanceSummaryQueryInlineDocument = gql`
    query financeSummaryQueryInline {
  financeSummary {
    Id
    TotalPrincipal {
      CurrencyCode
      Amount
    }
    TotalRedraw {
      CurrencyCode
      Amount
    }
    Instruments {
      Id
      Number
      LoanPurpose
      Description
      TotalPrincipal
      TotalRedraw
      Status
      IsUnderHardshipAgreement
      InstrumentType
      Term
      TotalTermMonths
      RemainingTermMonths
      MaturityDate
      PrimaryBorrower
      Accounts {
        Id
        Number
        Description
        DisplayOrder
        InstrumentId
        LegacyNumber
        ProductType
        CurrentBalance
        Redraw
        InterestType
        CardAccount
        RemainingDisbursementAmount
      }
    }
  }
}
    `;
export type FinanceSummaryQueryInlineComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables>, 'query'>;

    export const FinanceSummaryQueryInlineComponent = (props: FinanceSummaryQueryInlineComponentProps) => (
      <ApolloReactComponents.Query<FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables> query={FinanceSummaryQueryInlineDocument} {...props} />
    );
    
export type FinanceSummaryQueryInlineProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables>
    } & TChildProps;
export function withFinanceSummaryQueryInline<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FinanceSummaryQueryInlineQuery,
  FinanceSummaryQueryInlineQueryVariables,
  FinanceSummaryQueryInlineProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables, FinanceSummaryQueryInlineProps<TChildProps, TDataName>>(FinanceSummaryQueryInlineDocument, {
      alias: 'financeSummaryQueryInline',
      ...operationOptions
    });
};

/**
 * __useFinanceSummaryQueryInlineQuery__
 *
 * To run a query within a React component, call `useFinanceSummaryQueryInlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceSummaryQueryInlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinanceSummaryQueryInlineQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinanceSummaryQueryInlineQuery(baseOptions?: Apollo.QueryHookOptions<FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables>(FinanceSummaryQueryInlineDocument, options);
      }
export function useFinanceSummaryQueryInlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables>(FinanceSummaryQueryInlineDocument, options);
        }
export type FinanceSummaryQueryInlineQueryHookResult = ReturnType<typeof useFinanceSummaryQueryInlineQuery>;
export type FinanceSummaryQueryInlineLazyQueryHookResult = ReturnType<typeof useFinanceSummaryQueryInlineLazyQuery>;
export type FinanceSummaryQueryInlineQueryResult = Apollo.QueryResult<FinanceSummaryQueryInlineQuery, FinanceSummaryQueryInlineQueryVariables>;
export const FinanceSummaryQueryDocument = gql`
    query financeSummaryQuery {
  financeSummary {
    TotalPrincipal {
      CurrencyCode
      Amount
    }
    TotalRedraw {
      CurrencyCode
      Amount
    }
    Instruments {
      Id
      Number
      Description
      TotalPrincipal
      TotalRedraw
      Status
      IsUnderHardshipAgreement
      InstrumentType
      PrimaryBorrower
      Accounts {
        Id
        Number
        Description
        DisplayOrder
        InstrumentId
        LegacyNumber
        ProductType
        CurrentBalance
        Redraw
        InterestType
        CardAccount
        RemainingDisbursementAmount
      }
    }
  }
}
    `;
export type FinanceSummaryQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables>, 'query'>;

    export const FinanceSummaryQueryComponent = (props: FinanceSummaryQueryComponentProps) => (
      <ApolloReactComponents.Query<FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables> query={FinanceSummaryQueryDocument} {...props} />
    );
    
export type FinanceSummaryQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables>
    } & TChildProps;
export function withFinanceSummaryQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FinanceSummaryQueryQuery,
  FinanceSummaryQueryQueryVariables,
  FinanceSummaryQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables, FinanceSummaryQueryProps<TChildProps, TDataName>>(FinanceSummaryQueryDocument, {
      alias: 'financeSummaryQuery',
      ...operationOptions
    });
};

/**
 * __useFinanceSummaryQueryQuery__
 *
 * To run a query within a React component, call `useFinanceSummaryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceSummaryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinanceSummaryQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinanceSummaryQueryQuery(baseOptions?: Apollo.QueryHookOptions<FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables>(FinanceSummaryQueryDocument, options);
      }
export function useFinanceSummaryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables>(FinanceSummaryQueryDocument, options);
        }
export type FinanceSummaryQueryQueryHookResult = ReturnType<typeof useFinanceSummaryQueryQuery>;
export type FinanceSummaryQueryLazyQueryHookResult = ReturnType<typeof useFinanceSummaryQueryLazyQuery>;
export type FinanceSummaryQueryQueryResult = Apollo.QueryResult<FinanceSummaryQueryQuery, FinanceSummaryQueryQueryVariables>;
export const InstrumentByIdOrNumberDocument = gql`
    query instrumentByIdOrNumber($idOrNumber: String!) {
  instrumentByIdOrNumber(idOrNumber: $idOrNumber) {
    Id
    Number
    LoanPurpose
    Description
    TotalPrincipal
    TotalRedraw
    Status
    IsUnderHardshipAgreement
    InstrumentType
    Term
    TotalTermMonths
    RemainingTermMonths
    MaturityDate
    RedrawConsideration
    PrimaryBorrower
    Accounts {
      Id
      Number
      Description
      DisplayOrder
      InstrumentId
      LegacyNumber
      ProductType
      CurrentBalance
      Redraw
      InterestType
      CardAccount
      RedrawFlag
      OffsetAccount
      CardAvailable
    }
  }
}
    `;
export type InstrumentByIdOrNumberComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables>, 'query'> & ({ variables: InstrumentByIdOrNumberQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InstrumentByIdOrNumberComponent = (props: InstrumentByIdOrNumberComponentProps) => (
      <ApolloReactComponents.Query<InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables> query={InstrumentByIdOrNumberDocument} {...props} />
    );
    
export type InstrumentByIdOrNumberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables>
    } & TChildProps;
export function withInstrumentByIdOrNumber<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InstrumentByIdOrNumberQuery,
  InstrumentByIdOrNumberQueryVariables,
  InstrumentByIdOrNumberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables, InstrumentByIdOrNumberProps<TChildProps, TDataName>>(InstrumentByIdOrNumberDocument, {
      alias: 'instrumentByIdOrNumber',
      ...operationOptions
    });
};

/**
 * __useInstrumentByIdOrNumberQuery__
 *
 * To run a query within a React component, call `useInstrumentByIdOrNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentByIdOrNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentByIdOrNumberQuery({
 *   variables: {
 *      idOrNumber: // value for 'idOrNumber'
 *   },
 * });
 */
export function useInstrumentByIdOrNumberQuery(baseOptions: Apollo.QueryHookOptions<InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables>(InstrumentByIdOrNumberDocument, options);
      }
export function useInstrumentByIdOrNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables>(InstrumentByIdOrNumberDocument, options);
        }
export type InstrumentByIdOrNumberQueryHookResult = ReturnType<typeof useInstrumentByIdOrNumberQuery>;
export type InstrumentByIdOrNumberLazyQueryHookResult = ReturnType<typeof useInstrumentByIdOrNumberLazyQuery>;
export type InstrumentByIdOrNumberQueryResult = Apollo.QueryResult<InstrumentByIdOrNumberQuery, InstrumentByIdOrNumberQueryVariables>;
export const IsShariaDocument = gql`
    query isSharia {
  userSession {
    Id
    IsSharia
  }
}
    `;
export type IsShariaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IsShariaQuery, IsShariaQueryVariables>, 'query'>;

    export const IsShariaComponent = (props: IsShariaComponentProps) => (
      <ApolloReactComponents.Query<IsShariaQuery, IsShariaQueryVariables> query={IsShariaDocument} {...props} />
    );
    
export type IsShariaProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IsShariaQuery, IsShariaQueryVariables>
    } & TChildProps;
export function withIsSharia<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IsShariaQuery,
  IsShariaQueryVariables,
  IsShariaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IsShariaQuery, IsShariaQueryVariables, IsShariaProps<TChildProps, TDataName>>(IsShariaDocument, {
      alias: 'isSharia',
      ...operationOptions
    });
};

/**
 * __useIsShariaQuery__
 *
 * To run a query within a React component, call `useIsShariaQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsShariaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsShariaQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsShariaQuery(baseOptions?: Apollo.QueryHookOptions<IsShariaQuery, IsShariaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsShariaQuery, IsShariaQueryVariables>(IsShariaDocument, options);
      }
export function useIsShariaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsShariaQuery, IsShariaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsShariaQuery, IsShariaQueryVariables>(IsShariaDocument, options);
        }
export type IsShariaQueryHookResult = ReturnType<typeof useIsShariaQuery>;
export type IsShariaLazyQueryHookResult = ReturnType<typeof useIsShariaLazyQuery>;
export type IsShariaQueryResult = Apollo.QueryResult<IsShariaQuery, IsShariaQueryVariables>;
export const MaxLimitsDocument = gql`
    query maxLimits {
  userSession {
    Id
    RedrawLimitMax
    PayAnyoneLimitMax
    BPayLimitMax
  }
}
    `;
export type MaxLimitsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MaxLimitsQuery, MaxLimitsQueryVariables>, 'query'>;

    export const MaxLimitsComponent = (props: MaxLimitsComponentProps) => (
      <ApolloReactComponents.Query<MaxLimitsQuery, MaxLimitsQueryVariables> query={MaxLimitsDocument} {...props} />
    );
    
export type MaxLimitsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MaxLimitsQuery, MaxLimitsQueryVariables>
    } & TChildProps;
export function withMaxLimits<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MaxLimitsQuery,
  MaxLimitsQueryVariables,
  MaxLimitsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MaxLimitsQuery, MaxLimitsQueryVariables, MaxLimitsProps<TChildProps, TDataName>>(MaxLimitsDocument, {
      alias: 'maxLimits',
      ...operationOptions
    });
};

/**
 * __useMaxLimitsQuery__
 *
 * To run a query within a React component, call `useMaxLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaxLimitsQuery(baseOptions?: Apollo.QueryHookOptions<MaxLimitsQuery, MaxLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaxLimitsQuery, MaxLimitsQueryVariables>(MaxLimitsDocument, options);
      }
export function useMaxLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxLimitsQuery, MaxLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaxLimitsQuery, MaxLimitsQueryVariables>(MaxLimitsDocument, options);
        }
export type MaxLimitsQueryHookResult = ReturnType<typeof useMaxLimitsQuery>;
export type MaxLimitsLazyQueryHookResult = ReturnType<typeof useMaxLimitsLazyQuery>;
export type MaxLimitsQueryResult = Apollo.QueryResult<MaxLimitsQuery, MaxLimitsQueryVariables>;
export const PartyLimitDocument = gql`
    query partyLimit {
  partyLimits {
    DailyRedrawLimit {
      CurrencyCode
      Amount
    }
    DefaultRedrawLimit {
      CurrencyCode
      Amount
    }
    RemainingDailyRedrawLimit {
      CurrencyCode
      Amount
    }
    DailyPayAnyoneLimit {
      CurrencyCode
      Amount
    }
    DefaultPayAnyoneLimit {
      CurrencyCode
      Amount
    }
    RemainingDailyPayAnyoneLimit {
      CurrencyCode
      Amount
    }
    DailyBPayLimit {
      CurrencyCode
      Amount
    }
    DefaultBPayLimit {
      CurrencyCode
      Amount
    }
    RemainingDailyBPayLimit {
      CurrencyCode
      Amount
    }
    LimitEffectiveTo
  }
}
    `;
export type PartyLimitComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PartyLimitQuery, PartyLimitQueryVariables>, 'query'>;

    export const PartyLimitComponent = (props: PartyLimitComponentProps) => (
      <ApolloReactComponents.Query<PartyLimitQuery, PartyLimitQueryVariables> query={PartyLimitDocument} {...props} />
    );
    
export type PartyLimitProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PartyLimitQuery, PartyLimitQueryVariables>
    } & TChildProps;
export function withPartyLimit<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PartyLimitQuery,
  PartyLimitQueryVariables,
  PartyLimitProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PartyLimitQuery, PartyLimitQueryVariables, PartyLimitProps<TChildProps, TDataName>>(PartyLimitDocument, {
      alias: 'partyLimit',
      ...operationOptions
    });
};

/**
 * __usePartyLimitQuery__
 *
 * To run a query within a React component, call `usePartyLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartyLimitQuery(baseOptions?: Apollo.QueryHookOptions<PartyLimitQuery, PartyLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartyLimitQuery, PartyLimitQueryVariables>(PartyLimitDocument, options);
      }
export function usePartyLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartyLimitQuery, PartyLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartyLimitQuery, PartyLimitQueryVariables>(PartyLimitDocument, options);
        }
export type PartyLimitQueryHookResult = ReturnType<typeof usePartyLimitQuery>;
export type PartyLimitLazyQueryHookResult = ReturnType<typeof usePartyLimitLazyQuery>;
export type PartyLimitQueryResult = Apollo.QueryResult<PartyLimitQuery, PartyLimitQueryVariables>;
export const SecureMessageTypesDocument = gql`
    query secureMessageTypes {
  secureMessageTypes {
    Id
    IsAccount
    IsSystem
    Name
    Description
    DisplayOrder
  }
}
    `;
export type SecureMessageTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SecureMessageTypesQuery, SecureMessageTypesQueryVariables>, 'query'>;

    export const SecureMessageTypesComponent = (props: SecureMessageTypesComponentProps) => (
      <ApolloReactComponents.Query<SecureMessageTypesQuery, SecureMessageTypesQueryVariables> query={SecureMessageTypesDocument} {...props} />
    );
    
export type SecureMessageTypesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SecureMessageTypesQuery, SecureMessageTypesQueryVariables>
    } & TChildProps;
export function withSecureMessageTypes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SecureMessageTypesQuery,
  SecureMessageTypesQueryVariables,
  SecureMessageTypesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SecureMessageTypesQuery, SecureMessageTypesQueryVariables, SecureMessageTypesProps<TChildProps, TDataName>>(SecureMessageTypesDocument, {
      alias: 'secureMessageTypes',
      ...operationOptions
    });
};

/**
 * __useSecureMessageTypesQuery__
 *
 * To run a query within a React component, call `useSecureMessageTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureMessageTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureMessageTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSecureMessageTypesQuery(baseOptions?: Apollo.QueryHookOptions<SecureMessageTypesQuery, SecureMessageTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SecureMessageTypesQuery, SecureMessageTypesQueryVariables>(SecureMessageTypesDocument, options);
      }
export function useSecureMessageTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SecureMessageTypesQuery, SecureMessageTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SecureMessageTypesQuery, SecureMessageTypesQueryVariables>(SecureMessageTypesDocument, options);
        }
export type SecureMessageTypesQueryHookResult = ReturnType<typeof useSecureMessageTypesQuery>;
export type SecureMessageTypesLazyQueryHookResult = ReturnType<typeof useSecureMessageTypesLazyQuery>;
export type SecureMessageTypesQueryResult = Apollo.QueryResult<SecureMessageTypesQuery, SecureMessageTypesQueryVariables>;
export const StatementsByPartyIdDocument = gql`
    query statementsByPartyId {
  statementsByPartyId {
    Id
    AccountId
    AccountNumber
    AdHoc
    CreatedOn
    InstrumentId
    Number
    PeriodFrom
    PeriodTo
    Filename
    FileId
  }
}
    `;
export type StatementsByPartyIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables>, 'query'>;

    export const StatementsByPartyIdComponent = (props: StatementsByPartyIdComponentProps) => (
      <ApolloReactComponents.Query<StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables> query={StatementsByPartyIdDocument} {...props} />
    );
    
export type StatementsByPartyIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables>
    } & TChildProps;
export function withStatementsByPartyId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StatementsByPartyIdQuery,
  StatementsByPartyIdQueryVariables,
  StatementsByPartyIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables, StatementsByPartyIdProps<TChildProps, TDataName>>(StatementsByPartyIdDocument, {
      alias: 'statementsByPartyId',
      ...operationOptions
    });
};

/**
 * __useStatementsByPartyIdQuery__
 *
 * To run a query within a React component, call `useStatementsByPartyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatementsByPartyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatementsByPartyIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatementsByPartyIdQuery(baseOptions?: Apollo.QueryHookOptions<StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables>(StatementsByPartyIdDocument, options);
      }
export function useStatementsByPartyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables>(StatementsByPartyIdDocument, options);
        }
export type StatementsByPartyIdQueryHookResult = ReturnType<typeof useStatementsByPartyIdQuery>;
export type StatementsByPartyIdLazyQueryHookResult = ReturnType<typeof useStatementsByPartyIdLazyQuery>;
export type StatementsByPartyIdQueryResult = Apollo.QueryResult<StatementsByPartyIdQuery, StatementsByPartyIdQueryVariables>;
export const ToDoItemTypesDocument = gql`
    query toDoItemTypes($input: ToDoItemTypesInput!) {
  toDoItemTypes(input: $input) {
    Id
    Description
    SecureMessageType {
      Id
      IsAccount
      IsSystem
      Description
      DisplayOrder
      Name
    }
  }
}
    `;
export type ToDoItemTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ToDoItemTypesQuery, ToDoItemTypesQueryVariables>, 'query'> & ({ variables: ToDoItemTypesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ToDoItemTypesComponent = (props: ToDoItemTypesComponentProps) => (
      <ApolloReactComponents.Query<ToDoItemTypesQuery, ToDoItemTypesQueryVariables> query={ToDoItemTypesDocument} {...props} />
    );
    
export type ToDoItemTypesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ToDoItemTypesQuery, ToDoItemTypesQueryVariables>
    } & TChildProps;
export function withToDoItemTypes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ToDoItemTypesQuery,
  ToDoItemTypesQueryVariables,
  ToDoItemTypesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ToDoItemTypesQuery, ToDoItemTypesQueryVariables, ToDoItemTypesProps<TChildProps, TDataName>>(ToDoItemTypesDocument, {
      alias: 'toDoItemTypes',
      ...operationOptions
    });
};

/**
 * __useToDoItemTypesQuery__
 *
 * To run a query within a React component, call `useToDoItemTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useToDoItemTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToDoItemTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToDoItemTypesQuery(baseOptions: Apollo.QueryHookOptions<ToDoItemTypesQuery, ToDoItemTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToDoItemTypesQuery, ToDoItemTypesQueryVariables>(ToDoItemTypesDocument, options);
      }
export function useToDoItemTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToDoItemTypesQuery, ToDoItemTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToDoItemTypesQuery, ToDoItemTypesQueryVariables>(ToDoItemTypesDocument, options);
        }
export type ToDoItemTypesQueryHookResult = ReturnType<typeof useToDoItemTypesQuery>;
export type ToDoItemTypesLazyQueryHookResult = ReturnType<typeof useToDoItemTypesLazyQuery>;
export type ToDoItemTypesQueryResult = Apollo.QueryResult<ToDoItemTypesQuery, ToDoItemTypesQueryVariables>;
export const TransferAccountsByPartyDocument = gql`
    query transferAccountsByParty {
  transferAccountsByParty {
    AccountId
    AccountCategory
    AccountName
    AccountNumber
    BSB
    BillerCode
    RedrawBalance
    IsBankAccount
    IsExternal
    IsBPay
    InstrumentId
    AllowRead
    AllowOperate
    AllowInterAccount
    AllowDirectDebit
    AllowBPay
    AllowRedraw
    AllowPayAnyone
    CapitalAccountNumber
    IsDirectDebit
    IsDirectCredit
    FunderAllowsNPP
    AccountIsValidForNPP
    MinimumDirectDebitDate
  }
}
    `;
export type TransferAccountsByPartyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables>, 'query'>;

    export const TransferAccountsByPartyComponent = (props: TransferAccountsByPartyComponentProps) => (
      <ApolloReactComponents.Query<TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables> query={TransferAccountsByPartyDocument} {...props} />
    );
    
export type TransferAccountsByPartyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables>
    } & TChildProps;
export function withTransferAccountsByParty<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TransferAccountsByPartyQuery,
  TransferAccountsByPartyQueryVariables,
  TransferAccountsByPartyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables, TransferAccountsByPartyProps<TChildProps, TDataName>>(TransferAccountsByPartyDocument, {
      alias: 'transferAccountsByParty',
      ...operationOptions
    });
};

/**
 * __useTransferAccountsByPartyQuery__
 *
 * To run a query within a React component, call `useTransferAccountsByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferAccountsByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferAccountsByPartyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransferAccountsByPartyQuery(baseOptions?: Apollo.QueryHookOptions<TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables>(TransferAccountsByPartyDocument, options);
      }
export function useTransferAccountsByPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables>(TransferAccountsByPartyDocument, options);
        }
export type TransferAccountsByPartyQueryHookResult = ReturnType<typeof useTransferAccountsByPartyQuery>;
export type TransferAccountsByPartyLazyQueryHookResult = ReturnType<typeof useTransferAccountsByPartyLazyQuery>;
export type TransferAccountsByPartyQueryResult = Apollo.QueryResult<TransferAccountsByPartyQuery, TransferAccountsByPartyQueryVariables>;
export const DismissNotificationDocument = gql`
    mutation dismissNotification($notificationId: ID!) @client {
  dismissNotification(NotificationId: $notificationId) @client {
    Code
    Success
    Message
    Data {
      Id
      Account {
        InstrumentId
        Number
        Id
      }
      ConversionType
      ConversionDate
      NewInstalmentAmount {
        CurrencyCode
        Amount
      }
      NewInstalmentFrequency
      Dismissed @client
    }
  }
}
    `;
export type DismissNotificationMutationFn = Apollo.MutationFunction<DismissNotificationMutation, DismissNotificationMutationVariables>;
export type DismissNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DismissNotificationMutation, DismissNotificationMutationVariables>, 'mutation'>;

    export const DismissNotificationComponent = (props: DismissNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<DismissNotificationMutation, DismissNotificationMutationVariables> mutation={DismissNotificationDocument} {...props} />
    );
    
export type DismissNotificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DismissNotificationMutation, DismissNotificationMutationVariables>
    } & TChildProps;
export function withDismissNotification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DismissNotificationMutation,
  DismissNotificationMutationVariables,
  DismissNotificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DismissNotificationMutation, DismissNotificationMutationVariables, DismissNotificationProps<TChildProps, TDataName>>(DismissNotificationDocument, {
      alias: 'dismissNotification',
      ...operationOptions
    });
};

/**
 * __useDismissNotificationMutation__
 *
 * To run a mutation, you first call `useDismissNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissNotificationMutation, { data, loading, error }] = useDismissNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useDismissNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DismissNotificationMutation, DismissNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissNotificationMutation, DismissNotificationMutationVariables>(DismissNotificationDocument, options);
      }
export type DismissNotificationMutationHookResult = ReturnType<typeof useDismissNotificationMutation>;
export type DismissNotificationMutationResult = Apollo.MutationResult<DismissNotificationMutation>;
export type DismissNotificationMutationOptions = Apollo.BaseMutationOptions<DismissNotificationMutation, DismissNotificationMutationVariables>;